/* This file is auto-generated with figma-svg. */
import hoc from '@hh.ru/magritte-ui-icon/hoc';
import { AdjustmentsFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/AdjustmentsFilledSize16';
import { AdjustmentsFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/AdjustmentsFilledSize24';
import { AdjustmentsOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/AdjustmentsOutlinedSize16';
import { AdjustmentsOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/AdjustmentsOutlinedSize24';
import { AntennaFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/AntennaFilledSize16';
import { AntennaFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/AntennaFilledSize24';
import { AntennaOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/AntennaOutlinedSize16';
import { AntennaOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/AntennaOutlinedSize24';
import { ArchiveboxArrowFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArchiveboxArrowFilledSize16';
import { ArchiveboxArrowFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArchiveboxArrowFilledSize24';
import { ArchiveboxArrowOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArchiveboxArrowOutlinedSize16';
import { ArchiveboxArrowOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArchiveboxArrowOutlinedSize24';
import { ArchiveboxFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArchiveboxFilledSize16';
import { ArchiveboxFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArchiveboxFilledSize24';
import { ArchiveboxOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArchiveboxOutlinedSize16';
import { ArchiveboxOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArchiveboxOutlinedSize24';
import { ArrowDiagonalLeftDownOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowDiagonalLeftDownOutlinedSize16';
import { ArrowDiagonalLeftDownOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowDiagonalLeftDownOutlinedSize24';
import { ArrowDiagonalLeftUpOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowDiagonalLeftUpOutlinedSize16';
import { ArrowDiagonalLeftUpOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowDiagonalLeftUpOutlinedSize24';
import { ArrowDiagonalRightDownOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowDiagonalRightDownOutlinedSize16';
import { ArrowDiagonalRightDownOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowDiagonalRightDownOutlinedSize24';
import { ArrowDiagonalRightUpOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowDiagonalRightUpOutlinedSize16';
import { ArrowDiagonalRightUpOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowDiagonalRightUpOutlinedSize24';
import { ArrowDownLineOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowDownLineOutlinedSize16';
import { ArrowDownLineOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowDownLineOutlinedSize24';
import { ArrowDownOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowDownOutlinedSize16';
import { ArrowDownOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowDownOutlinedSize24';
import { ArrowDownRightOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowDownRightOutlinedSize16';
import { ArrowDownRightOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowDownRightOutlinedSize24';
import { ArrowLeftOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowLeftOutlinedSize16';
import { ArrowLeftOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowLeftOutlinedSize24';
import { ArrowLeftRightOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowLeftRightOutlinedSize16';
import { ArrowLeftRightOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowLeftRightOutlinedSize24';
import { ArrowPathClockwiseOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowPathClockwiseOutlinedSize16';
import { ArrowPathClockwiseOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowPathClockwiseOutlinedSize24';
import { ArrowPathOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowPathOutlinedSize16';
import { ArrowPathOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowPathOutlinedSize24';
import { ArrowRightOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowRightOutlinedSize16';
import { ArrowRightOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowRightOutlinedSize24';
import { ArrowSquareOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowSquareOutlinedSize16';
import { ArrowSquareOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowSquareOutlinedSize24';
import { ArrowUpDownOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowUpDownOutlinedSize16';
import { ArrowUpDownOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowUpDownOutlinedSize24';
import { ArrowUpOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowUpOutlinedSize16';
import { ArrowUpOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowUpOutlinedSize24';
import { ArrowUpOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowUpOutlinedSize32';
import { ArrowsCrossOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowsCrossOutlinedSize16';
import { ArrowsCrossOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowsCrossOutlinedSize24';
import { ArrowsDiagonalInOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowsDiagonalInOutlinedSize16';
import { ArrowsDiagonalInOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowsDiagonalInOutlinedSize24';
import { ArrowsDiagonalOutOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowsDiagonalOutOutlinedSize16';
import { ArrowsDiagonalOutOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ArrowsDiagonalOutOutlinedSize24';
import { AstrostarFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/AstrostarFilledSize16';
import { AstrostarFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/AstrostarFilledSize24';
import { AstrostarOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/AstrostarOutlinedSize16';
import { AstrostarOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/AstrostarOutlinedSize24';
import { BackwardFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BackwardFilledSize16';
import { BackwardFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BackwardFilledSize24';
import { BackwardOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BackwardOutlinedSize16';
import { BackwardOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BackwardOutlinedSize24';
import { BagFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BagFilledSize16';
import { BagFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BagFilledSize24';
import { BagOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BagOutlinedSize16';
import { BagOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BagOutlinedSize24';
import { BagPlusFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BagPlusFilledSize16';
import { BagPlusFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BagPlusFilledSize24';
import { BagPlusOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BagPlusOutlinedSize16';
import { BagPlusOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BagPlusOutlinedSize24';
import { BanFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BanFilledSize16';
import { BanFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BanFilledSize24';
import { BanOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BanOutlinedSize16';
import { BanOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BanOutlinedSize24';
import { BankFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BankFilledSize16';
import { BankFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BankFilledSize24';
import { BankOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BankOutlinedSize16';
import { BankOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BankOutlinedSize24';
import { BarsOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BarsOutlinedSize16';
import { BarsOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BarsOutlinedSize24';
import { BellCrossedFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BellCrossedFilledSize16';
import { BellCrossedFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BellCrossedFilledSize24';
import { BellCrossedOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BellCrossedOutlinedSize16';
import { BellCrossedOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BellCrossedOutlinedSize24';
import { BellFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BellFilledSize16';
import { BellFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BellFilledSize24';
import { BellOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BellOutlinedSize16';
import { BellOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BellOutlinedSize24';
import { BicycleOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BicycleOutlinedSize16';
import { BicycleOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BicycleOutlinedSize24';
import { BoltFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BoltFilledSize16';
import { BoltFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BoltFilledSize24';
import { BoltOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BoltOutlinedSize16';
import { BoltOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BoltOutlinedSize24';
import { BookFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BookFilledSize16';
import { BookFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BookFilledSize24';
import { BookOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BookOutlinedSize16';
import { BookOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BookOutlinedSize24';
import { BotFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BotFilledSize16';
import { BotFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BotFilledSize24';
import { BotOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BotOutlinedSize16';
import { BotOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BotOutlinedSize24';
import { BottleFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BottleFilledSize16';
import { BottleFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BottleFilledSize24';
import { BottleOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BottleOutlinedSize16';
import { BottleOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BottleOutlinedSize24';
import { BoxFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BoxFilledSize16';
import { BoxFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BoxFilledSize24';
import { BoxOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BoxOutlinedSize16';
import { BoxOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BoxOutlinedSize24';
import { BracketsOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BracketsOutlinedSize16';
import { BracketsOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BracketsOutlinedSize24';
import { BricksFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BricksFilledSize16';
import { BricksFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BricksFilledSize24';
import { BricksOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BricksOutlinedSize16';
import { BricksOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BricksOutlinedSize24';
import { BriefcaseFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BriefcaseFilledSize16';
import { BriefcaseFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BriefcaseFilledSize24';
import { BriefcaseOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BriefcaseOutlinedSize16';
import { BriefcaseOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BriefcaseOutlinedSize24';
import { BubbleDotRoundFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BubbleDotRoundFilledSize16';
import { BubbleDotRoundFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BubbleDotRoundFilledSize24';
import { BubbleDotRoundOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BubbleDotRoundOutlinedSize16';
import { BubbleDotRoundOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BubbleDotRoundOutlinedSize24';
import { BubbleRoundDoubleFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BubbleRoundDoubleFilledSize16';
import { BubbleRoundDoubleFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BubbleRoundDoubleFilledSize24';
import { BubbleRoundDoubleOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BubbleRoundDoubleOutlinedSize16';
import { BubbleRoundDoubleOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BubbleRoundDoubleOutlinedSize24';
import { BubbleRoundFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BubbleRoundFilledSize16';
import { BubbleRoundFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BubbleRoundFilledSize24';
import { BubbleRoundHyperstarFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BubbleRoundHyperstarFilledSize16';
import { BubbleRoundHyperstarFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BubbleRoundHyperstarFilledSize24';
import { BubbleRoundHyperstarOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BubbleRoundHyperstarOutlinedSize16';
import { BubbleRoundHyperstarOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BubbleRoundHyperstarOutlinedSize24';
import { BubbleRoundOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BubbleRoundOutlinedSize16';
import { BubbleRoundOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BubbleRoundOutlinedSize24';
import { BubbleSquareFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BubbleSquareFilledSize16';
import { BubbleSquareFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BubbleSquareFilledSize24';
import { BubbleSquareOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BubbleSquareOutlinedSize16';
import { BubbleSquareOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BubbleSquareOutlinedSize24';
import { BuildingFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BuildingFilledSize16';
import { BuildingFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BuildingFilledSize24';
import { BuildingOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BuildingOutlinedSize16';
import { BuildingOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BuildingOutlinedSize24';
import { BulletFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BulletFilledSize16';
import { BulletFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BulletFilledSize24';
import { BulletOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BulletOutlinedSize16';
import { BulletOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BulletOutlinedSize24';
import { BusFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BusFilledSize16';
import { BusFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BusFilledSize24';
import { BusOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BusOutlinedSize16';
import { BusOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BusOutlinedSize24';
import { BusTaxiFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BusTaxiFilledSize16';
import { BusTaxiFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BusTaxiFilledSize24';
import { BusTaxiOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BusTaxiOutlinedSize16';
import { BusTaxiOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/BusTaxiOutlinedSize24';
import { CalendarFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CalendarFilledSize16';
import { CalendarFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CalendarFilledSize24';
import { CalendarOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CalendarOutlinedSize16';
import { CalendarOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CalendarOutlinedSize24';
import { CameraFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CameraFilledSize16';
import { CameraFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CameraFilledSize24';
import { CameraOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CameraOutlinedSize16';
import { CameraOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CameraOutlinedSize24';
import { CarDoorFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CarDoorFilledSize16';
import { CarDoorFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CarDoorFilledSize24';
import { CarDoorOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CarDoorOutlinedSize16';
import { CarDoorOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CarDoorOutlinedSize24';
import { CarFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CarFilledSize16';
import { CarFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CarFilledSize24';
import { CarOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CarOutlinedSize16';
import { CarOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CarOutlinedSize24';
import { CardLinesCrossFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesCrossFilledSize16';
import { CardLinesCrossFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesCrossFilledSize24';
import { CardLinesCrossOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesCrossOutlinedSize16';
import { CardLinesCrossOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesCrossOutlinedSize24';
import { CardLinesCrossedFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesCrossedFilledSize16';
import { CardLinesCrossedFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesCrossedFilledSize24';
import { CardLinesCrossedOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesCrossedOutlinedSize16';
import { CardLinesCrossedOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesCrossedOutlinedSize24';
import { CardLinesEyeFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesEyeFilledSize16';
import { CardLinesEyeFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesEyeFilledSize24';
import { CardLinesEyeOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesEyeOutlinedSize16';
import { CardLinesEyeOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesEyeOutlinedSize24';
import { CardLinesFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesFilledSize16';
import { CardLinesFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesFilledSize24';
import { CardLinesHeartFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesHeartFilledSize16';
import { CardLinesHeartFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesHeartFilledSize24';
import { CardLinesHeartOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesHeartOutlinedSize16';
import { CardLinesHeartOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesHeartOutlinedSize24';
import { CardLinesOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesOutlinedSize16';
import { CardLinesOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesOutlinedSize24';
import { CardLinesPlusFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesPlusFilledSize16';
import { CardLinesPlusFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesPlusFilledSize24';
import { CardLinesPlusOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesPlusOutlinedSize16';
import { CardLinesPlusOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesPlusOutlinedSize24';
import { CardLinesStackedCrossFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesStackedCrossFilledSize16';
import { CardLinesStackedCrossFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesStackedCrossFilledSize24';
import { CardLinesStackedCrossOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesStackedCrossOutlinedSize16';
import { CardLinesStackedCrossOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesStackedCrossOutlinedSize24';
import { CardLinesStackedCrossedFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesStackedCrossedFilledSize16';
import { CardLinesStackedCrossedFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesStackedCrossedFilledSize24';
import { CardLinesStackedCrossedOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesStackedCrossedOutlinedSize16';
import { CardLinesStackedCrossedOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesStackedCrossedOutlinedSize24';
import { CardLinesStackedFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesStackedFilledSize16';
import { CardLinesStackedFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesStackedFilledSize24';
import { CardLinesStackedOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesStackedOutlinedSize16';
import { CardLinesStackedOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesStackedOutlinedSize24';
import { CardLinesStackedPlusFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesStackedPlusFilledSize16';
import { CardLinesStackedPlusFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesStackedPlusFilledSize24';
import { CardLinesStackedPlusOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesStackedPlusOutlinedSize16';
import { CardLinesStackedPlusOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CardLinesStackedPlusOutlinedSize24';
import { CartFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CartFilledSize16';
import { CartFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CartFilledSize24';
import { CartOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CartOutlinedSize16';
import { CartOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CartOutlinedSize24';
import { ChartBarFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChartBarFilledSize16';
import { ChartBarFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChartBarFilledSize24';
import { ChartBarOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChartBarOutlinedSize16';
import { ChartBarOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChartBarOutlinedSize24';
import { ChartLineFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChartLineFilledSize16';
import { ChartLineFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChartLineFilledSize24';
import { ChartLineFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChartLineFilledSize32';
import { ChartLineOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChartLineOutlinedSize16';
import { ChartLineOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChartLineOutlinedSize24';
import { ChartLineOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChartLineOutlinedSize32';
import { CheckCircleFilledSize12Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CheckCircleFilledSize12';
import { CheckCircleFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CheckCircleFilledSize16';
import { CheckCircleFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CheckCircleFilledSize24';
import { CheckCircleOutlinedSize12Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CheckCircleOutlinedSize12';
import { CheckCircleOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CheckCircleOutlinedSize16';
import { CheckCircleOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CheckCircleOutlinedSize24';
import { CheckDoubleOutlinedSize12Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CheckDoubleOutlinedSize12';
import { CheckDoubleOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CheckDoubleOutlinedSize16';
import { CheckDoubleOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CheckDoubleOutlinedSize24';
import { CheckOutlinedSize12Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CheckOutlinedSize12';
import { CheckOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CheckOutlinedSize16';
import { CheckOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CheckOutlinedSize24';
import { ChevronDownOutlinedSize12Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChevronDownOutlinedSize12';
import { ChevronDownOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChevronDownOutlinedSize16';
import { ChevronDownOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChevronDownOutlinedSize24';
import { ChevronLeftOutlinedSize12Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChevronLeftOutlinedSize12';
import { ChevronLeftOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChevronLeftOutlinedSize16';
import { ChevronLeftOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChevronLeftOutlinedSize24';
import { ChevronLeftSquareFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChevronLeftSquareFilledSize16';
import { ChevronLeftSquareFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChevronLeftSquareFilledSize24';
import { ChevronLeftSquareOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChevronLeftSquareOutlinedSize16';
import { ChevronLeftSquareOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChevronLeftSquareOutlinedSize24';
import { ChevronRightOutlinedSize12Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChevronRightOutlinedSize12';
import { ChevronRightOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChevronRightOutlinedSize16';
import { ChevronRightOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChevronRightOutlinedSize24';
import { ChevronRightSquareFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChevronRightSquareFilledSize16';
import { ChevronRightSquareFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChevronRightSquareFilledSize24';
import { ChevronRightSquareOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChevronRightSquareOutlinedSize16';
import { ChevronRightSquareOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChevronRightSquareOutlinedSize24';
import { ChevronUpDownOutlinedSize12Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChevronUpDownOutlinedSize12';
import { ChevronUpDownOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChevronUpDownOutlinedSize16';
import { ChevronUpDownOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChevronUpDownOutlinedSize24';
import { ChevronUpOutlinedSize12Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChevronUpOutlinedSize12';
import { ChevronUpOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChevronUpOutlinedSize16';
import { ChevronUpOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChevronUpOutlinedSize24';
import { ChevronWide2OutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChevronWide2OutlinedSize16';
import { ChevronWide2OutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChevronWide2OutlinedSize24';
import { ChevronWide3OutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChevronWide3OutlinedSize16';
import { ChevronWide3OutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChevronWide3OutlinedSize24';
import { ChevronWideOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChevronWideOutlinedSize16';
import { ChevronWideOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ChevronWideOutlinedSize24';
import { CircleFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CircleFilledSize16';
import { CircleFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CircleFilledSize24';
import { CircleOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CircleOutlinedSize16';
import { CircleOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CircleOutlinedSize24';
import { ClipOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ClipOutlinedSize16';
import { ClipOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ClipOutlinedSize24';
import { ClocheFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ClocheFilledSize16';
import { ClocheFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ClocheFilledSize24';
import { ClocheOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ClocheOutlinedSize16';
import { ClocheOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ClocheOutlinedSize24';
import { ClockFilledSize12Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ClockFilledSize12';
import { ClockFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ClockFilledSize16';
import { ClockFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ClockFilledSize24';
import { ClockFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ClockFilledSize32';
import { ClockOutlinedSize12Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ClockOutlinedSize12';
import { ClockOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ClockOutlinedSize16';
import { ClockOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ClockOutlinedSize24';
import { ClockOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ClockOutlinedSize32';
import { ClockRewindOutlinedSize12Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ClockRewindOutlinedSize12';
import { ClockRewindOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ClockRewindOutlinedSize16';
import { ClockRewindOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ClockRewindOutlinedSize24';
import { CloudFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CloudFilledSize16';
import { CloudFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CloudFilledSize24';
import { CloudOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CloudOutlinedSize16';
import { CloudOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CloudOutlinedSize24';
import { ComputerOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ComputerOutlinedSize16';
import { ComputerOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ComputerOutlinedSize24';
import { ConstructionHatFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ConstructionHatFilledSize16';
import { ConstructionHatFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ConstructionHatFilledSize24';
import { ConstructionHatOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ConstructionHatOutlinedSize16';
import { ConstructionHatOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ConstructionHatOutlinedSize24';
import { CopyFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CopyFilledSize16';
import { CopyFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CopyFilledSize24';
import { CopyOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CopyOutlinedSize16';
import { CopyOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CopyOutlinedSize24';
import { CraneFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CraneFilledSize16';
import { CraneFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CraneFilledSize24';
import { CraneOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CraneOutlinedSize16';
import { CraneOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CraneOutlinedSize24';
import { CrossCircleFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CrossCircleFilledSize16';
import { CrossCircleFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CrossCircleFilledSize24';
import { CrossCircleOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CrossCircleOutlinedSize16';
import { CrossCircleOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CrossCircleOutlinedSize24';
import { CrossOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CrossOutlinedSize16';
import { CrossOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CrossOutlinedSize24';
import { CubeFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CubeFilledSize16';
import { CubeFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CubeFilledSize24';
import { CubeOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CubeOutlinedSize16';
import { CubeOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/CubeOutlinedSize24';
import { DashedSquareInOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DashedSquareInOutlinedSize16';
import { DashedSquareInOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DashedSquareInOutlinedSize24';
import { DashedSquareOutOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DashedSquareOutOutlinedSize16';
import { DashedSquareOutOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DashedSquareOutOutlinedSize24';
import { DataflowFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DataflowFilledSize16';
import { DataflowFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DataflowFilledSize24';
import { DataflowOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DataflowOutlinedSize16';
import { DataflowOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DataflowOutlinedSize24';
import { DocumentArrowUpFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DocumentArrowUpFilledSize16';
import { DocumentArrowUpFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DocumentArrowUpFilledSize24';
import { DocumentArrowUpFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DocumentArrowUpFilledSize32';
import { DocumentArrowUpOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DocumentArrowUpOutlinedSize16';
import { DocumentArrowUpOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DocumentArrowUpOutlinedSize24';
import { DocumentArrowUpOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DocumentArrowUpOutlinedSize32';
import { DocumentFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DocumentFilledSize16';
import { DocumentFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DocumentFilledSize24';
import { DocumentFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DocumentFilledSize32';
import { DocumentOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DocumentOutlinedSize16';
import { DocumentOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DocumentOutlinedSize24';
import { DocumentOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DocumentOutlinedSize32';
import { DocumentStarFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DocumentStarFilledSize16';
import { DocumentStarFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DocumentStarFilledSize24';
import { DocumentStarFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DocumentStarFilledSize32';
import { DocumentStarOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DocumentStarOutlinedSize16';
import { DocumentStarOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DocumentStarOutlinedSize24';
import { DocumentStarOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DocumentStarOutlinedSize32';
import { DocumentVerifiedFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DocumentVerifiedFilledSize16';
import { DocumentVerifiedFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DocumentVerifiedFilledSize24';
import { DocumentVerifiedFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DocumentVerifiedFilledSize32';
import { DocumentVerifiedOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DocumentVerifiedOutlinedSize16';
import { DocumentVerifiedOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DocumentVerifiedOutlinedSize24';
import { DocumentVerifiedOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DocumentVerifiedOutlinedSize32';
import { DotFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DotFilledSize16';
import { DotFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DotFilledSize24';
import { DotsOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DotsOutlinedSize16';
import { DotsOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DotsOutlinedSize24';
import { DrawerFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DrawerFilledSize16';
import { DrawerFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DrawerFilledSize24';
import { DrawerOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DrawerOutlinedSize16';
import { DrawerOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DrawerOutlinedSize24';
import { DropsFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DropsFilledSize16';
import { DropsFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DropsFilledSize24';
import { DropsOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DropsOutlinedSize16';
import { DropsOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/DropsOutlinedSize24';
import { EllipsisHorizontalCircleFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EllipsisHorizontalCircleFilledSize16';
import { EllipsisHorizontalCircleFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EllipsisHorizontalCircleFilledSize24';
import { EllipsisHorizontalCircleOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EllipsisHorizontalCircleOutlinedSize16';
import { EllipsisHorizontalCircleOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EllipsisHorizontalCircleOutlinedSize24';
import { EllipsisHorizontalOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EllipsisHorizontalOutlinedSize16';
import { EllipsisHorizontalOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EllipsisHorizontalOutlinedSize24';
import { EllipsisVerticalOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EllipsisVerticalOutlinedSize16';
import { EllipsisVerticalOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EllipsisVerticalOutlinedSize24';
import { EmojiHalfsad3dSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiHalfsad3dSize16';
import { EmojiHalfsad3dSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiHalfsad3dSize24';
import { EmojiHalfsad3dSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiHalfsad3dSize32';
import { EmojiHalfsadFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiHalfsadFilledSize16';
import { EmojiHalfsadFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiHalfsadFilledSize24';
import { EmojiHalfsadFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiHalfsadFilledSize32';
import { EmojiHalfsadOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiHalfsadOutlinedSize16';
import { EmojiHalfsadOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiHalfsadOutlinedSize24';
import { EmojiHalfsadOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiHalfsadOutlinedSize32';
import { EmojiHalfsmile3dSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiHalfsmile3dSize16';
import { EmojiHalfsmile3dSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiHalfsmile3dSize24';
import { EmojiHalfsmile3dSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiHalfsmile3dSize32';
import { EmojiHalfsmileFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiHalfsmileFilledSize16';
import { EmojiHalfsmileFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiHalfsmileFilledSize24';
import { EmojiHalfsmileFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiHalfsmileFilledSize32';
import { EmojiHalfsmileOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiHalfsmileOutlinedSize16';
import { EmojiHalfsmileOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiHalfsmileOutlinedSize24';
import { EmojiHalfsmileOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiHalfsmileOutlinedSize32';
import { EmojiNeutral3dSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiNeutral3dSize16';
import { EmojiNeutral3dSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiNeutral3dSize24';
import { EmojiNeutral3dSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiNeutral3dSize32';
import { EmojiNeutralFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiNeutralFilledSize16';
import { EmojiNeutralFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiNeutralFilledSize24';
import { EmojiNeutralFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiNeutralFilledSize32';
import { EmojiNeutralOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiNeutralOutlinedSize16';
import { EmojiNeutralOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiNeutralOutlinedSize24';
import { EmojiNeutralOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiNeutralOutlinedSize32';
import { EmojiSad3dSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiSad3dSize16';
import { EmojiSad3dSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiSad3dSize24';
import { EmojiSad3dSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiSad3dSize32';
import { EmojiSadFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiSadFilledSize16';
import { EmojiSadFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiSadFilledSize24';
import { EmojiSadFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiSadFilledSize32';
import { EmojiSadOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiSadOutlinedSize16';
import { EmojiSadOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiSadOutlinedSize24';
import { EmojiSadOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiSadOutlinedSize32';
import { EmojiSmile3dSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiSmile3dSize16';
import { EmojiSmile3dSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiSmile3dSize24';
import { EmojiSmile3dSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiSmile3dSize32';
import { EmojiSmileFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiSmileFilledSize16';
import { EmojiSmileFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiSmileFilledSize24';
import { EmojiSmileFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiSmileFilledSize32';
import { EmojiSmileOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiSmileOutlinedSize16';
import { EmojiSmileOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiSmileOutlinedSize24';
import { EmojiSmileOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmojiSmileOutlinedSize32';
import { EmptySize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmptySize16';
import { EmptySize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmptySize24';
import { EmptySize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmptySize32';
import { EmptySize48Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmptySize48';
import { EmptySize64Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmptySize64';
import { EmptySize96Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EmptySize96';
import { EnvelopeFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EnvelopeFilledSize16';
import { EnvelopeFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EnvelopeFilledSize24';
import { EnvelopeOpenedFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EnvelopeOpenedFilledSize16';
import { EnvelopeOpenedFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EnvelopeOpenedFilledSize24';
import { EnvelopeOpenedOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EnvelopeOpenedOutlinedSize16';
import { EnvelopeOpenedOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EnvelopeOpenedOutlinedSize24';
import { EnvelopeOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EnvelopeOutlinedSize16';
import { EnvelopeOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EnvelopeOutlinedSize24';
import { ExclamationCircleFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ExclamationCircleFilledSize16';
import { ExclamationCircleFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ExclamationCircleFilledSize24';
import { ExclamationCircleOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ExclamationCircleOutlinedSize16';
import { ExclamationCircleOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ExclamationCircleOutlinedSize24';
import { ExclamationTriangleFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ExclamationTriangleFilledSize16';
import { ExclamationTriangleFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ExclamationTriangleFilledSize24';
import { ExclamationTriangleFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ExclamationTriangleFilledSize32';
import { ExclamationTriangleOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ExclamationTriangleOutlinedSize16';
import { ExclamationTriangleOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ExclamationTriangleOutlinedSize24';
import { ExclamationTriangleOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ExclamationTriangleOutlinedSize32';
import { EyeCrossedFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EyeCrossedFilledSize16';
import { EyeCrossedFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EyeCrossedFilledSize24';
import { EyeCrossedOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EyeCrossedOutlinedSize16';
import { EyeCrossedOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EyeCrossedOutlinedSize24';
import { EyeFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EyeFilledSize16';
import { EyeFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EyeFilledSize24';
import { EyeOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EyeOutlinedSize16';
import { EyeOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/EyeOutlinedSize24';
import { FlagFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FlagFilledSize16';
import { FlagFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FlagFilledSize24';
import { FlagOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FlagOutlinedSize16';
import { FlagOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FlagOutlinedSize24';
import { FlameFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FlameFilledSize16';
import { FlameFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FlameFilledSize24';
import { FlameFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FlameFilledSize32';
import { FlameOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FlameOutlinedSize16';
import { FlameOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FlameOutlinedSize24';
import { FlameOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FlameOutlinedSize32';
import { FlaskFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FlaskFilledSize16';
import { FlaskFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FlaskFilledSize24';
import { FlaskOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FlaskOutlinedSize16';
import { FlaskOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FlaskOutlinedSize24';
import { FolderArrowRightFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FolderArrowRightFilledSize16';
import { FolderArrowRightFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FolderArrowRightFilledSize24';
import { FolderArrowRightOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FolderArrowRightOutlinedSize16';
import { FolderArrowRightOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FolderArrowRightOutlinedSize24';
import { FolderFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FolderFilledSize16';
import { FolderFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FolderFilledSize24';
import { FolderHeartFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FolderHeartFilledSize16';
import { FolderHeartFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FolderHeartFilledSize24';
import { FolderHeartOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FolderHeartOutlinedSize16';
import { FolderHeartOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FolderHeartOutlinedSize24';
import { FolderHyperstarFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FolderHyperstarFilledSize16';
import { FolderHyperstarFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FolderHyperstarFilledSize24';
import { FolderHyperstarOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FolderHyperstarOutlinedSize16';
import { FolderHyperstarOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FolderHyperstarOutlinedSize24';
import { FolderOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FolderOutlinedSize16';
import { FolderOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FolderOutlinedSize24';
import { ForwardFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ForwardFilledSize16';
import { ForwardFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ForwardFilledSize24';
import { ForwardOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ForwardOutlinedSize16';
import { ForwardOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ForwardOutlinedSize24';
import { FrameStarFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FrameStarFilledSize16';
import { FrameStarFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FrameStarFilledSize24';
import { FrameStarOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FrameStarOutlinedSize16';
import { FrameStarOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FrameStarOutlinedSize24';
import { FunnelFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FunnelFilledSize16';
import { FunnelFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FunnelFilledSize24';
import { FunnelOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FunnelOutlinedSize16';
import { FunnelOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/FunnelOutlinedSize24';
import { GamepadFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/GamepadFilledSize16';
import { GamepadFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/GamepadFilledSize24';
import { GamepadOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/GamepadOutlinedSize16';
import { GamepadOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/GamepadOutlinedSize24';
import { GearFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/GearFilledSize16';
import { GearFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/GearFilledSize24';
import { GearOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/GearOutlinedSize16';
import { GearOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/GearOutlinedSize24';
import { GhostFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/GhostFilledSize16';
import { GhostFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/GhostFilledSize24';
import { GhostOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/GhostOutlinedSize16';
import { GhostOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/GhostOutlinedSize24';
import { GiftFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/GiftFilledSize16';
import { GiftFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/GiftFilledSize24';
import { GiftOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/GiftOutlinedSize16';
import { GiftOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/GiftOutlinedSize24';
import { GlobeFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/GlobeFilledSize16';
import { GlobeFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/GlobeFilledSize24';
import { GlobeOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/GlobeOutlinedSize16';
import { GlobeOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/GlobeOutlinedSize24';
import { GraduationHatFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/GraduationHatFilledSize16';
import { GraduationHatFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/GraduationHatFilledSize24';
import { GraduationHatFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/GraduationHatFilledSize32';
import { GraduationHatOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/GraduationHatOutlinedSize16';
import { GraduationHatOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/GraduationHatOutlinedSize24';
import { GraduationHatOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/GraduationHatOutlinedSize32';
import { GridFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/GridFilledSize16';
import { GridFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/GridFilledSize24';
import { GridOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/GridOutlinedSize16';
import { GridOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/GridOutlinedSize24';
import { HeadsetFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HeadsetFilledSize16';
import { HeadsetFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HeadsetFilledSize24';
import { HeadsetOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HeadsetOutlinedSize16';
import { HeadsetOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HeadsetOutlinedSize24';
import { HeartFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HeartFilledSize16';
import { HeartFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HeartFilledSize24';
import { HeartFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HeartFilledSize32';
import { HeartOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HeartOutlinedSize16';
import { HeartOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HeartOutlinedSize24';
import { HeartOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HeartOutlinedSize32';
import { HieroglyphLetterOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HieroglyphLetterOutlinedSize16';
import { HieroglyphLetterOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HieroglyphLetterOutlinedSize24';
import { HomeFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HomeFilledSize16';
import { HomeFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HomeFilledSize24';
import { HomeOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HomeOutlinedSize16';
import { HomeOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HomeOutlinedSize24';
import { HumanCircleFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HumanCircleFilledSize16';
import { HumanCircleFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HumanCircleFilledSize24';
import { HumanCircleOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HumanCircleOutlinedSize16';
import { HumanCircleOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HumanCircleOutlinedSize24';
import { HumanWalkFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HumanWalkFilledSize16';
import { HumanWalkFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HumanWalkFilledSize24';
import { HyperstarFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HyperstarFilledSize16';
import { HyperstarFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HyperstarFilledSize24';
import { HyperstarFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HyperstarFilledSize32';
import { HyperstarFilledSize48Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HyperstarFilledSize48';
import { HyperstarOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HyperstarOutlinedSize16';
import { HyperstarOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HyperstarOutlinedSize24';
import { HyperstarOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HyperstarOutlinedSize32';
import { HyperstarOutlinedSize48Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HyperstarOutlinedSize48';
import { HyperstarSparkleFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HyperstarSparkleFilledSize16';
import { HyperstarSparkleFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HyperstarSparkleFilledSize24';
import { HyperstarSparkleFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HyperstarSparkleFilledSize32';
import { HyperstarSparkleFilledSize48Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HyperstarSparkleFilledSize48';
import { HyperstarSparkleOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HyperstarSparkleOutlinedSize16';
import { HyperstarSparkleOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HyperstarSparkleOutlinedSize24';
import { HyperstarSparkleOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HyperstarSparkleOutlinedSize32';
import { HyperstarSparkleOutlinedSize48Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/HyperstarSparkleOutlinedSize48';
import { ImageFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ImageFilledSize16';
import { ImageFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ImageFilledSize24';
import { ImageFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ImageFilledSize32';
import { ImageFilledSize48Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ImageFilledSize48';
import { ImageHyperstarFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ImageHyperstarFilledSize16';
import { ImageHyperstarFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ImageHyperstarFilledSize24';
import { ImageHyperstarOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ImageHyperstarOutlinedSize16';
import { ImageHyperstarOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ImageHyperstarOutlinedSize24';
import { ImageOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ImageOutlinedSize16';
import { ImageOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ImageOutlinedSize24';
import { ImageOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ImageOutlinedSize32';
import { ImageOutlinedSize48Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ImageOutlinedSize48';
import { ImageStackFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ImageStackFilledSize16';
import { ImageStackFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ImageStackFilledSize32';
import { ImageStackFilledSizeSize4Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ImageStackFilledSizeSize4';
import { ImageStackOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ImageStackOutlinedSize16';
import { ImageStackOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ImageStackOutlinedSize24';
import { ImageStackOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ImageStackOutlinedSize32';
import { InfoCircleFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/InfoCircleFilledSize16';
import { InfoCircleFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/InfoCircleFilledSize24';
import { InfoCircleOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/InfoCircleOutlinedSize16';
import { InfoCircleOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/InfoCircleOutlinedSize24';
import { IngotsFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/IngotsFilledSize16';
import { IngotsFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/IngotsFilledSize24';
import { IngotsOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/IngotsOutlinedSize16';
import { IngotsOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/IngotsOutlinedSize24';
import { KeyFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/KeyFilledSize16';
import { KeyFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/KeyFilledSize24';
import { KeyOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/KeyOutlinedSize16';
import { KeyOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/KeyOutlinedSize24';
import { LiferingFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LiferingFilledSize16';
import { LiferingFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LiferingFilledSize24';
import { LiferingOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LiferingOutlinedSize16';
import { LiferingOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LiferingOutlinedSize24';
import { LightbulbOnFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LightbulbOnFilledSize16';
import { LightbulbOnFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LightbulbOnFilledSize24';
import { LightbulbOnOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LightbulbOnOutlinedSize16';
import { LightbulbOnOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LightbulbOnOutlinedSize24';
import { LineArrowRightEnterOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LineArrowRightEnterOutlinedSize16';
import { LineArrowRightEnterOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LineArrowRightEnterOutlinedSize24';
import { LineArrowRightOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LineArrowRightOutlinedSize16';
import { LineArrowRightOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LineArrowRightOutlinedSize24';
import { LinkOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LinkOutlinedSize16';
import { LinkOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LinkOutlinedSize24';
import { ListOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ListOutlinedSize16';
import { ListOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ListOutlinedSize24';
import { ListShortOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ListShortOutlinedSize16';
import { ListShortOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ListShortOutlinedSize24';
import { LoaderOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LoaderOutlinedSize16';
import { LoaderOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LoaderOutlinedSize24';
import { LoaderOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LoaderOutlinedSize32';
import { LoaderOutlinedSize48Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LoaderOutlinedSize48';
import { LoaderOutlinedSize64Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LoaderOutlinedSize64';
import { LoaderOutlinedSize96Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LoaderOutlinedSize96';
import { LocationFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LocationFilledSize16';
import { LocationFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LocationFilledSize24';
import { LocationFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LocationFilledSize32';
import { LocationOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LocationOutlinedSize16';
import { LocationOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LocationOutlinedSize24';
import { LocationOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LocationOutlinedSize32';
import { LockClosedFilledSize12Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LockClosedFilledSize12';
import { LockClosedFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LockClosedFilledSize16';
import { LockClosedFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LockClosedFilledSize24';
import { LockClosedOutlinedSize12Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LockClosedOutlinedSize12';
import { LockClosedOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LockClosedOutlinedSize16';
import { LockClosedOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LockClosedOutlinedSize24';
import { LockOpenedFilledSize12Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LockOpenedFilledSize12';
import { LockOpenedFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LockOpenedFilledSize16';
import { LockOpenedFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LockOpenedFilledSize24';
import { LockOpenedOutlinedSize12Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LockOpenedOutlinedSize12';
import { LockOpenedOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LockOpenedOutlinedSize16';
import { LockOpenedOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LockOpenedOutlinedSize24';
import { MagnifierFilledHeartFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MagnifierFilledHeartFilledSize16';
import { MagnifierFilledHeartFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MagnifierFilledHeartFilledSize24';
import { MagnifierFilledHeartOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MagnifierFilledHeartOutlinedSize16';
import { MagnifierFilledHeartOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MagnifierFilledHeartOutlinedSize24';
import { MagnifierFilledHyperstarFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MagnifierFilledHyperstarFilledSize16';
import { MagnifierFilledHyperstarFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MagnifierFilledHyperstarFilledSize24';
import { MagnifierFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MagnifierFilledSize16';
import { MagnifierFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MagnifierFilledSize24';
import { MagnifierMinusFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MagnifierMinusFilledSize16';
import { MagnifierMinusFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MagnifierMinusFilledSize24';
import { MagnifierMinusOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MagnifierMinusOutlinedSize16';
import { MagnifierMinusOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MagnifierMinusOutlinedSize24';
import { MagnifierOutlinedHeartFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MagnifierOutlinedHeartFilledSize16';
import { MagnifierOutlinedHeartFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MagnifierOutlinedHeartFilledSize24';
import { MagnifierOutlinedHeartOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MagnifierOutlinedHeartOutlinedSize16';
import { MagnifierOutlinedHeartOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MagnifierOutlinedHeartOutlinedSize24';
import { MagnifierOutlinedHyperstarFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MagnifierOutlinedHyperstarFilledSize16';
import { MagnifierOutlinedHyperstarFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MagnifierOutlinedHyperstarFilledSize24';
import { MagnifierOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MagnifierOutlinedSize16';
import { MagnifierOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MagnifierOutlinedSize24';
import { MagnifierPlusFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MagnifierPlusFilledSize16';
import { MagnifierPlusFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MagnifierPlusFilledSize24';
import { MagnifierPlusOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MagnifierPlusOutlinedSize16';
import { MagnifierPlusOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MagnifierPlusOutlinedSize24';
import { MapFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MapFilledSize16';
import { MapFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MapFilledSize24';
import { MapFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MapFilledSize32';
import { MapOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MapOutlinedSize16';
import { MapOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MapOutlinedSize24';
import { MapOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MapOutlinedSize32';
import { MapPinFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MapPinFilledSize16';
import { MapPinFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MapPinFilledSize24';
import { MapPinFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MapPinFilledSize32';
import { MapPinOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MapPinOutlinedSize16';
import { MapPinOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MapPinOutlinedSize24';
import { MapPinOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MapPinOutlinedSize32';
import { MegaphoneFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MegaphoneFilledSize16';
import { MegaphoneFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MegaphoneFilledSize24';
import { MegaphoneOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MegaphoneOutlinedSize16';
import { MegaphoneOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MegaphoneOutlinedSize24';
import { MicCrossedFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MicCrossedFilledSize16';
import { MicCrossedFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MicCrossedFilledSize24';
import { MicCrossedOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MicCrossedOutlinedSize16';
import { MicCrossedOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MicCrossedOutlinedSize24';
import { MicFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MicFilledSize16';
import { MicFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MicFilledSize24';
import { MicOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MicOutlinedSize16';
import { MicOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MicOutlinedSize24';
import { MinusCircleFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MinusCircleFilledSize16';
import { MinusCircleFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MinusCircleFilledSize24';
import { MinusCircleOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MinusCircleOutlinedSize16';
import { MinusCircleOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MinusCircleOutlinedSize24';
import { MinusOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MinusOutlinedSize16';
import { MinusOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MinusOutlinedSize24';
import { MoonStarFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MoonStarFilledSize16';
import { MoonStarFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MoonStarFilledSize24';
import { MoonStarOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MoonStarOutlinedSize16';
import { MoonStarOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/MoonStarOutlinedSize24';
import { PauseFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PauseFilledSize16';
import { PauseFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PauseFilledSize24';
import { PauseOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PauseOutlinedSize16';
import { PauseOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PauseOutlinedSize24';
import { PenFilledSize12Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PenFilledSize12';
import { PenFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PenFilledSize16';
import { PenFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PenFilledSize24';
import { PenHyperstarFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PenHyperstarFilledSize16';
import { PenHyperstarFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PenHyperstarFilledSize24';
import { PenHyperstarOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PenHyperstarOutlinedSize16';
import { PenHyperstarOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PenHyperstarOutlinedSize24';
import { PenLineFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PenLineFilledSize16';
import { PenLineFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PenLineFilledSize24';
import { PenLineOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PenLineOutlinedSize16';
import { PenLineOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PenLineOutlinedSize24';
import { PenOutlinedSize12Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PenOutlinedSize12';
import { PenOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PenOutlinedSize16';
import { PenOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PenOutlinedSize24';
import { PenSquareOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PenSquareOutlinedSize16';
import { PenSquareOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PenSquareOutlinedSize24';
import { PhoneArrowInFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PhoneArrowInFilledSize16';
import { PhoneArrowInFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PhoneArrowInFilledSize24';
import { PhoneArrowInOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PhoneArrowInOutlinedSize16';
import { PhoneArrowInOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PhoneArrowInOutlinedSize24';
import { PhoneArrowOutFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PhoneArrowOutFilledSize16';
import { PhoneArrowOutFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PhoneArrowOutFilledSize24';
import { PhoneArrowOutOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PhoneArrowOutOutlinedSize16';
import { PhoneArrowOutOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PhoneArrowOutOutlinedSize24';
import { PhoneCrossFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PhoneCrossFilledSize16';
import { PhoneCrossFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PhoneCrossFilledSize24';
import { PhoneCrossOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PhoneCrossOutlinedSize16';
import { PhoneCrossOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PhoneCrossOutlinedSize24';
import { PhoneDownFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PhoneDownFilledSize16';
import { PhoneDownFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PhoneDownFilledSize24';
import { PhoneDownOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PhoneDownOutlinedSize16';
import { PhoneDownOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PhoneDownOutlinedSize24';
import { PhoneFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PhoneFilledSize16';
import { PhoneFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PhoneFilledSize24';
import { PhoneOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PhoneOutlinedSize16';
import { PhoneOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PhoneOutlinedSize24';
import { PhoneWaveFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PhoneWaveFilledSize16';
import { PhoneWaveFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PhoneWaveFilledSize24';
import { PhoneWaveOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PhoneWaveOutlinedSize16';
import { PhoneWaveOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PhoneWaveOutlinedSize24';
import { PinCrossedFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PinCrossedFilledSize16';
import { PinCrossedFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PinCrossedFilledSize24';
import { PinCrossedOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PinCrossedOutlinedSize16';
import { PinCrossedOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PinCrossedOutlinedSize24';
import { PinFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PinFilledSize16';
import { PinFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PinFilledSize24';
import { PinOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PinOutlinedSize16';
import { PinOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PinOutlinedSize24';
import { PlayCircleFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PlayCircleFilledSize16';
import { PlayCircleFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PlayCircleFilledSize24';
import { PlayCircleOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PlayCircleOutlinedSize16';
import { PlayCircleOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PlayCircleOutlinedSize24';
import { PlayFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PlayFilledSize16';
import { PlayFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PlayFilledSize24';
import { PlayOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PlayOutlinedSize16';
import { PlayOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PlayOutlinedSize24';
import { PlusBoldFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PlusBoldFilledSize16';
import { PlusBoldFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PlusBoldFilledSize24';
import { PlusBoldOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PlusBoldOutlinedSize16';
import { PlusBoldOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PlusBoldOutlinedSize24';
import { PlusCircleFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PlusCircleFilledSize16';
import { PlusCircleFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PlusCircleFilledSize24';
import { PlusCircleOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PlusCircleOutlinedSize16';
import { PlusCircleOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PlusCircleOutlinedSize24';
import { PlusOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PlusOutlinedSize16';
import { PlusOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PlusOutlinedSize24';
import { PopcornFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PopcornFilledSize16';
import { PopcornFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PopcornFilledSize24';
import { PopcornOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PopcornOutlinedSize16';
import { PopcornOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PopcornOutlinedSize24';
import { PriceTagFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PriceTagFilledSize16';
import { PriceTagFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PriceTagFilledSize24';
import { PriceTagOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PriceTagOutlinedSize16';
import { PriceTagOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PriceTagOutlinedSize24';
import { PrinterFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PrinterFilledSize16';
import { PrinterFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PrinterFilledSize24';
import { PrinterOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PrinterOutlinedSize16';
import { PrinterOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/PrinterOutlinedSize24';
import { QrCodeOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/QrCodeOutlinedSize16';
import { QrCodeOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/QrCodeOutlinedSize24';
import { QuestionCircleFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/QuestionCircleFilledSize16';
import { QuestionCircleFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/QuestionCircleFilledSize24';
import { QuestionCircleOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/QuestionCircleOutlinedSize16';
import { QuestionCircleOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/QuestionCircleOutlinedSize24';
import { RadiusFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/RadiusFilledSize16';
import { RadiusFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/RadiusFilledSize24';
import { RadiusOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/RadiusOutlinedSize16';
import { RadiusOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/RadiusOutlinedSize24';
import { RocketFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/RocketFilledSize16';
import { RocketFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/RocketFilledSize24';
import { RocketOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/RocketOutlinedSize16';
import { RocketOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/RocketOutlinedSize24';
import { RotateLeftFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/RotateLeftFilledSize16';
import { RotateLeftFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/RotateLeftFilledSize24';
import { RotateLeftOultinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/RotateLeftOultinedSize16';
import { RotateLeftOultinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/RotateLeftOultinedSize24';
import { RotateRightFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/RotateRightFilledSize16';
import { RotateRightFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/RotateRightFilledSize24';
import { RotateRightOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/RotateRightOutlinedSize16';
import { RotateRightOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/RotateRightOutlinedSize24';
import { SafeFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SafeFilledSize16';
import { SafeFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SafeFilledSize24';
import { SafeOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SafeOutlinedSize16';
import { SafeOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SafeOutlinedSize24';
import { ScooterFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ScooterFilledSize16';
import { ScooterFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ScooterFilledSize24';
import { ScooterOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ScooterOutlinedSize16';
import { ScooterOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ScooterOutlinedSize24';
import { SendAndroidFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SendAndroidFilledSize16';
import { SendAndroidFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SendAndroidFilledSize24';
import { SendAndroidFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SendAndroidFilledSize32';
import { SendAndroidOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SendAndroidOutlinedSize16';
import { SendAndroidOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SendAndroidOutlinedSize24';
import { SendAndroidOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SendAndroidOutlinedSize32';
import { SendIosFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SendIosFilledSize16';
import { SendIosFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SendIosFilledSize24';
import { SendIosFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SendIosFilledSize32';
import { SendIosOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SendIosOutlinedSize16';
import { SendIosOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SendIosOutlinedSize24';
import { SendIosOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SendIosOutlinedSize32';
import { SendWebFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SendWebFilledSize16';
import { SendWebFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SendWebFilledSize24';
import { SendWebFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SendWebFilledSize32';
import { SendWebOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SendWebOutlinedSize16';
import { SendWebOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SendWebOutlinedSize24';
import { SendWebOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SendWebOutlinedSize32';
import { ShareAndroidOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ShareAndroidOutlinedSize16';
import { ShareAndroidOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ShareAndroidOutlinedSize24';
import { ShareIosOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ShareIosOutlinedSize16';
import { ShareIosOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ShareIosOutlinedSize24';
import { ShareWebFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ShareWebFilledSize16';
import { ShareWebFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ShareWebFilledSize24';
import { ShareWebOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ShareWebOutlinedSize16';
import { ShareWebOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ShareWebOutlinedSize24';
import { ShieldFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ShieldFilledSize16';
import { ShieldFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ShieldFilledSize24';
import { ShieldOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ShieldOutlinedSize16';
import { ShieldOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ShieldOutlinedSize24';
import { SmartphoneFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SmartphoneFilledSize16';
import { SmartphoneFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SmartphoneFilledSize24';
import { SmartphoneOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SmartphoneOutlinedSize16';
import { SmartphoneOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SmartphoneOutlinedSize24';
import { SmileFaceFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SmileFaceFilledSize16';
import { SmileFaceFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SmileFaceFilledSize24';
import { SmileFaceOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SmileFaceOutlinedSize16';
import { SmileFaceOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SmileFaceOutlinedSize24';
import { SpeakerCrossFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SpeakerCrossFilledSize16';
import { SpeakerCrossFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SpeakerCrossFilledSize24';
import { SpeakerCrossOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SpeakerCrossOutlinedSize16';
import { SpeakerCrossOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SpeakerCrossOutlinedSize24';
import { SpeakerCrossedFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SpeakerCrossedFilledSize16';
import { SpeakerCrossedFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SpeakerCrossedFilledSize24';
import { SpeakerCrossedFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SpeakerCrossedFilledSize32';
import { SpeakerCrossedOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SpeakerCrossedOutlinedSize16';
import { SpeakerCrossedOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SpeakerCrossedOutlinedSize24';
import { SpeakerWaveFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SpeakerWaveFilledSize16';
import { SpeakerWaveFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SpeakerWaveFilledSize24';
import { SpeakerWaveOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SpeakerWaveOutlinedSize16';
import { SpeakerWaveOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SpeakerWaveOutlinedSize24';
import { SpeedometerFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SpeedometerFilledSize16';
import { SpeedometerFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SpeedometerFilledSize24';
import { SpeedometerOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SpeedometerOutlinedSize16';
import { SpeedometerOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SpeedometerOutlinedSize24';
import { SquareCircleFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SquareCircleFilledSize16';
import { SquareCircleFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SquareCircleFilledSize24';
import { SquaresIntersectedFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SquaresIntersectedFilledSize16';
import { SquaresIntersectedFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SquaresIntersectedFilledSize24';
import { SquaresIntersectedOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SquaresIntersectedOutlinedSize16';
import { SquaresIntersectedOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SquaresIntersectedOutlinedSize24';
import { StarCircleFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/StarCircleFilledSize16';
import { StarCircleFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/StarCircleFilledSize24';
import { StarCircleFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/StarCircleFilledSize32';
import { StarCircleOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/StarCircleOutlinedSize16';
import { StarCircleOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/StarCircleOutlinedSize24';
import { StarCircleOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/StarCircleOutlinedSize32';
import { StarFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/StarFilledSize16';
import { StarFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/StarFilledSize24';
import { StarFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/StarFilledSize32';
import { StarHalfFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/StarHalfFilledSize16';
import { StarHalfFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/StarHalfFilledSize24';
import { StarHalfFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/StarHalfFilledSize32';
import { StarOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/StarOutlinedSize16';
import { StarOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/StarOutlinedSize24';
import { StarOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/StarOutlinedSize32';
import { SunFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SunFilledSize16';
import { SunFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SunFilledSize24';
import { SunOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SunOutlinedSize16';
import { SunOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SunOutlinedSize24';
import { SuperstarFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SuperstarFilledSize16';
import { SuperstarFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SuperstarFilledSize24';
import { SuperstarOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SuperstarOutlinedSize16';
import { SuperstarOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/SuperstarOutlinedSize24';
import { ThumbDownFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ThumbDownFilledSize16';
import { ThumbDownFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ThumbDownFilledSize24';
import { ThumbDownOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ThumbDownOutlinedSize16';
import { ThumbDownOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ThumbDownOutlinedSize24';
import { ThumbUpFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ThumbUpFilledSize16';
import { ThumbUpFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ThumbUpFilledSize24';
import { ThumbUpOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ThumbUpOutlinedSize16';
import { ThumbUpOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/ThumbUpOutlinedSize24';
import { TrainFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/TrainFilledSize16';
import { TrainFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/TrainFilledSize24';
import { TrainOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/TrainOutlinedSize16';
import { TrainOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/TrainOutlinedSize24';
import { TramFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/TramFilledSize16';
import { TramFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/TramFilledSize24';
import { TramOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/TramOutlinedSize16';
import { TramOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/TramOutlinedSize24';
import { TrashFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/TrashFilledSize16';
import { TrashFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/TrashFilledSize24';
import { TrashOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/TrashOutlinedSize16';
import { TrashOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/TrashOutlinedSize24';
import { TreeFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/TreeFilledSize16';
import { TreeFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/TreeFilledSize24';
import { TreeOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/TreeOutlinedSize16';
import { TreeOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/TreeOutlinedSize24';
import { TrolleyFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/TrolleyFilledSize16';
import { TrolleyFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/TrolleyFilledSize24';
import { TrolleyOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/TrolleyOutlinedSize16';
import { TrolleyOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/TrolleyOutlinedSize24';
import { TrolleybusFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/TrolleybusFilledSize16';
import { TrolleybusFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/TrolleybusFilledSize24';
import { TrolleybusOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/TrolleybusOutlinedSize16';
import { TrolleybusOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/TrolleybusOutlinedSize24';
import { UserCircleFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/UserCircleFilledSize16';
import { UserCircleFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/UserCircleFilledSize24';
import { UserCircleFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/UserCircleFilledSize32';
import { UserCircleOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/UserCircleOutlinedSize16';
import { UserCircleOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/UserCircleOutlinedSize24';
import { UserCircleOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/UserCircleOutlinedSize32';
import { UserDoubleFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/UserDoubleFilledSize16';
import { UserDoubleFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/UserDoubleFilledSize24';
import { UserDoubleOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/UserDoubleOutlinedSize16';
import { UserDoubleOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/UserDoubleOutlinedSize24';
import { UserFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/UserFilledSize16';
import { UserFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/UserFilledSize24';
import { UserOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/UserOutlinedSize16';
import { UserOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/UserOutlinedSize24';
import { UserSingleBanFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/UserSingleBanFilledSize16';
import { UserSingleBanFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/UserSingleBanFilledSize24';
import { UserSingleBanOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/UserSingleBanOutlinedSize16';
import { UserSingleBanOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/UserSingleBanOutlinedSize24';
import { UserSinglePlusFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/UserSinglePlusFilledSize16';
import { UserSinglePlusFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/UserSinglePlusFilledSize24';
import { UserSinglePlusOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/UserSinglePlusOutlinedSize16';
import { UserSinglePlusOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/UserSinglePlusOutlinedSize24';
import { UturnLeftOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/UturnLeftOutlinedSize16';
import { UturnLeftOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/UturnLeftOutlinedSize24';
import { UturnRightOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/UturnRightOutlinedSize16';
import { UturnRightOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/UturnRightOutlinedSize24';
import { VerifiedBadgeFilledSize12Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/VerifiedBadgeFilledSize12';
import { VerifiedBadgeFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/VerifiedBadgeFilledSize16';
import { VerifiedBadgeFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/VerifiedBadgeFilledSize24';
import { VerifiedBadgeFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/VerifiedBadgeFilledSize32';
import { VerifiedBadgeOutlinedSize12Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/VerifiedBadgeOutlinedSize12';
import { VerifiedBadgeOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/VerifiedBadgeOutlinedSize16';
import { VerifiedBadgeOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/VerifiedBadgeOutlinedSize24';
import { VideocameraFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/VideocameraFilledSize16';
import { VideocameraFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/VideocameraFilledSize24';
import { VideocameraFilledSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/VideocameraFilledSize32';
import { VideocameraHyperstarFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/VideocameraHyperstarFilledSize16';
import { VideocameraHyperstarFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/VideocameraHyperstarFilledSize24';
import { VideocameraHyperstarOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/VideocameraHyperstarOutlinedSize16';
import { VideocameraHyperstarOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/VideocameraHyperstarOutlinedSize24';
import { VideocameraOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/VideocameraOutlinedSize16';
import { VideocameraOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/VideocameraOutlinedSize24';
import { VideocameraOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/VideocameraOutlinedSize32';
import { WalletFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/WalletFilledSize16';
import { WalletFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/WalletFilledSize24';
import { WalletOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/WalletOutlinedSize16';
import { WalletOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/WalletOutlinedSize24';
import { WheatFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/WheatFilledSize16';
import { WheatFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/WheatFilledSize24';
import { WheatOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/WheatOutlinedSize16';
import { WheatOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/WheatOutlinedSize24';

export const MapOutlinedSize16 = /* #__PURE__*/ hoc<'MapOutlinedSize16'>(MapOutlinedSize16Glyph, 'MapOutlinedSize16');
export const ClockRewindOutlinedSize16 = /* #__PURE__*/ hoc<'ClockRewindOutlinedSize16'>(
    ClockRewindOutlinedSize16Glyph,
    'ClockRewindOutlinedSize16'
);
export const CheckDoubleOutlinedSize12 = /* #__PURE__*/ hoc<'CheckDoubleOutlinedSize12'>(
    CheckDoubleOutlinedSize12Glyph,
    'CheckDoubleOutlinedSize12'
);
export const ClipOutlinedSize16 = /* #__PURE__*/ hoc<'ClipOutlinedSize16'>(
    ClipOutlinedSize16Glyph,
    'ClipOutlinedSize16'
);
export const RadiusFilledSize24 = /* #__PURE__*/ hoc<'RadiusFilledSize24'>(
    RadiusFilledSize24Glyph,
    'RadiusFilledSize24'
);
export const SendWebFilledSize16 = /* #__PURE__*/ hoc<'SendWebFilledSize16'>(
    SendWebFilledSize16Glyph,
    'SendWebFilledSize16'
);
export const TrainFilledSize24 = /* #__PURE__*/ hoc<'TrainFilledSize24'>(TrainFilledSize24Glyph, 'TrainFilledSize24');
export const CarFilledSize16 = /* #__PURE__*/ hoc<'CarFilledSize16'>(CarFilledSize16Glyph, 'CarFilledSize16');
export const TrainOutlinedSize24 = /* #__PURE__*/ hoc<'TrainOutlinedSize24'>(
    TrainOutlinedSize24Glyph,
    'TrainOutlinedSize24'
);
export const BusOutlinedSize24 = /* #__PURE__*/ hoc<'BusOutlinedSize24'>(BusOutlinedSize24Glyph, 'BusOutlinedSize24');
export const BusTaxiOutlinedSize24 = /* #__PURE__*/ hoc<'BusTaxiOutlinedSize24'>(
    BusTaxiOutlinedSize24Glyph,
    'BusTaxiOutlinedSize24'
);
export const TrolleybusFilledSize24 = /* #__PURE__*/ hoc<'TrolleybusFilledSize24'>(
    TrolleybusFilledSize24Glyph,
    'TrolleybusFilledSize24'
);
export const StarFilledSize24 = /* #__PURE__*/ hoc<'StarFilledSize24'>(StarFilledSize24Glyph, 'StarFilledSize24');
export const ShareWebOutlinedSize24 = /* #__PURE__*/ hoc<'ShareWebOutlinedSize24'>(
    ShareWebOutlinedSize24Glyph,
    'ShareWebOutlinedSize24'
);
export const MapPinFilledSize24 = /* #__PURE__*/ hoc<'MapPinFilledSize24'>(
    MapPinFilledSize24Glyph,
    'MapPinFilledSize24'
);
export const ChevronDownOutlinedSize16 = /* #__PURE__*/ hoc<'ChevronDownOutlinedSize16'>(
    ChevronDownOutlinedSize16Glyph,
    'ChevronDownOutlinedSize16'
);
export const UserCircleOutlinedSize16 = /* #__PURE__*/ hoc<'UserCircleOutlinedSize16'>(
    UserCircleOutlinedSize16Glyph,
    'UserCircleOutlinedSize16'
);
export const TrashFilledSize16 = /* #__PURE__*/ hoc<'TrashFilledSize16'>(TrashFilledSize16Glyph, 'TrashFilledSize16');
export const GlobeFilledSize16 = /* #__PURE__*/ hoc<'GlobeFilledSize16'>(GlobeFilledSize16Glyph, 'GlobeFilledSize16');
export const PauseFilledSize24 = /* #__PURE__*/ hoc<'PauseFilledSize24'>(PauseFilledSize24Glyph, 'PauseFilledSize24');
export const PauseFilledSize16 = /* #__PURE__*/ hoc<'PauseFilledSize16'>(PauseFilledSize16Glyph, 'PauseFilledSize16');
export const ChartBarFilledSize24 = /* #__PURE__*/ hoc<'ChartBarFilledSize24'>(
    ChartBarFilledSize24Glyph,
    'ChartBarFilledSize24'
);
export const MicOutlinedSize24 = /* #__PURE__*/ hoc<'MicOutlinedSize24'>(MicOutlinedSize24Glyph, 'MicOutlinedSize24');
export const ChartBarFilledSize16 = /* #__PURE__*/ hoc<'ChartBarFilledSize16'>(
    ChartBarFilledSize16Glyph,
    'ChartBarFilledSize16'
);
export const ArrowDiagonalRightDownOutlinedSize16 = /* #__PURE__*/ hoc<'ArrowDiagonalRightDownOutlinedSize16'>(
    ArrowDiagonalRightDownOutlinedSize16Glyph,
    'ArrowDiagonalRightDownOutlinedSize16'
);
export const StarHalfFilledSize24 = /* #__PURE__*/ hoc<'StarHalfFilledSize24'>(
    StarHalfFilledSize24Glyph,
    'StarHalfFilledSize24'
);
export const ArrowDiagonalRightDownOutlinedSize24 = /* #__PURE__*/ hoc<'ArrowDiagonalRightDownOutlinedSize24'>(
    ArrowDiagonalRightDownOutlinedSize24Glyph,
    'ArrowDiagonalRightDownOutlinedSize24'
);
export const ChartLineFilledSize32 = /* #__PURE__*/ hoc<'ChartLineFilledSize32'>(
    ChartLineFilledSize32Glyph,
    'ChartLineFilledSize32'
);
export const WalletOutlinedSize24 = /* #__PURE__*/ hoc<'WalletOutlinedSize24'>(
    WalletOutlinedSize24Glyph,
    'WalletOutlinedSize24'
);
export const WalletOutlinedSize16 = /* #__PURE__*/ hoc<'WalletOutlinedSize16'>(
    WalletOutlinedSize16Glyph,
    'WalletOutlinedSize16'
);
export const EmojiSmile3dSize16 = /* #__PURE__*/ hoc<'EmojiSmile3dSize16'>(
    EmojiSmile3dSize16Glyph,
    'EmojiSmile3dSize16'
);
export const EmojiSmile3dSize32 = /* #__PURE__*/ hoc<'EmojiSmile3dSize32'>(
    EmojiSmile3dSize32Glyph,
    'EmojiSmile3dSize32'
);
export const CardLinesStackedCrossedOutlinedSize16 = /* #__PURE__*/ hoc<'CardLinesStackedCrossedOutlinedSize16'>(
    CardLinesStackedCrossedOutlinedSize16Glyph,
    'CardLinesStackedCrossedOutlinedSize16'
);
export const CalendarOutlinedSize16 = /* #__PURE__*/ hoc<'CalendarOutlinedSize16'>(
    CalendarOutlinedSize16Glyph,
    'CalendarOutlinedSize16'
);
export const LocationOutlinedSize16 = /* #__PURE__*/ hoc<'LocationOutlinedSize16'>(
    LocationOutlinedSize16Glyph,
    'LocationOutlinedSize16'
);
export const HeadsetOutlinedSize16 = /* #__PURE__*/ hoc<'HeadsetOutlinedSize16'>(
    HeadsetOutlinedSize16Glyph,
    'HeadsetOutlinedSize16'
);
export const QuestionCircleOutlinedSize16 = /* #__PURE__*/ hoc<'QuestionCircleOutlinedSize16'>(
    QuestionCircleOutlinedSize16Glyph,
    'QuestionCircleOutlinedSize16'
);
export const AdjustmentsFilledSize24 = /* #__PURE__*/ hoc<'AdjustmentsFilledSize24'>(
    AdjustmentsFilledSize24Glyph,
    'AdjustmentsFilledSize24'
);
export const SendIosFilledSize24 = /* #__PURE__*/ hoc<'SendIosFilledSize24'>(
    SendIosFilledSize24Glyph,
    'SendIosFilledSize24'
);
export const FlagOutlinedSize24 = /* #__PURE__*/ hoc<'FlagOutlinedSize24'>(
    FlagOutlinedSize24Glyph,
    'FlagOutlinedSize24'
);
export const ChevronWideOutlinedSize16 = /* #__PURE__*/ hoc<'ChevronWideOutlinedSize16'>(
    ChevronWideOutlinedSize16Glyph,
    'ChevronWideOutlinedSize16'
);
export const ChartBarOutlinedSize16 = /* #__PURE__*/ hoc<'ChartBarOutlinedSize16'>(
    ChartBarOutlinedSize16Glyph,
    'ChartBarOutlinedSize16'
);
export const ImageFilledSize16 = /* #__PURE__*/ hoc<'ImageFilledSize16'>(ImageFilledSize16Glyph, 'ImageFilledSize16');
export const DropsFilledSize24 = /* #__PURE__*/ hoc<'DropsFilledSize24'>(DropsFilledSize24Glyph, 'DropsFilledSize24');
export const FolderHyperstarOutlinedSize16 = /* #__PURE__*/ hoc<'FolderHyperstarOutlinedSize16'>(
    FolderHyperstarOutlinedSize16Glyph,
    'FolderHyperstarOutlinedSize16'
);
export const MagnifierFilledHyperstarFilledSize16 = /* #__PURE__*/ hoc<'MagnifierFilledHyperstarFilledSize16'>(
    MagnifierFilledHyperstarFilledSize16Glyph,
    'MagnifierFilledHyperstarFilledSize16'
);
export const FolderHyperstarFilledSize24 = /* #__PURE__*/ hoc<'FolderHyperstarFilledSize24'>(
    FolderHyperstarFilledSize24Glyph,
    'FolderHyperstarFilledSize24'
);
export const PenHyperstarFilledSize24 = /* #__PURE__*/ hoc<'PenHyperstarFilledSize24'>(
    PenHyperstarFilledSize24Glyph,
    'PenHyperstarFilledSize24'
);
export const PenHyperstarFilledSize16 = /* #__PURE__*/ hoc<'PenHyperstarFilledSize16'>(
    PenHyperstarFilledSize16Glyph,
    'PenHyperstarFilledSize16'
);
export const UserSinglePlusOutlinedSize16 = /* #__PURE__*/ hoc<'UserSinglePlusOutlinedSize16'>(
    UserSinglePlusOutlinedSize16Glyph,
    'UserSinglePlusOutlinedSize16'
);
export const CardLinesPlusOutlinedSize16 = /* #__PURE__*/ hoc<'CardLinesPlusOutlinedSize16'>(
    CardLinesPlusOutlinedSize16Glyph,
    'CardLinesPlusOutlinedSize16'
);
export const CardLinesPlusFilledSize24 = /* #__PURE__*/ hoc<'CardLinesPlusFilledSize24'>(
    CardLinesPlusFilledSize24Glyph,
    'CardLinesPlusFilledSize24'
);
export const UserSinglePlusFilledSize24 = /* #__PURE__*/ hoc<'UserSinglePlusFilledSize24'>(
    UserSinglePlusFilledSize24Glyph,
    'UserSinglePlusFilledSize24'
);
export const BulletFilledSize24 = /* #__PURE__*/ hoc<'BulletFilledSize24'>(
    BulletFilledSize24Glyph,
    'BulletFilledSize24'
);
export const DocumentStarOutlinedSize32 = /* #__PURE__*/ hoc<'DocumentStarOutlinedSize32'>(
    DocumentStarOutlinedSize32Glyph,
    'DocumentStarOutlinedSize32'
);
export const SquaresIntersectedFilledSize16 = /* #__PURE__*/ hoc<'SquaresIntersectedFilledSize16'>(
    SquaresIntersectedFilledSize16Glyph,
    'SquaresIntersectedFilledSize16'
);
export const HomeFilledSize16 = /* #__PURE__*/ hoc<'HomeFilledSize16'>(HomeFilledSize16Glyph, 'HomeFilledSize16');
export const EmojiNeutral3dSize24 = /* #__PURE__*/ hoc<'EmojiNeutral3dSize24'>(
    EmojiNeutral3dSize24Glyph,
    'EmojiNeutral3dSize24'
);
export const EmojiNeutral3dSize32 = /* #__PURE__*/ hoc<'EmojiNeutral3dSize32'>(
    EmojiNeutral3dSize32Glyph,
    'EmojiNeutral3dSize32'
);
export const EmojiHalfsad3dSize16 = /* #__PURE__*/ hoc<'EmojiHalfsad3dSize16'>(
    EmojiHalfsad3dSize16Glyph,
    'EmojiHalfsad3dSize16'
);
export const EmojiHalfsmile3dSize32 = /* #__PURE__*/ hoc<'EmojiHalfsmile3dSize32'>(
    EmojiHalfsmile3dSize32Glyph,
    'EmojiHalfsmile3dSize32'
);
export const SpeakerCrossOutlinedSize16 = /* #__PURE__*/ hoc<'SpeakerCrossOutlinedSize16'>(
    SpeakerCrossOutlinedSize16Glyph,
    'SpeakerCrossOutlinedSize16'
);
export const EmojiNeutral3dSize16 = /* #__PURE__*/ hoc<'EmojiNeutral3dSize16'>(
    EmojiNeutral3dSize16Glyph,
    'EmojiNeutral3dSize16'
);
export const EmojiHalfsad3dSize32 = /* #__PURE__*/ hoc<'EmojiHalfsad3dSize32'>(
    EmojiHalfsad3dSize32Glyph,
    'EmojiHalfsad3dSize32'
);
export const CarDoorFilledSize24 = /* #__PURE__*/ hoc<'CarDoorFilledSize24'>(
    CarDoorFilledSize24Glyph,
    'CarDoorFilledSize24'
);
export const BookOutlinedSize16 = /* #__PURE__*/ hoc<'BookOutlinedSize16'>(
    BookOutlinedSize16Glyph,
    'BookOutlinedSize16'
);
export const CarDoorOutlinedSize24 = /* #__PURE__*/ hoc<'CarDoorOutlinedSize24'>(
    CarDoorOutlinedSize24Glyph,
    'CarDoorOutlinedSize24'
);
export const LoaderOutlinedSize24 = /* #__PURE__*/ hoc<'LoaderOutlinedSize24'>(
    LoaderOutlinedSize24Glyph,
    'LoaderOutlinedSize24'
);
export const EmojiSadOutlinedSize32 = /* #__PURE__*/ hoc<'EmojiSadOutlinedSize32'>(
    EmojiSadOutlinedSize32Glyph,
    'EmojiSadOutlinedSize32'
);
export const SquaresIntersectedFilledSize24 = /* #__PURE__*/ hoc<'SquaresIntersectedFilledSize24'>(
    SquaresIntersectedFilledSize24Glyph,
    'SquaresIntersectedFilledSize24'
);
export const ShieldFilledSize24 = /* #__PURE__*/ hoc<'ShieldFilledSize24'>(
    ShieldFilledSize24Glyph,
    'ShieldFilledSize24'
);
export const EmojiSad3dSize16 = /* #__PURE__*/ hoc<'EmojiSad3dSize16'>(EmojiSad3dSize16Glyph, 'EmojiSad3dSize16');
export const ChevronLeftSquareFilledSize24 = /* #__PURE__*/ hoc<'ChevronLeftSquareFilledSize24'>(
    ChevronLeftSquareFilledSize24Glyph,
    'ChevronLeftSquareFilledSize24'
);
export const ArrowUpOutlinedSize16 = /* #__PURE__*/ hoc<'ArrowUpOutlinedSize16'>(
    ArrowUpOutlinedSize16Glyph,
    'ArrowUpOutlinedSize16'
);
export const LoaderOutlinedSize48 = /* #__PURE__*/ hoc<'LoaderOutlinedSize48'>(
    LoaderOutlinedSize48Glyph,
    'LoaderOutlinedSize48'
);
export const ArrowUpOutlinedSize32 = /* #__PURE__*/ hoc<'ArrowUpOutlinedSize32'>(
    ArrowUpOutlinedSize32Glyph,
    'ArrowUpOutlinedSize32'
);
export const BubbleRoundFilledSize24 = /* #__PURE__*/ hoc<'BubbleRoundFilledSize24'>(
    BubbleRoundFilledSize24Glyph,
    'BubbleRoundFilledSize24'
);
export const EmojiHalfsad3dSize24 = /* #__PURE__*/ hoc<'EmojiHalfsad3dSize24'>(
    EmojiHalfsad3dSize24Glyph,
    'EmojiHalfsad3dSize24'
);
export const EmojiSad3dSize32 = /* #__PURE__*/ hoc<'EmojiSad3dSize32'>(EmojiSad3dSize32Glyph, 'EmojiSad3dSize32');
export const ArrowsDiagonalOutOutlinedSize24 = /* #__PURE__*/ hoc<'ArrowsDiagonalOutOutlinedSize24'>(
    ArrowsDiagonalOutOutlinedSize24Glyph,
    'ArrowsDiagonalOutOutlinedSize24'
);
export const ArrowsDiagonalOutOutlinedSize16 = /* #__PURE__*/ hoc<'ArrowsDiagonalOutOutlinedSize16'>(
    ArrowsDiagonalOutOutlinedSize16Glyph,
    'ArrowsDiagonalOutOutlinedSize16'
);
export const SmileFaceOutlinedSize16 = /* #__PURE__*/ hoc<'SmileFaceOutlinedSize16'>(
    SmileFaceOutlinedSize16Glyph,
    'SmileFaceOutlinedSize16'
);
export const BubbleRoundFilledSize16 = /* #__PURE__*/ hoc<'BubbleRoundFilledSize16'>(
    BubbleRoundFilledSize16Glyph,
    'BubbleRoundFilledSize16'
);
export const EmojiHalfsmile3dSize16 = /* #__PURE__*/ hoc<'EmojiHalfsmile3dSize16'>(
    EmojiHalfsmile3dSize16Glyph,
    'EmojiHalfsmile3dSize16'
);
export const DataflowOutlinedSize16 = /* #__PURE__*/ hoc<'DataflowOutlinedSize16'>(
    DataflowOutlinedSize16Glyph,
    'DataflowOutlinedSize16'
);
export const LockOpenedOutlinedSize24 = /* #__PURE__*/ hoc<'LockOpenedOutlinedSize24'>(
    LockOpenedOutlinedSize24Glyph,
    'LockOpenedOutlinedSize24'
);
export const CarDoorOutlinedSize16 = /* #__PURE__*/ hoc<'CarDoorOutlinedSize16'>(
    CarDoorOutlinedSize16Glyph,
    'CarDoorOutlinedSize16'
);
export const ImageStackFilledSize32 = /* #__PURE__*/ hoc<'ImageStackFilledSize32'>(
    ImageStackFilledSize32Glyph,
    'ImageStackFilledSize32'
);
export const HomeFilledSize24 = /* #__PURE__*/ hoc<'HomeFilledSize24'>(HomeFilledSize24Glyph, 'HomeFilledSize24');
export const LoaderOutlinedSize16 = /* #__PURE__*/ hoc<'LoaderOutlinedSize16'>(
    LoaderOutlinedSize16Glyph,
    'LoaderOutlinedSize16'
);
export const LoaderOutlinedSize32 = /* #__PURE__*/ hoc<'LoaderOutlinedSize32'>(
    LoaderOutlinedSize32Glyph,
    'LoaderOutlinedSize32'
);
export const EmojiHalfsmile3dSize24 = /* #__PURE__*/ hoc<'EmojiHalfsmile3dSize24'>(
    EmojiHalfsmile3dSize24Glyph,
    'EmojiHalfsmile3dSize24'
);
export const CarDoorFilledSize16 = /* #__PURE__*/ hoc<'CarDoorFilledSize16'>(
    CarDoorFilledSize16Glyph,
    'CarDoorFilledSize16'
);
export const ShieldFilledSize16 = /* #__PURE__*/ hoc<'ShieldFilledSize16'>(
    ShieldFilledSize16Glyph,
    'ShieldFilledSize16'
);
export const ArrowUpOutlinedSize24 = /* #__PURE__*/ hoc<'ArrowUpOutlinedSize24'>(
    ArrowUpOutlinedSize24Glyph,
    'ArrowUpOutlinedSize24'
);
export const LoaderOutlinedSize64 = /* #__PURE__*/ hoc<'LoaderOutlinedSize64'>(
    LoaderOutlinedSize64Glyph,
    'LoaderOutlinedSize64'
);
export const EmojiSad3dSize24 = /* #__PURE__*/ hoc<'EmojiSad3dSize24'>(EmojiSad3dSize24Glyph, 'EmojiSad3dSize24');
export const ClocheOutlinedSize24 = /* #__PURE__*/ hoc<'ClocheOutlinedSize24'>(
    ClocheOutlinedSize24Glyph,
    'ClocheOutlinedSize24'
);
export const LoaderOutlinedSize96 = /* #__PURE__*/ hoc<'LoaderOutlinedSize96'>(
    LoaderOutlinedSize96Glyph,
    'LoaderOutlinedSize96'
);
export const ComputerOutlinedSize24 = /* #__PURE__*/ hoc<'ComputerOutlinedSize24'>(
    ComputerOutlinedSize24Glyph,
    'ComputerOutlinedSize24'
);
export const PhoneCrossFilledSize16 = /* #__PURE__*/ hoc<'PhoneCrossFilledSize16'>(
    PhoneCrossFilledSize16Glyph,
    'PhoneCrossFilledSize16'
);
export const BoxFilledSize24 = /* #__PURE__*/ hoc<'BoxFilledSize24'>(BoxFilledSize24Glyph, 'BoxFilledSize24');
export const PhoneCrossOutlinedSize24 = /* #__PURE__*/ hoc<'PhoneCrossOutlinedSize24'>(
    PhoneCrossOutlinedSize24Glyph,
    'PhoneCrossOutlinedSize24'
);
export const FolderOutlinedSize16 = /* #__PURE__*/ hoc<'FolderOutlinedSize16'>(
    FolderOutlinedSize16Glyph,
    'FolderOutlinedSize16'
);
export const PhoneArrowOutOutlinedSize16 = /* #__PURE__*/ hoc<'PhoneArrowOutOutlinedSize16'>(
    PhoneArrowOutOutlinedSize16Glyph,
    'PhoneArrowOutOutlinedSize16'
);
export const ConstructionHatFilledSize24 = /* #__PURE__*/ hoc<'ConstructionHatFilledSize24'>(
    ConstructionHatFilledSize24Glyph,
    'ConstructionHatFilledSize24'
);
export const ListShortOutlinedSize16 = /* #__PURE__*/ hoc<'ListShortOutlinedSize16'>(
    ListShortOutlinedSize16Glyph,
    'ListShortOutlinedSize16'
);
export const GiftOutlinedSize16 = /* #__PURE__*/ hoc<'GiftOutlinedSize16'>(
    GiftOutlinedSize16Glyph,
    'GiftOutlinedSize16'
);
export const PhoneArrowInFilledSize16 = /* #__PURE__*/ hoc<'PhoneArrowInFilledSize16'>(
    PhoneArrowInFilledSize16Glyph,
    'PhoneArrowInFilledSize16'
);
export const MagnifierPlusFilledSize24 = /* #__PURE__*/ hoc<'MagnifierPlusFilledSize24'>(
    MagnifierPlusFilledSize24Glyph,
    'MagnifierPlusFilledSize24'
);
export const LiferingFilledSize24 = /* #__PURE__*/ hoc<'LiferingFilledSize24'>(
    LiferingFilledSize24Glyph,
    'LiferingFilledSize24'
);
export const CraneOutlinedSize24 = /* #__PURE__*/ hoc<'CraneOutlinedSize24'>(
    CraneOutlinedSize24Glyph,
    'CraneOutlinedSize24'
);
export const AntennaOutlinedSize16 = /* #__PURE__*/ hoc<'AntennaOutlinedSize16'>(
    AntennaOutlinedSize16Glyph,
    'AntennaOutlinedSize16'
);
export const PenLineFilledSize16 = /* #__PURE__*/ hoc<'PenLineFilledSize16'>(
    PenLineFilledSize16Glyph,
    'PenLineFilledSize16'
);
export const PhoneFilledSize24 = /* #__PURE__*/ hoc<'PhoneFilledSize24'>(PhoneFilledSize24Glyph, 'PhoneFilledSize24');
export const CardLinesEyeOutlinedSize24 = /* #__PURE__*/ hoc<'CardLinesEyeOutlinedSize24'>(
    CardLinesEyeOutlinedSize24Glyph,
    'CardLinesEyeOutlinedSize24'
);
export const SuperstarFilledSize24 = /* #__PURE__*/ hoc<'SuperstarFilledSize24'>(
    SuperstarFilledSize24Glyph,
    'SuperstarFilledSize24'
);
export const PhoneCrossOutlinedSize16 = /* #__PURE__*/ hoc<'PhoneCrossOutlinedSize16'>(
    PhoneCrossOutlinedSize16Glyph,
    'PhoneCrossOutlinedSize16'
);
export const PhoneFilledSize16 = /* #__PURE__*/ hoc<'PhoneFilledSize16'>(PhoneFilledSize16Glyph, 'PhoneFilledSize16');
export const CloudOutlinedSize24 = /* #__PURE__*/ hoc<'CloudOutlinedSize24'>(
    CloudOutlinedSize24Glyph,
    'CloudOutlinedSize24'
);
export const BagFilledSize24 = /* #__PURE__*/ hoc<'BagFilledSize24'>(BagFilledSize24Glyph, 'BagFilledSize24');
export const UserSinglePlusOutlinedSize24 = /* #__PURE__*/ hoc<'UserSinglePlusOutlinedSize24'>(
    UserSinglePlusOutlinedSize24Glyph,
    'UserSinglePlusOutlinedSize24'
);
export const MicCrossedFilledSize24 = /* #__PURE__*/ hoc<'MicCrossedFilledSize24'>(
    MicCrossedFilledSize24Glyph,
    'MicCrossedFilledSize24'
);
export const CraneOutlinedSize16 = /* #__PURE__*/ hoc<'CraneOutlinedSize16'>(
    CraneOutlinedSize16Glyph,
    'CraneOutlinedSize16'
);
export const PhoneCrossFilledSize24 = /* #__PURE__*/ hoc<'PhoneCrossFilledSize24'>(
    PhoneCrossFilledSize24Glyph,
    'PhoneCrossFilledSize24'
);
export const GraduationHatFilledSize16 = /* #__PURE__*/ hoc<'GraduationHatFilledSize16'>(
    GraduationHatFilledSize16Glyph,
    'GraduationHatFilledSize16'
);
export const DocumentFilledSize24 = /* #__PURE__*/ hoc<'DocumentFilledSize24'>(
    DocumentFilledSize24Glyph,
    'DocumentFilledSize24'
);
export const FunnelFilledSize24 = /* #__PURE__*/ hoc<'FunnelFilledSize24'>(
    FunnelFilledSize24Glyph,
    'FunnelFilledSize24'
);
export const LinkOutlinedSize16 = /* #__PURE__*/ hoc<'LinkOutlinedSize16'>(
    LinkOutlinedSize16Glyph,
    'LinkOutlinedSize16'
);
export const EmojiSmile3dSize24 = /* #__PURE__*/ hoc<'EmojiSmile3dSize24'>(
    EmojiSmile3dSize24Glyph,
    'EmojiSmile3dSize24'
);
export const LiferingOutlinedSize16 = /* #__PURE__*/ hoc<'LiferingOutlinedSize16'>(
    LiferingOutlinedSize16Glyph,
    'LiferingOutlinedSize16'
);
export const ChevronRightOutlinedSize24 = /* #__PURE__*/ hoc<'ChevronRightOutlinedSize24'>(
    ChevronRightOutlinedSize24Glyph,
    'ChevronRightOutlinedSize24'
);
export const FunnelFilledSize16 = /* #__PURE__*/ hoc<'FunnelFilledSize16'>(
    FunnelFilledSize16Glyph,
    'FunnelFilledSize16'
);
export const LinkOutlinedSize24 = /* #__PURE__*/ hoc<'LinkOutlinedSize24'>(
    LinkOutlinedSize24Glyph,
    'LinkOutlinedSize24'
);
export const ArrowDiagonalRightUpOutlinedSize24 = /* #__PURE__*/ hoc<'ArrowDiagonalRightUpOutlinedSize24'>(
    ArrowDiagonalRightUpOutlinedSize24Glyph,
    'ArrowDiagonalRightUpOutlinedSize24'
);
export const GearOutlinedSize16 = /* #__PURE__*/ hoc<'GearOutlinedSize16'>(
    GearOutlinedSize16Glyph,
    'GearOutlinedSize16'
);
export const GhostOutlinedSize16 = /* #__PURE__*/ hoc<'GhostOutlinedSize16'>(
    GhostOutlinedSize16Glyph,
    'GhostOutlinedSize16'
);
export const CardLinesFilledSize24 = /* #__PURE__*/ hoc<'CardLinesFilledSize24'>(
    CardLinesFilledSize24Glyph,
    'CardLinesFilledSize24'
);
export const ArrowDiagonalRightUpOutlinedSize16 = /* #__PURE__*/ hoc<'ArrowDiagonalRightUpOutlinedSize16'>(
    ArrowDiagonalRightUpOutlinedSize16Glyph,
    'ArrowDiagonalRightUpOutlinedSize16'
);
export const ArchiveboxArrowFilledSize16 = /* #__PURE__*/ hoc<'ArchiveboxArrowFilledSize16'>(
    ArchiveboxArrowFilledSize16Glyph,
    'ArchiveboxArrowFilledSize16'
);
export const ChevronUpOutlinedSize16 = /* #__PURE__*/ hoc<'ChevronUpOutlinedSize16'>(
    ChevronUpOutlinedSize16Glyph,
    'ChevronUpOutlinedSize16'
);
export const DocumentVerifiedOutlinedSize16 = /* #__PURE__*/ hoc<'DocumentVerifiedOutlinedSize16'>(
    DocumentVerifiedOutlinedSize16Glyph,
    'DocumentVerifiedOutlinedSize16'
);
export const ClockRewindOutlinedSize24 = /* #__PURE__*/ hoc<'ClockRewindOutlinedSize24'>(
    ClockRewindOutlinedSize24Glyph,
    'ClockRewindOutlinedSize24'
);
export const CrossCircleOutlinedSize24 = /* #__PURE__*/ hoc<'CrossCircleOutlinedSize24'>(
    CrossCircleOutlinedSize24Glyph,
    'CrossCircleOutlinedSize24'
);
export const FrameStarOutlinedSize16 = /* #__PURE__*/ hoc<'FrameStarOutlinedSize16'>(
    FrameStarOutlinedSize16Glyph,
    'FrameStarOutlinedSize16'
);
export const SafeOutlinedSize24 = /* #__PURE__*/ hoc<'SafeOutlinedSize24'>(
    SafeOutlinedSize24Glyph,
    'SafeOutlinedSize24'
);
export const ClockFilledSize32 = /* #__PURE__*/ hoc<'ClockFilledSize32'>(ClockFilledSize32Glyph, 'ClockFilledSize32');
export const SafeFilledSize16 = /* #__PURE__*/ hoc<'SafeFilledSize16'>(SafeFilledSize16Glyph, 'SafeFilledSize16');
export const BellFilledSize24 = /* #__PURE__*/ hoc<'BellFilledSize24'>(BellFilledSize24Glyph, 'BellFilledSize24');
export const ArchiveboxArrowOutlinedSize16 = /* #__PURE__*/ hoc<'ArchiveboxArrowOutlinedSize16'>(
    ArchiveboxArrowOutlinedSize16Glyph,
    'ArchiveboxArrowOutlinedSize16'
);
export const ArchiveboxArrowFilledSize24 = /* #__PURE__*/ hoc<'ArchiveboxArrowFilledSize24'>(
    ArchiveboxArrowFilledSize24Glyph,
    'ArchiveboxArrowFilledSize24'
);
export const ThumbDownFilledSize24 = /* #__PURE__*/ hoc<'ThumbDownFilledSize24'>(
    ThumbDownFilledSize24Glyph,
    'ThumbDownFilledSize24'
);
export const SquaresIntersectedOutlinedSize24 = /* #__PURE__*/ hoc<'SquaresIntersectedOutlinedSize24'>(
    SquaresIntersectedOutlinedSize24Glyph,
    'SquaresIntersectedOutlinedSize24'
);
export const FlagFilledSize24 = /* #__PURE__*/ hoc<'FlagFilledSize24'>(FlagFilledSize24Glyph, 'FlagFilledSize24');
export const ClockOutlinedSize32 = /* #__PURE__*/ hoc<'ClockOutlinedSize32'>(
    ClockOutlinedSize32Glyph,
    'ClockOutlinedSize32'
);
export const SafeOutlinedSize16 = /* #__PURE__*/ hoc<'SafeOutlinedSize16'>(
    SafeOutlinedSize16Glyph,
    'SafeOutlinedSize16'
);
export const ClockRewindOutlinedSize12 = /* #__PURE__*/ hoc<'ClockRewindOutlinedSize12'>(
    ClockRewindOutlinedSize12Glyph,
    'ClockRewindOutlinedSize12'
);
export const ClockFilledSize12 = /* #__PURE__*/ hoc<'ClockFilledSize12'>(ClockFilledSize12Glyph, 'ClockFilledSize12');
export const ClockOutlinedSize16 = /* #__PURE__*/ hoc<'ClockOutlinedSize16'>(
    ClockOutlinedSize16Glyph,
    'ClockOutlinedSize16'
);
export const ClockFilledSize24 = /* #__PURE__*/ hoc<'ClockFilledSize24'>(ClockFilledSize24Glyph, 'ClockFilledSize24');
export const GridOutlinedSize16 = /* #__PURE__*/ hoc<'GridOutlinedSize16'>(
    GridOutlinedSize16Glyph,
    'GridOutlinedSize16'
);
export const GridOutlinedSize24 = /* #__PURE__*/ hoc<'GridOutlinedSize24'>(
    GridOutlinedSize24Glyph,
    'GridOutlinedSize24'
);
export const CardLinesStackedCrossOutlinedSize16 = /* #__PURE__*/ hoc<'CardLinesStackedCrossOutlinedSize16'>(
    CardLinesStackedCrossOutlinedSize16Glyph,
    'CardLinesStackedCrossOutlinedSize16'
);
export const PopcornFilledSize24 = /* #__PURE__*/ hoc<'PopcornFilledSize24'>(
    PopcornFilledSize24Glyph,
    'PopcornFilledSize24'
);
export const BellCrossedFilledSize16 = /* #__PURE__*/ hoc<'BellCrossedFilledSize16'>(
    BellCrossedFilledSize16Glyph,
    'BellCrossedFilledSize16'
);
export const ExclamationTriangleFilledSize16 = /* #__PURE__*/ hoc<'ExclamationTriangleFilledSize16'>(
    ExclamationTriangleFilledSize16Glyph,
    'ExclamationTriangleFilledSize16'
);
export const ClockFilledSize16 = /* #__PURE__*/ hoc<'ClockFilledSize16'>(ClockFilledSize16Glyph, 'ClockFilledSize16');
export const CrossCircleOutlinedSize16 = /* #__PURE__*/ hoc<'CrossCircleOutlinedSize16'>(
    CrossCircleOutlinedSize16Glyph,
    'CrossCircleOutlinedSize16'
);
export const LightbulbOnOutlinedSize24 = /* #__PURE__*/ hoc<'LightbulbOnOutlinedSize24'>(
    LightbulbOnOutlinedSize24Glyph,
    'LightbulbOnOutlinedSize24'
);
export const LightbulbOnOutlinedSize16 = /* #__PURE__*/ hoc<'LightbulbOnOutlinedSize16'>(
    LightbulbOnOutlinedSize16Glyph,
    'LightbulbOnOutlinedSize16'
);
export const PlusOutlinedSize24 = /* #__PURE__*/ hoc<'PlusOutlinedSize24'>(
    PlusOutlinedSize24Glyph,
    'PlusOutlinedSize24'
);
export const VerifiedBadgeFilledSize12 = /* #__PURE__*/ hoc<'VerifiedBadgeFilledSize12'>(
    VerifiedBadgeFilledSize12Glyph,
    'VerifiedBadgeFilledSize12'
);
export const MagnifierOutlinedHeartOutlinedSize16 = /* #__PURE__*/ hoc<'MagnifierOutlinedHeartOutlinedSize16'>(
    MagnifierOutlinedHeartOutlinedSize16Glyph,
    'MagnifierOutlinedHeartOutlinedSize16'
);
export const HieroglyphLetterOutlinedSize16 = /* #__PURE__*/ hoc<'HieroglyphLetterOutlinedSize16'>(
    HieroglyphLetterOutlinedSize16Glyph,
    'HieroglyphLetterOutlinedSize16'
);
export const VerifiedBadgeFilledSize32 = /* #__PURE__*/ hoc<'VerifiedBadgeFilledSize32'>(
    VerifiedBadgeFilledSize32Glyph,
    'VerifiedBadgeFilledSize32'
);
export const CalendarOutlinedSize24 = /* #__PURE__*/ hoc<'CalendarOutlinedSize24'>(
    CalendarOutlinedSize24Glyph,
    'CalendarOutlinedSize24'
);
export const MagnifierPlusOutlinedSize24 = /* #__PURE__*/ hoc<'MagnifierPlusOutlinedSize24'>(
    MagnifierPlusOutlinedSize24Glyph,
    'MagnifierPlusOutlinedSize24'
);
export const HieroglyphLetterOutlinedSize24 = /* #__PURE__*/ hoc<'HieroglyphLetterOutlinedSize24'>(
    HieroglyphLetterOutlinedSize24Glyph,
    'HieroglyphLetterOutlinedSize24'
);
export const ImageStackOutlinedSize24 = /* #__PURE__*/ hoc<'ImageStackOutlinedSize24'>(
    ImageStackOutlinedSize24Glyph,
    'ImageStackOutlinedSize24'
);
export const CheckDoubleOutlinedSize24 = /* #__PURE__*/ hoc<'CheckDoubleOutlinedSize24'>(
    CheckDoubleOutlinedSize24Glyph,
    'CheckDoubleOutlinedSize24'
);
export const ScooterFilledSize16 = /* #__PURE__*/ hoc<'ScooterFilledSize16'>(
    ScooterFilledSize16Glyph,
    'ScooterFilledSize16'
);
export const ScooterFilledSize24 = /* #__PURE__*/ hoc<'ScooterFilledSize24'>(
    ScooterFilledSize24Glyph,
    'ScooterFilledSize24'
);
export const SquareCircleFilledSize24 = /* #__PURE__*/ hoc<'SquareCircleFilledSize24'>(
    SquareCircleFilledSize24Glyph,
    'SquareCircleFilledSize24'
);
export const LockClosedFilledSize16 = /* #__PURE__*/ hoc<'LockClosedFilledSize16'>(
    LockClosedFilledSize16Glyph,
    'LockClosedFilledSize16'
);
export const FlaskFilledSize16 = /* #__PURE__*/ hoc<'FlaskFilledSize16'>(FlaskFilledSize16Glyph, 'FlaskFilledSize16');
export const EyeOutlinedSize24 = /* #__PURE__*/ hoc<'EyeOutlinedSize24'>(EyeOutlinedSize24Glyph, 'EyeOutlinedSize24');
export const ChevronWide2OutlinedSize16 = /* #__PURE__*/ hoc<'ChevronWide2OutlinedSize16'>(
    ChevronWide2OutlinedSize16Glyph,
    'ChevronWide2OutlinedSize16'
);
export const EnvelopeOpenedOutlinedSize24 = /* #__PURE__*/ hoc<'EnvelopeOpenedOutlinedSize24'>(
    EnvelopeOpenedOutlinedSize24Glyph,
    'EnvelopeOpenedOutlinedSize24'
);
export const FlameOutlinedSize32 = /* #__PURE__*/ hoc<'FlameOutlinedSize32'>(
    FlameOutlinedSize32Glyph,
    'FlameOutlinedSize32'
);
export const EyeOutlinedSize16 = /* #__PURE__*/ hoc<'EyeOutlinedSize16'>(EyeOutlinedSize16Glyph, 'EyeOutlinedSize16');
export const RadiusOutlinedSize24 = /* #__PURE__*/ hoc<'RadiusOutlinedSize24'>(
    RadiusOutlinedSize24Glyph,
    'RadiusOutlinedSize24'
);
export const SquareCircleFilledSize16 = /* #__PURE__*/ hoc<'SquareCircleFilledSize16'>(
    SquareCircleFilledSize16Glyph,
    'SquareCircleFilledSize16'
);
export const VerifiedBadgeFilledSize24 = /* #__PURE__*/ hoc<'VerifiedBadgeFilledSize24'>(
    VerifiedBadgeFilledSize24Glyph,
    'VerifiedBadgeFilledSize24'
);
export const LocationFilledSize32 = /* #__PURE__*/ hoc<'LocationFilledSize32'>(
    LocationFilledSize32Glyph,
    'LocationFilledSize32'
);
export const VerifiedBadgeFilledSize16 = /* #__PURE__*/ hoc<'VerifiedBadgeFilledSize16'>(
    VerifiedBadgeFilledSize16Glyph,
    'VerifiedBadgeFilledSize16'
);
export const BicycleOutlinedSize24 = /* #__PURE__*/ hoc<'BicycleOutlinedSize24'>(
    BicycleOutlinedSize24Glyph,
    'BicycleOutlinedSize24'
);
export const FlaskFilledSize24 = /* #__PURE__*/ hoc<'FlaskFilledSize24'>(FlaskFilledSize24Glyph, 'FlaskFilledSize24');
export const ArrowRightOutlinedSize24 = /* #__PURE__*/ hoc<'ArrowRightOutlinedSize24'>(
    ArrowRightOutlinedSize24Glyph,
    'ArrowRightOutlinedSize24'
);
export const ChevronWide2OutlinedSize24 = /* #__PURE__*/ hoc<'ChevronWide2OutlinedSize24'>(
    ChevronWide2OutlinedSize24Glyph,
    'ChevronWide2OutlinedSize24'
);
export const MagnifierOutlinedHeartOutlinedSize24 = /* #__PURE__*/ hoc<'MagnifierOutlinedHeartOutlinedSize24'>(
    MagnifierOutlinedHeartOutlinedSize24Glyph,
    'MagnifierOutlinedHeartOutlinedSize24'
);
export const LocationFilledSize16 = /* #__PURE__*/ hoc<'LocationFilledSize16'>(
    LocationFilledSize16Glyph,
    'LocationFilledSize16'
);
export const ClipOutlinedSize24 = /* #__PURE__*/ hoc<'ClipOutlinedSize24'>(
    ClipOutlinedSize24Glyph,
    'ClipOutlinedSize24'
);
export const CircleOutlinedSize16 = /* #__PURE__*/ hoc<'CircleOutlinedSize16'>(
    CircleOutlinedSize16Glyph,
    'CircleOutlinedSize16'
);
export const PrinterFilledSize24 = /* #__PURE__*/ hoc<'PrinterFilledSize24'>(
    PrinterFilledSize24Glyph,
    'PrinterFilledSize24'
);
export const EnvelopeOpenedFilledSize24 = /* #__PURE__*/ hoc<'EnvelopeOpenedFilledSize24'>(
    EnvelopeOpenedFilledSize24Glyph,
    'EnvelopeOpenedFilledSize24'
);
export const CrossOutlinedSize24 = /* #__PURE__*/ hoc<'CrossOutlinedSize24'>(
    CrossOutlinedSize24Glyph,
    'CrossOutlinedSize24'
);
export const VerifiedBadgeOutlinedSize12 = /* #__PURE__*/ hoc<'VerifiedBadgeOutlinedSize12'>(
    VerifiedBadgeOutlinedSize12Glyph,
    'VerifiedBadgeOutlinedSize12'
);
export const BarsOutlinedSize24 = /* #__PURE__*/ hoc<'BarsOutlinedSize24'>(
    BarsOutlinedSize24Glyph,
    'BarsOutlinedSize24'
);
export const AstrostarFilledSize16 = /* #__PURE__*/ hoc<'AstrostarFilledSize16'>(
    AstrostarFilledSize16Glyph,
    'AstrostarFilledSize16'
);
export const CardLinesStackedPlusOutlinedSize24 = /* #__PURE__*/ hoc<'CardLinesStackedPlusOutlinedSize24'>(
    CardLinesStackedPlusOutlinedSize24Glyph,
    'CardLinesStackedPlusOutlinedSize24'
);
export const ListOutlinedSize16 = /* #__PURE__*/ hoc<'ListOutlinedSize16'>(
    ListOutlinedSize16Glyph,
    'ListOutlinedSize16'
);
export const PenOutlinedSize16 = /* #__PURE__*/ hoc<'PenOutlinedSize16'>(PenOutlinedSize16Glyph, 'PenOutlinedSize16');
export const EmojiSmileOutlinedSize32 = /* #__PURE__*/ hoc<'EmojiSmileOutlinedSize32'>(
    EmojiSmileOutlinedSize32Glyph,
    'EmojiSmileOutlinedSize32'
);
export const EmojiSmileOutlinedSize16 = /* #__PURE__*/ hoc<'EmojiSmileOutlinedSize16'>(
    EmojiSmileOutlinedSize16Glyph,
    'EmojiSmileOutlinedSize16'
);
export const RocketFilledSize16 = /* #__PURE__*/ hoc<'RocketFilledSize16'>(
    RocketFilledSize16Glyph,
    'RocketFilledSize16'
);
export const CardLinesHeartOutlinedSize24 = /* #__PURE__*/ hoc<'CardLinesHeartOutlinedSize24'>(
    CardLinesHeartOutlinedSize24Glyph,
    'CardLinesHeartOutlinedSize24'
);
export const CardLinesHeartOutlinedSize16 = /* #__PURE__*/ hoc<'CardLinesHeartOutlinedSize16'>(
    CardLinesHeartOutlinedSize16Glyph,
    'CardLinesHeartOutlinedSize16'
);
export const CardLinesHeartFilledSize24 = /* #__PURE__*/ hoc<'CardLinesHeartFilledSize24'>(
    CardLinesHeartFilledSize24Glyph,
    'CardLinesHeartFilledSize24'
);
export const CardLinesHeartFilledSize16 = /* #__PURE__*/ hoc<'CardLinesHeartFilledSize16'>(
    CardLinesHeartFilledSize16Glyph,
    'CardLinesHeartFilledSize16'
);
export const PopcornFilledSize16 = /* #__PURE__*/ hoc<'PopcornFilledSize16'>(
    PopcornFilledSize16Glyph,
    'PopcornFilledSize16'
);
export const PopcornOutlinedSize24 = /* #__PURE__*/ hoc<'PopcornOutlinedSize24'>(
    PopcornOutlinedSize24Glyph,
    'PopcornOutlinedSize24'
);
export const PopcornOutlinedSize16 = /* #__PURE__*/ hoc<'PopcornOutlinedSize16'>(
    PopcornOutlinedSize16Glyph,
    'PopcornOutlinedSize16'
);
export const SunFilledSize24 = /* #__PURE__*/ hoc<'SunFilledSize24'>(SunFilledSize24Glyph, 'SunFilledSize24');
export const SunFilledSize16 = /* #__PURE__*/ hoc<'SunFilledSize16'>(SunFilledSize16Glyph, 'SunFilledSize16');
export const MoonStarFilledSize16 = /* #__PURE__*/ hoc<'MoonStarFilledSize16'>(
    MoonStarFilledSize16Glyph,
    'MoonStarFilledSize16'
);
export const MoonStarOutlinedSize16 = /* #__PURE__*/ hoc<'MoonStarOutlinedSize16'>(
    MoonStarOutlinedSize16Glyph,
    'MoonStarOutlinedSize16'
);
export const MoonStarOutlinedSize24 = /* #__PURE__*/ hoc<'MoonStarOutlinedSize24'>(
    MoonStarOutlinedSize24Glyph,
    'MoonStarOutlinedSize24'
);
export const BackwardOutlinedSize24 = /* #__PURE__*/ hoc<'BackwardOutlinedSize24'>(
    BackwardOutlinedSize24Glyph,
    'BackwardOutlinedSize24'
);
export const ForwardFilledSize16 = /* #__PURE__*/ hoc<'ForwardFilledSize16'>(
    ForwardFilledSize16Glyph,
    'ForwardFilledSize16'
);
export const ForwardFilledSize24 = /* #__PURE__*/ hoc<'ForwardFilledSize24'>(
    ForwardFilledSize24Glyph,
    'ForwardFilledSize24'
);
export const UserSingleBanOutlinedSize16 = /* #__PURE__*/ hoc<'UserSingleBanOutlinedSize16'>(
    UserSingleBanOutlinedSize16Glyph,
    'UserSingleBanOutlinedSize16'
);
export const UserSingleBanOutlinedSize24 = /* #__PURE__*/ hoc<'UserSingleBanOutlinedSize24'>(
    UserSingleBanOutlinedSize24Glyph,
    'UserSingleBanOutlinedSize24'
);
export const UserSingleBanFilledSize16 = /* #__PURE__*/ hoc<'UserSingleBanFilledSize16'>(
    UserSingleBanFilledSize16Glyph,
    'UserSingleBanFilledSize16'
);
export const UserSingleBanFilledSize24 = /* #__PURE__*/ hoc<'UserSingleBanFilledSize24'>(
    UserSingleBanFilledSize24Glyph,
    'UserSingleBanFilledSize24'
);
export const DashedSquareOutOutlinedSize24 = /* #__PURE__*/ hoc<'DashedSquareOutOutlinedSize24'>(
    DashedSquareOutOutlinedSize24Glyph,
    'DashedSquareOutOutlinedSize24'
);
export const DashedSquareOutOutlinedSize16 = /* #__PURE__*/ hoc<'DashedSquareOutOutlinedSize16'>(
    DashedSquareOutOutlinedSize16Glyph,
    'DashedSquareOutOutlinedSize16'
);
export const BusTaxiFilledSize24 = /* #__PURE__*/ hoc<'BusTaxiFilledSize24'>(
    BusTaxiFilledSize24Glyph,
    'BusTaxiFilledSize24'
);
export const BusTaxiFilledSize16 = /* #__PURE__*/ hoc<'BusTaxiFilledSize16'>(
    BusTaxiFilledSize16Glyph,
    'BusTaxiFilledSize16'
);
export const TrainFilledSize16 = /* #__PURE__*/ hoc<'TrainFilledSize16'>(TrainFilledSize16Glyph, 'TrainFilledSize16');
export const TramFilledSize16 = /* #__PURE__*/ hoc<'TramFilledSize16'>(TramFilledSize16Glyph, 'TramFilledSize16');
export const TrolleybusFilledSize16 = /* #__PURE__*/ hoc<'TrolleybusFilledSize16'>(
    TrolleybusFilledSize16Glyph,
    'TrolleybusFilledSize16'
);
export const TramFilledSize24 = /* #__PURE__*/ hoc<'TramFilledSize24'>(TramFilledSize24Glyph, 'TramFilledSize24');
export const SpeakerWaveFilledSize16 = /* #__PURE__*/ hoc<'SpeakerWaveFilledSize16'>(
    SpeakerWaveFilledSize16Glyph,
    'SpeakerWaveFilledSize16'
);
export const EmojiSadFilledSize16 = /* #__PURE__*/ hoc<'EmojiSadFilledSize16'>(
    EmojiSadFilledSize16Glyph,
    'EmojiSadFilledSize16'
);
export const ImageOutlinedSize32 = /* #__PURE__*/ hoc<'ImageOutlinedSize32'>(
    ImageOutlinedSize32Glyph,
    'ImageOutlinedSize32'
);
export const EmptySize48 = /* #__PURE__*/ hoc<'EmptySize48'>(EmptySize48Glyph, 'EmptySize48');
export const EmptySize32 = /* #__PURE__*/ hoc<'EmptySize32'>(EmptySize32Glyph, 'EmptySize32');
export const SmileFaceFilledSize16 = /* #__PURE__*/ hoc<'SmileFaceFilledSize16'>(
    SmileFaceFilledSize16Glyph,
    'SmileFaceFilledSize16'
);
export const ImageOutlinedSize48 = /* #__PURE__*/ hoc<'ImageOutlinedSize48'>(
    ImageOutlinedSize48Glyph,
    'ImageOutlinedSize48'
);
export const HyperstarSparkleFilledSize32 = /* #__PURE__*/ hoc<'HyperstarSparkleFilledSize32'>(
    HyperstarSparkleFilledSize32Glyph,
    'HyperstarSparkleFilledSize32'
);
export const SmileFaceFilledSize24 = /* #__PURE__*/ hoc<'SmileFaceFilledSize24'>(
    SmileFaceFilledSize24Glyph,
    'SmileFaceFilledSize24'
);
export const ImageOutlinedSize24 = /* #__PURE__*/ hoc<'ImageOutlinedSize24'>(
    ImageOutlinedSize24Glyph,
    'ImageOutlinedSize24'
);
export const HyperstarOutlinedSize48 = /* #__PURE__*/ hoc<'HyperstarOutlinedSize48'>(
    HyperstarOutlinedSize48Glyph,
    'HyperstarOutlinedSize48'
);
export const EmojiSadFilledSize32 = /* #__PURE__*/ hoc<'EmojiSadFilledSize32'>(
    EmojiSadFilledSize32Glyph,
    'EmojiSadFilledSize32'
);
export const ImageOutlinedSize16 = /* #__PURE__*/ hoc<'ImageOutlinedSize16'>(
    ImageOutlinedSize16Glyph,
    'ImageOutlinedSize16'
);
export const EmojiSadFilledSize24 = /* #__PURE__*/ hoc<'EmojiSadFilledSize24'>(
    EmojiSadFilledSize24Glyph,
    'EmojiSadFilledSize24'
);
export const EmptySize16 = /* #__PURE__*/ hoc<'EmptySize16'>(EmptySize16Glyph, 'EmptySize16');
export const EmptySize24 = /* #__PURE__*/ hoc<'EmptySize24'>(EmptySize24Glyph, 'EmptySize24');
export const HyperstarSparkleFilledSize48 = /* #__PURE__*/ hoc<'HyperstarSparkleFilledSize48'>(
    HyperstarSparkleFilledSize48Glyph,
    'HyperstarSparkleFilledSize48'
);
export const HyperstarOutlinedSize32 = /* #__PURE__*/ hoc<'HyperstarOutlinedSize32'>(
    HyperstarOutlinedSize32Glyph,
    'HyperstarOutlinedSize32'
);
export const HyperstarSparkleFilledSize24 = /* #__PURE__*/ hoc<'HyperstarSparkleFilledSize24'>(
    HyperstarSparkleFilledSize24Glyph,
    'HyperstarSparkleFilledSize24'
);
export const ImageFilledSize32 = /* #__PURE__*/ hoc<'ImageFilledSize32'>(ImageFilledSize32Glyph, 'ImageFilledSize32');
export const HyperstarOutlinedSize16 = /* #__PURE__*/ hoc<'HyperstarOutlinedSize16'>(
    HyperstarOutlinedSize16Glyph,
    'HyperstarOutlinedSize16'
);
export const ImageFilledSize24 = /* #__PURE__*/ hoc<'ImageFilledSize24'>(ImageFilledSize24Glyph, 'ImageFilledSize24');
export const ImageFilledSize48 = /* #__PURE__*/ hoc<'ImageFilledSize48'>(ImageFilledSize48Glyph, 'ImageFilledSize48');
export const HyperstarSparkleFilledSize16 = /* #__PURE__*/ hoc<'HyperstarSparkleFilledSize16'>(
    HyperstarSparkleFilledSize16Glyph,
    'HyperstarSparkleFilledSize16'
);
export const SmileFaceOutlinedSize24 = /* #__PURE__*/ hoc<'SmileFaceOutlinedSize24'>(
    SmileFaceOutlinedSize24Glyph,
    'SmileFaceOutlinedSize24'
);
export const EmptySize64 = /* #__PURE__*/ hoc<'EmptySize64'>(EmptySize64Glyph, 'EmptySize64');
export const HyperstarOutlinedSize24 = /* #__PURE__*/ hoc<'HyperstarOutlinedSize24'>(
    HyperstarOutlinedSize24Glyph,
    'HyperstarOutlinedSize24'
);
export const EmptySize96 = /* #__PURE__*/ hoc<'EmptySize96'>(EmptySize96Glyph, 'EmptySize96');
export const PlusOutlinedSize16 = /* #__PURE__*/ hoc<'PlusOutlinedSize16'>(
    PlusOutlinedSize16Glyph,
    'PlusOutlinedSize16'
);
export const TrolleyFilledSize24 = /* #__PURE__*/ hoc<'TrolleyFilledSize24'>(
    TrolleyFilledSize24Glyph,
    'TrolleyFilledSize24'
);
export const ImageStackFilledSizeSize4 = /* #__PURE__*/ hoc<'ImageStackFilledSizeSize4'>(
    ImageStackFilledSizeSize4Glyph,
    'ImageStackFilledSizeSize4'
);
export const SpeedometerOutlinedSize24 = /* #__PURE__*/ hoc<'SpeedometerOutlinedSize24'>(
    SpeedometerOutlinedSize24Glyph,
    'SpeedometerOutlinedSize24'
);
export const FolderHeartFilledSize24 = /* #__PURE__*/ hoc<'FolderHeartFilledSize24'>(
    FolderHeartFilledSize24Glyph,
    'FolderHeartFilledSize24'
);
export const EmojiSadOutlinedSize24 = /* #__PURE__*/ hoc<'EmojiSadOutlinedSize24'>(
    EmojiSadOutlinedSize24Glyph,
    'EmojiSadOutlinedSize24'
);
export const FrameStarFilledSize24 = /* #__PURE__*/ hoc<'FrameStarFilledSize24'>(
    FrameStarFilledSize24Glyph,
    'FrameStarFilledSize24'
);
export const LockOpenedOutlinedSize16 = /* #__PURE__*/ hoc<'LockOpenedOutlinedSize16'>(
    LockOpenedOutlinedSize16Glyph,
    'LockOpenedOutlinedSize16'
);
export const EmojiHalfsmileFilledSize32 = /* #__PURE__*/ hoc<'EmojiHalfsmileFilledSize32'>(
    EmojiHalfsmileFilledSize32Glyph,
    'EmojiHalfsmileFilledSize32'
);
export const MicCrossedOutlinedSize16 = /* #__PURE__*/ hoc<'MicCrossedOutlinedSize16'>(
    MicCrossedOutlinedSize16Glyph,
    'MicCrossedOutlinedSize16'
);
export const DocumentStarOutlinedSize16 = /* #__PURE__*/ hoc<'DocumentStarOutlinedSize16'>(
    DocumentStarOutlinedSize16Glyph,
    'DocumentStarOutlinedSize16'
);
export const SpeedometerFilledSize24 = /* #__PURE__*/ hoc<'SpeedometerFilledSize24'>(
    SpeedometerFilledSize24Glyph,
    'SpeedometerFilledSize24'
);
export const ImageHyperstarFilledSize24 = /* #__PURE__*/ hoc<'ImageHyperstarFilledSize24'>(
    ImageHyperstarFilledSize24Glyph,
    'ImageHyperstarFilledSize24'
);
export const EmojiSmileFilledSize24 = /* #__PURE__*/ hoc<'EmojiSmileFilledSize24'>(
    EmojiSmileFilledSize24Glyph,
    'EmojiSmileFilledSize24'
);
export const EmojiHalfsadFilledSize16 = /* #__PURE__*/ hoc<'EmojiHalfsadFilledSize16'>(
    EmojiHalfsadFilledSize16Glyph,
    'EmojiHalfsadFilledSize16'
);
export const SpeakerWaveFilledSize24 = /* #__PURE__*/ hoc<'SpeakerWaveFilledSize24'>(
    SpeakerWaveFilledSize24Glyph,
    'SpeakerWaveFilledSize24'
);
export const PriceTagFilledSize16 = /* #__PURE__*/ hoc<'PriceTagFilledSize16'>(
    PriceTagFilledSize16Glyph,
    'PriceTagFilledSize16'
);
export const FlaskOutlinedSize16 = /* #__PURE__*/ hoc<'FlaskOutlinedSize16'>(
    FlaskOutlinedSize16Glyph,
    'FlaskOutlinedSize16'
);
export const HyperstarSparkleOutlinedSize16 = /* #__PURE__*/ hoc<'HyperstarSparkleOutlinedSize16'>(
    HyperstarSparkleOutlinedSize16Glyph,
    'HyperstarSparkleOutlinedSize16'
);
export const PinFilledSize24 = /* #__PURE__*/ hoc<'PinFilledSize24'>(PinFilledSize24Glyph, 'PinFilledSize24');
export const EmojiSmileFilledSize16 = /* #__PURE__*/ hoc<'EmojiSmileFilledSize16'>(
    EmojiSmileFilledSize16Glyph,
    'EmojiSmileFilledSize16'
);
export const EmojiHalfsmileOutlinedSize16 = /* #__PURE__*/ hoc<'EmojiHalfsmileOutlinedSize16'>(
    EmojiHalfsmileOutlinedSize16Glyph,
    'EmojiHalfsmileOutlinedSize16'
);
export const EmojiHalfsmileFilledSize24 = /* #__PURE__*/ hoc<'EmojiHalfsmileFilledSize24'>(
    EmojiHalfsmileFilledSize24Glyph,
    'EmojiHalfsmileFilledSize24'
);
export const PlayOutlinedSize24 = /* #__PURE__*/ hoc<'PlayOutlinedSize24'>(
    PlayOutlinedSize24Glyph,
    'PlayOutlinedSize24'
);
export const MicCrossedOutlinedSize24 = /* #__PURE__*/ hoc<'MicCrossedOutlinedSize24'>(
    MicCrossedOutlinedSize24Glyph,
    'MicCrossedOutlinedSize24'
);
export const SpeakerCrossedFilledSize32 = /* #__PURE__*/ hoc<'SpeakerCrossedFilledSize32'>(
    SpeakerCrossedFilledSize32Glyph,
    'SpeakerCrossedFilledSize32'
);
export const LockOpenedOutlinedSize12 = /* #__PURE__*/ hoc<'LockOpenedOutlinedSize12'>(
    LockOpenedOutlinedSize12Glyph,
    'LockOpenedOutlinedSize12'
);
export const CubeOutlinedSize24 = /* #__PURE__*/ hoc<'CubeOutlinedSize24'>(
    CubeOutlinedSize24Glyph,
    'CubeOutlinedSize24'
);
export const SpeakerWaveOutlinedSize16 = /* #__PURE__*/ hoc<'SpeakerWaveOutlinedSize16'>(
    SpeakerWaveOutlinedSize16Glyph,
    'SpeakerWaveOutlinedSize16'
);
export const GamepadFilledSize16 = /* #__PURE__*/ hoc<'GamepadFilledSize16'>(
    GamepadFilledSize16Glyph,
    'GamepadFilledSize16'
);
export const PinFilledSize16 = /* #__PURE__*/ hoc<'PinFilledSize16'>(PinFilledSize16Glyph, 'PinFilledSize16');
export const ArrowsCrossOutlinedSize16 = /* #__PURE__*/ hoc<'ArrowsCrossOutlinedSize16'>(
    ArrowsCrossOutlinedSize16Glyph,
    'ArrowsCrossOutlinedSize16'
);
export const PriceTagOutlinedSize24 = /* #__PURE__*/ hoc<'PriceTagOutlinedSize24'>(
    PriceTagOutlinedSize24Glyph,
    'PriceTagOutlinedSize24'
);
export const EmojiHalfsmileOutlinedSize32 = /* #__PURE__*/ hoc<'EmojiHalfsmileOutlinedSize32'>(
    EmojiHalfsmileOutlinedSize32Glyph,
    'EmojiHalfsmileOutlinedSize32'
);
export const ShieldOutlinedSize16 = /* #__PURE__*/ hoc<'ShieldOutlinedSize16'>(
    ShieldOutlinedSize16Glyph,
    'ShieldOutlinedSize16'
);
export const CameraOutlinedSize24 = /* #__PURE__*/ hoc<'CameraOutlinedSize24'>(
    CameraOutlinedSize24Glyph,
    'CameraOutlinedSize24'
);
export const FrameStarFilledSize16 = /* #__PURE__*/ hoc<'FrameStarFilledSize16'>(
    FrameStarFilledSize16Glyph,
    'FrameStarFilledSize16'
);
export const ClocheFilledSize24 = /* #__PURE__*/ hoc<'ClocheFilledSize24'>(
    ClocheFilledSize24Glyph,
    'ClocheFilledSize24'
);
export const CartFilledSize16 = /* #__PURE__*/ hoc<'CartFilledSize16'>(CartFilledSize16Glyph, 'CartFilledSize16');
export const EmojiHalfsadFilledSize32 = /* #__PURE__*/ hoc<'EmojiHalfsadFilledSize32'>(
    EmojiHalfsadFilledSize32Glyph,
    'EmojiHalfsadFilledSize32'
);
export const ArrowDiagonalLeftUpOutlinedSize24 = /* #__PURE__*/ hoc<'ArrowDiagonalLeftUpOutlinedSize24'>(
    ArrowDiagonalLeftUpOutlinedSize24Glyph,
    'ArrowDiagonalLeftUpOutlinedSize24'
);
export const BookOutlinedSize24 = /* #__PURE__*/ hoc<'BookOutlinedSize24'>(
    BookOutlinedSize24Glyph,
    'BookOutlinedSize24'
);
export const EmojiHalfsmileOutlinedSize24 = /* #__PURE__*/ hoc<'EmojiHalfsmileOutlinedSize24'>(
    EmojiHalfsmileOutlinedSize24Glyph,
    'EmojiHalfsmileOutlinedSize24'
);
export const ChevronLeftSquareFilledSize16 = /* #__PURE__*/ hoc<'ChevronLeftSquareFilledSize16'>(
    ChevronLeftSquareFilledSize16Glyph,
    'ChevronLeftSquareFilledSize16'
);
export const EmojiNeutralOutlinedSize16 = /* #__PURE__*/ hoc<'EmojiNeutralOutlinedSize16'>(
    EmojiNeutralOutlinedSize16Glyph,
    'EmojiNeutralOutlinedSize16'
);
export const SpeakerCrossedOutlinedSize24 = /* #__PURE__*/ hoc<'SpeakerCrossedOutlinedSize24'>(
    SpeakerCrossedOutlinedSize24Glyph,
    'SpeakerCrossedOutlinedSize24'
);
export const BotFilledSize24 = /* #__PURE__*/ hoc<'BotFilledSize24'>(BotFilledSize24Glyph, 'BotFilledSize24');
export const EmojiHalfsadOutlinedSize24 = /* #__PURE__*/ hoc<'EmojiHalfsadOutlinedSize24'>(
    EmojiHalfsadOutlinedSize24Glyph,
    'EmojiHalfsadOutlinedSize24'
);
export const SpeedometerOutlinedSize16 = /* #__PURE__*/ hoc<'SpeedometerOutlinedSize16'>(
    SpeedometerOutlinedSize16Glyph,
    'SpeedometerOutlinedSize16'
);
export const BottleFilledSize16 = /* #__PURE__*/ hoc<'BottleFilledSize16'>(
    BottleFilledSize16Glyph,
    'BottleFilledSize16'
);
export const ArrowDiagonalLeftUpOutlinedSize16 = /* #__PURE__*/ hoc<'ArrowDiagonalLeftUpOutlinedSize16'>(
    ArrowDiagonalLeftUpOutlinedSize16Glyph,
    'ArrowDiagonalLeftUpOutlinedSize16'
);
export const BotFilledSize16 = /* #__PURE__*/ hoc<'BotFilledSize16'>(BotFilledSize16Glyph, 'BotFilledSize16');
export const KeyFilledSize16 = /* #__PURE__*/ hoc<'KeyFilledSize16'>(KeyFilledSize16Glyph, 'KeyFilledSize16');
export const EmojiHalfsadOutlinedSize32 = /* #__PURE__*/ hoc<'EmojiHalfsadOutlinedSize32'>(
    EmojiHalfsadOutlinedSize32Glyph,
    'EmojiHalfsadOutlinedSize32'
);
export const EmojiSmileFilledSize32 = /* #__PURE__*/ hoc<'EmojiSmileFilledSize32'>(
    EmojiSmileFilledSize32Glyph,
    'EmojiSmileFilledSize32'
);
export const BagPlusFilledSize16 = /* #__PURE__*/ hoc<'BagPlusFilledSize16'>(
    BagPlusFilledSize16Glyph,
    'BagPlusFilledSize16'
);
export const KeyFilledSize24 = /* #__PURE__*/ hoc<'KeyFilledSize24'>(KeyFilledSize24Glyph, 'KeyFilledSize24');
export const HyperstarSparkleOutlinedSize32 = /* #__PURE__*/ hoc<'HyperstarSparkleOutlinedSize32'>(
    HyperstarSparkleOutlinedSize32Glyph,
    'HyperstarSparkleOutlinedSize32'
);
export const PauseOutlinedSize16 = /* #__PURE__*/ hoc<'PauseOutlinedSize16'>(
    PauseOutlinedSize16Glyph,
    'PauseOutlinedSize16'
);
export const TrolleyFilledSize16 = /* #__PURE__*/ hoc<'TrolleyFilledSize16'>(
    TrolleyFilledSize16Glyph,
    'TrolleyFilledSize16'
);
export const EmojiHalfsmileFilledSize16 = /* #__PURE__*/ hoc<'EmojiHalfsmileFilledSize16'>(
    EmojiHalfsmileFilledSize16Glyph,
    'EmojiHalfsmileFilledSize16'
);
export const EmojiHalfsadFilledSize24 = /* #__PURE__*/ hoc<'EmojiHalfsadFilledSize24'>(
    EmojiHalfsadFilledSize24Glyph,
    'EmojiHalfsadFilledSize24'
);
export const KeyOutlinedSize16 = /* #__PURE__*/ hoc<'KeyOutlinedSize16'>(KeyOutlinedSize16Glyph, 'KeyOutlinedSize16');
export const DocumentStarOutlinedSize24 = /* #__PURE__*/ hoc<'DocumentStarOutlinedSize24'>(
    DocumentStarOutlinedSize24Glyph,
    'DocumentStarOutlinedSize24'
);
export const BagPlusFilledSize24 = /* #__PURE__*/ hoc<'BagPlusFilledSize24'>(
    BagPlusFilledSize24Glyph,
    'BagPlusFilledSize24'
);
export const PriceTagFilledSize24 = /* #__PURE__*/ hoc<'PriceTagFilledSize24'>(
    PriceTagFilledSize24Glyph,
    'PriceTagFilledSize24'
);
export const PlayFilledSize24 = /* #__PURE__*/ hoc<'PlayFilledSize24'>(PlayFilledSize24Glyph, 'PlayFilledSize24');
export const LockClosedOutlinedSize24 = /* #__PURE__*/ hoc<'LockClosedOutlinedSize24'>(
    LockClosedOutlinedSize24Glyph,
    'LockClosedOutlinedSize24'
);
export const SpeakerWaveOutlinedSize24 = /* #__PURE__*/ hoc<'SpeakerWaveOutlinedSize24'>(
    SpeakerWaveOutlinedSize24Glyph,
    'SpeakerWaveOutlinedSize24'
);
export const EmojiNeutralOutlinedSize32 = /* #__PURE__*/ hoc<'EmojiNeutralOutlinedSize32'>(
    EmojiNeutralOutlinedSize32Glyph,
    'EmojiNeutralOutlinedSize32'
);
export const SpeedometerFilledSize16 = /* #__PURE__*/ hoc<'SpeedometerFilledSize16'>(
    SpeedometerFilledSize16Glyph,
    'SpeedometerFilledSize16'
);
export const SpeakerCrossOutlinedSize24 = /* #__PURE__*/ hoc<'SpeakerCrossOutlinedSize24'>(
    SpeakerCrossOutlinedSize24Glyph,
    'SpeakerCrossOutlinedSize24'
);
export const CameraOutlinedSize16 = /* #__PURE__*/ hoc<'CameraOutlinedSize16'>(
    CameraOutlinedSize16Glyph,
    'CameraOutlinedSize16'
);
export const ShieldOutlinedSize24 = /* #__PURE__*/ hoc<'ShieldOutlinedSize24'>(
    ShieldOutlinedSize24Glyph,
    'ShieldOutlinedSize24'
);
export const CubeOutlinedSize16 = /* #__PURE__*/ hoc<'CubeOutlinedSize16'>(
    CubeOutlinedSize16Glyph,
    'CubeOutlinedSize16'
);
export const ImageStackFilledSize16 = /* #__PURE__*/ hoc<'ImageStackFilledSize16'>(
    ImageStackFilledSize16Glyph,
    'ImageStackFilledSize16'
);
export const CubeFilledSize24 = /* #__PURE__*/ hoc<'CubeFilledSize24'>(CubeFilledSize24Glyph, 'CubeFilledSize24');
export const PlayCircleOutlinedSize16 = /* #__PURE__*/ hoc<'PlayCircleOutlinedSize16'>(
    PlayCircleOutlinedSize16Glyph,
    'PlayCircleOutlinedSize16'
);
export const PauseOutlinedSize24 = /* #__PURE__*/ hoc<'PauseOutlinedSize24'>(
    PauseOutlinedSize24Glyph,
    'PauseOutlinedSize24'
);
export const DataflowOutlinedSize24 = /* #__PURE__*/ hoc<'DataflowOutlinedSize24'>(
    DataflowOutlinedSize24Glyph,
    'DataflowOutlinedSize24'
);
export const SpeakerCrossedFilledSize16 = /* #__PURE__*/ hoc<'SpeakerCrossedFilledSize16'>(
    SpeakerCrossedFilledSize16Glyph,
    'SpeakerCrossedFilledSize16'
);
export const ArrowsCrossOutlinedSize24 = /* #__PURE__*/ hoc<'ArrowsCrossOutlinedSize24'>(
    ArrowsCrossOutlinedSize24Glyph,
    'ArrowsCrossOutlinedSize24'
);
export const FolderHeartFilledSize16 = /* #__PURE__*/ hoc<'FolderHeartFilledSize16'>(
    FolderHeartFilledSize16Glyph,
    'FolderHeartFilledSize16'
);
export const CartOutlinedSize16 = /* #__PURE__*/ hoc<'CartOutlinedSize16'>(
    CartOutlinedSize16Glyph,
    'CartOutlinedSize16'
);
export const PlayFilledSize16 = /* #__PURE__*/ hoc<'PlayFilledSize16'>(PlayFilledSize16Glyph, 'PlayFilledSize16');
export const EmojiSadOutlinedSize16 = /* #__PURE__*/ hoc<'EmojiSadOutlinedSize16'>(
    EmojiSadOutlinedSize16Glyph,
    'EmojiSadOutlinedSize16'
);
export const KeyOutlinedSize24 = /* #__PURE__*/ hoc<'KeyOutlinedSize24'>(KeyOutlinedSize24Glyph, 'KeyOutlinedSize24');
export const FlaskOutlinedSize24 = /* #__PURE__*/ hoc<'FlaskOutlinedSize24'>(
    FlaskOutlinedSize24Glyph,
    'FlaskOutlinedSize24'
);
export const VideocameraFilledSize16 = /* #__PURE__*/ hoc<'VideocameraFilledSize16'>(
    VideocameraFilledSize16Glyph,
    'VideocameraFilledSize16'
);
export const HyperstarSparkleOutlinedSize48 = /* #__PURE__*/ hoc<'HyperstarSparkleOutlinedSize48'>(
    HyperstarSparkleOutlinedSize48Glyph,
    'HyperstarSparkleOutlinedSize48'
);
export const EmojiNeutralOutlinedSize24 = /* #__PURE__*/ hoc<'EmojiNeutralOutlinedSize24'>(
    EmojiNeutralOutlinedSize24Glyph,
    'EmojiNeutralOutlinedSize24'
);
export const SafeFilledSize24 = /* #__PURE__*/ hoc<'SafeFilledSize24'>(SafeFilledSize24Glyph, 'SafeFilledSize24');
export const EmojiHalfsadOutlinedSize16 = /* #__PURE__*/ hoc<'EmojiHalfsadOutlinedSize16'>(
    EmojiHalfsadOutlinedSize16Glyph,
    'EmojiHalfsadOutlinedSize16'
);
export const SpeakerCrossedFilledSize24 = /* #__PURE__*/ hoc<'SpeakerCrossedFilledSize24'>(
    SpeakerCrossedFilledSize24Glyph,
    'SpeakerCrossedFilledSize24'
);
export const CardLinesStackedPlusFilledSize24 = /* #__PURE__*/ hoc<'CardLinesStackedPlusFilledSize24'>(
    CardLinesStackedPlusFilledSize24Glyph,
    'CardLinesStackedPlusFilledSize24'
);
export const HyperstarSparkleOutlinedSize24 = /* #__PURE__*/ hoc<'HyperstarSparkleOutlinedSize24'>(
    HyperstarSparkleOutlinedSize24Glyph,
    'HyperstarSparkleOutlinedSize24'
);
export const ClocheFilledSize16 = /* #__PURE__*/ hoc<'ClocheFilledSize16'>(
    ClocheFilledSize16Glyph,
    'ClocheFilledSize16'
);
export const LockClosedOutlinedSize16 = /* #__PURE__*/ hoc<'LockClosedOutlinedSize16'>(
    LockClosedOutlinedSize16Glyph,
    'LockClosedOutlinedSize16'
);
export const PlayOutlinedSize16 = /* #__PURE__*/ hoc<'PlayOutlinedSize16'>(
    PlayOutlinedSize16Glyph,
    'PlayOutlinedSize16'
);
export const CartFilledSize24 = /* #__PURE__*/ hoc<'CartFilledSize24'>(CartFilledSize24Glyph, 'CartFilledSize24');
export const ClocheOutlinedSize16 = /* #__PURE__*/ hoc<'ClocheOutlinedSize16'>(
    ClocheOutlinedSize16Glyph,
    'ClocheOutlinedSize16'
);
export const RocketFilledSize24 = /* #__PURE__*/ hoc<'RocketFilledSize24'>(
    RocketFilledSize24Glyph,
    'RocketFilledSize24'
);
export const PlayCircleOutlinedSize24 = /* #__PURE__*/ hoc<'PlayCircleOutlinedSize24'>(
    PlayCircleOutlinedSize24Glyph,
    'PlayCircleOutlinedSize24'
);
export const PriceTagOutlinedSize16 = /* #__PURE__*/ hoc<'PriceTagOutlinedSize16'>(
    PriceTagOutlinedSize16Glyph,
    'PriceTagOutlinedSize16'
);
export const BottleFilledSize24 = /* #__PURE__*/ hoc<'BottleFilledSize24'>(
    BottleFilledSize24Glyph,
    'BottleFilledSize24'
);
export const CardLinesStackedPlusFilledSize16 = /* #__PURE__*/ hoc<'CardLinesStackedPlusFilledSize16'>(
    CardLinesStackedPlusFilledSize16Glyph,
    'CardLinesStackedPlusFilledSize16'
);
export const CartOutlinedSize24 = /* #__PURE__*/ hoc<'CartOutlinedSize24'>(
    CartOutlinedSize24Glyph,
    'CartOutlinedSize24'
);
export const VideocameraFilledSize32 = /* #__PURE__*/ hoc<'VideocameraFilledSize32'>(
    VideocameraFilledSize32Glyph,
    'VideocameraFilledSize32'
);
export const GamepadFilledSize24 = /* #__PURE__*/ hoc<'GamepadFilledSize24'>(
    GamepadFilledSize24Glyph,
    'GamepadFilledSize24'
);
export const VideocameraFilledSize24 = /* #__PURE__*/ hoc<'VideocameraFilledSize24'>(
    VideocameraFilledSize24Glyph,
    'VideocameraFilledSize24'
);
export const SpeakerCrossedOutlinedSize16 = /* #__PURE__*/ hoc<'SpeakerCrossedOutlinedSize16'>(
    SpeakerCrossedOutlinedSize16Glyph,
    'SpeakerCrossedOutlinedSize16'
);
export const LockClosedOutlinedSize12 = /* #__PURE__*/ hoc<'LockClosedOutlinedSize12'>(
    LockClosedOutlinedSize12Glyph,
    'LockClosedOutlinedSize12'
);
export const CubeFilledSize16 = /* #__PURE__*/ hoc<'CubeFilledSize16'>(CubeFilledSize16Glyph, 'CubeFilledSize16');
export const ImageHyperstarFilledSize16 = /* #__PURE__*/ hoc<'ImageHyperstarFilledSize16'>(
    ImageHyperstarFilledSize16Glyph,
    'ImageHyperstarFilledSize16'
);
export const LineArrowRightEnterOutlinedSize24 = /* #__PURE__*/ hoc<'LineArrowRightEnterOutlinedSize24'>(
    LineArrowRightEnterOutlinedSize24Glyph,
    'LineArrowRightEnterOutlinedSize24'
);
export const UserOutlinedSize16 = /* #__PURE__*/ hoc<'UserOutlinedSize16'>(
    UserOutlinedSize16Glyph,
    'UserOutlinedSize16'
);
export const IngotsFilledSize16 = /* #__PURE__*/ hoc<'IngotsFilledSize16'>(
    IngotsFilledSize16Glyph,
    'IngotsFilledSize16'
);
export const GlobeOutlinedSize24 = /* #__PURE__*/ hoc<'GlobeOutlinedSize24'>(
    GlobeOutlinedSize24Glyph,
    'GlobeOutlinedSize24'
);
export const PhoneWaveOutlinedSize24 = /* #__PURE__*/ hoc<'PhoneWaveOutlinedSize24'>(
    PhoneWaveOutlinedSize24Glyph,
    'PhoneWaveOutlinedSize24'
);
export const FolderOutlinedSize24 = /* #__PURE__*/ hoc<'FolderOutlinedSize24'>(
    FolderOutlinedSize24Glyph,
    'FolderOutlinedSize24'
);
export const CardLinesEyeOutlinedSize16 = /* #__PURE__*/ hoc<'CardLinesEyeOutlinedSize16'>(
    CardLinesEyeOutlinedSize16Glyph,
    'CardLinesEyeOutlinedSize16'
);
export const SunOutlinedSize24 = /* #__PURE__*/ hoc<'SunOutlinedSize24'>(SunOutlinedSize24Glyph, 'SunOutlinedSize24');
export const PhoneArrowInOutlinedSize16 = /* #__PURE__*/ hoc<'PhoneArrowInOutlinedSize16'>(
    PhoneArrowInOutlinedSize16Glyph,
    'PhoneArrowInOutlinedSize16'
);
export const GraduationHatFilledSize32 = /* #__PURE__*/ hoc<'GraduationHatFilledSize32'>(
    GraduationHatFilledSize32Glyph,
    'GraduationHatFilledSize32'
);
export const HumanCircleFilledSize24 = /* #__PURE__*/ hoc<'HumanCircleFilledSize24'>(
    HumanCircleFilledSize24Glyph,
    'HumanCircleFilledSize24'
);
export const BuildingOutlinedSize24 = /* #__PURE__*/ hoc<'BuildingOutlinedSize24'>(
    BuildingOutlinedSize24Glyph,
    'BuildingOutlinedSize24'
);
export const ListShortOutlinedSize24 = /* #__PURE__*/ hoc<'ListShortOutlinedSize24'>(
    ListShortOutlinedSize24Glyph,
    'ListShortOutlinedSize24'
);
export const CraneFilledSize24 = /* #__PURE__*/ hoc<'CraneFilledSize24'>(CraneFilledSize24Glyph, 'CraneFilledSize24');
export const EmojiNeutralFilledSize16 = /* #__PURE__*/ hoc<'EmojiNeutralFilledSize16'>(
    EmojiNeutralFilledSize16Glyph,
    'EmojiNeutralFilledSize16'
);
export const MagnifierPlusFilledSize16 = /* #__PURE__*/ hoc<'MagnifierPlusFilledSize16'>(
    MagnifierPlusFilledSize16Glyph,
    'MagnifierPlusFilledSize16'
);
export const CarFilledSize24 = /* #__PURE__*/ hoc<'CarFilledSize24'>(CarFilledSize24Glyph, 'CarFilledSize24');
export const PhoneWaveOutlinedSize16 = /* #__PURE__*/ hoc<'PhoneWaveOutlinedSize16'>(
    PhoneWaveOutlinedSize16Glyph,
    'PhoneWaveOutlinedSize16'
);
export const PhoneDownOutlinedSize24 = /* #__PURE__*/ hoc<'PhoneDownOutlinedSize24'>(
    PhoneDownOutlinedSize24Glyph,
    'PhoneDownOutlinedSize24'
);
export const TramOutlinedSize24 = /* #__PURE__*/ hoc<'TramOutlinedSize24'>(
    TramOutlinedSize24Glyph,
    'TramOutlinedSize24'
);
export const SunOutlinedSize16 = /* #__PURE__*/ hoc<'SunOutlinedSize16'>(SunOutlinedSize16Glyph, 'SunOutlinedSize16');
export const ConstructionHatOutlinedSize24 = /* #__PURE__*/ hoc<'ConstructionHatOutlinedSize24'>(
    ConstructionHatOutlinedSize24Glyph,
    'ConstructionHatOutlinedSize24'
);
export const PhoneOutlinedSize24 = /* #__PURE__*/ hoc<'PhoneOutlinedSize24'>(
    PhoneOutlinedSize24Glyph,
    'PhoneOutlinedSize24'
);
export const MicCrossedFilledSize16 = /* #__PURE__*/ hoc<'MicCrossedFilledSize16'>(
    MicCrossedFilledSize16Glyph,
    'MicCrossedFilledSize16'
);
export const PhoneArrowOutFilledSize24 = /* #__PURE__*/ hoc<'PhoneArrowOutFilledSize24'>(
    PhoneArrowOutFilledSize24Glyph,
    'PhoneArrowOutFilledSize24'
);
export const BuildingOutlinedSize16 = /* #__PURE__*/ hoc<'BuildingOutlinedSize16'>(
    BuildingOutlinedSize16Glyph,
    'BuildingOutlinedSize16'
);
export const ChevronRightSquareOutlinedSize24 = /* #__PURE__*/ hoc<'ChevronRightSquareOutlinedSize24'>(
    ChevronRightSquareOutlinedSize24Glyph,
    'ChevronRightSquareOutlinedSize24'
);
export const MegaphoneFilledSize16 = /* #__PURE__*/ hoc<'MegaphoneFilledSize16'>(
    MegaphoneFilledSize16Glyph,
    'MegaphoneFilledSize16'
);
export const HumanCircleOutlinedSize24 = /* #__PURE__*/ hoc<'HumanCircleOutlinedSize24'>(
    HumanCircleOutlinedSize24Glyph,
    'HumanCircleOutlinedSize24'
);
export const PhoneArrowOutOutlinedSize24 = /* #__PURE__*/ hoc<'PhoneArrowOutOutlinedSize24'>(
    PhoneArrowOutOutlinedSize24Glyph,
    'PhoneArrowOutOutlinedSize24'
);
export const CloudFilledSize16 = /* #__PURE__*/ hoc<'CloudFilledSize16'>(CloudFilledSize16Glyph, 'CloudFilledSize16');
export const MegaphoneFilledSize24 = /* #__PURE__*/ hoc<'MegaphoneFilledSize24'>(
    MegaphoneFilledSize24Glyph,
    'MegaphoneFilledSize24'
);
export const PhoneWaveFilledSize24 = /* #__PURE__*/ hoc<'PhoneWaveFilledSize24'>(
    PhoneWaveFilledSize24Glyph,
    'PhoneWaveFilledSize24'
);
export const GraduationHatFilledSize24 = /* #__PURE__*/ hoc<'GraduationHatFilledSize24'>(
    GraduationHatFilledSize24Glyph,
    'GraduationHatFilledSize24'
);
export const AntennaOutlinedSize24 = /* #__PURE__*/ hoc<'AntennaOutlinedSize24'>(
    AntennaOutlinedSize24Glyph,
    'AntennaOutlinedSize24'
);
export const PhoneArrowInOutlinedSize24 = /* #__PURE__*/ hoc<'PhoneArrowInOutlinedSize24'>(
    PhoneArrowInOutlinedSize24Glyph,
    'PhoneArrowInOutlinedSize24'
);
export const IngotsFilledSize24 = /* #__PURE__*/ hoc<'IngotsFilledSize24'>(
    IngotsFilledSize24Glyph,
    'IngotsFilledSize24'
);
export const CloudFilledSize24 = /* #__PURE__*/ hoc<'CloudFilledSize24'>(CloudFilledSize24Glyph, 'CloudFilledSize24');
export const CraneFilledSize16 = /* #__PURE__*/ hoc<'CraneFilledSize16'>(CraneFilledSize16Glyph, 'CraneFilledSize16');
export const IngotsOutlinedSize24 = /* #__PURE__*/ hoc<'IngotsOutlinedSize24'>(
    IngotsOutlinedSize24Glyph,
    'IngotsOutlinedSize24'
);
export const HumanCircleOutlinedSize16 = /* #__PURE__*/ hoc<'HumanCircleOutlinedSize16'>(
    HumanCircleOutlinedSize16Glyph,
    'HumanCircleOutlinedSize16'
);
export const HeadsetFilledSize16 = /* #__PURE__*/ hoc<'HeadsetFilledSize16'>(
    HeadsetFilledSize16Glyph,
    'HeadsetFilledSize16'
);
export const ConstructionHatFilledSize16 = /* #__PURE__*/ hoc<'ConstructionHatFilledSize16'>(
    ConstructionHatFilledSize16Glyph,
    'ConstructionHatFilledSize16'
);
export const CarOutlinedSize24 = /* #__PURE__*/ hoc<'CarOutlinedSize24'>(CarOutlinedSize24Glyph, 'CarOutlinedSize24');
export const PenFilledSize16 = /* #__PURE__*/ hoc<'PenFilledSize16'>(PenFilledSize16Glyph, 'PenFilledSize16');
export const CloudOutlinedSize16 = /* #__PURE__*/ hoc<'CloudOutlinedSize16'>(
    CloudOutlinedSize16Glyph,
    'CloudOutlinedSize16'
);
export const SmartphoneFilledSize16 = /* #__PURE__*/ hoc<'SmartphoneFilledSize16'>(
    SmartphoneFilledSize16Glyph,
    'SmartphoneFilledSize16'
);
export const GiftOutlinedSize24 = /* #__PURE__*/ hoc<'GiftOutlinedSize24'>(
    GiftOutlinedSize24Glyph,
    'GiftOutlinedSize24'
);
export const BoxFilledSize16 = /* #__PURE__*/ hoc<'BoxFilledSize16'>(BoxFilledSize16Glyph, 'BoxFilledSize16');
export const PhoneOutlinedSize16 = /* #__PURE__*/ hoc<'PhoneOutlinedSize16'>(
    PhoneOutlinedSize16Glyph,
    'PhoneOutlinedSize16'
);
export const ThumbUpFilledSize16 = /* #__PURE__*/ hoc<'ThumbUpFilledSize16'>(
    ThumbUpFilledSize16Glyph,
    'ThumbUpFilledSize16'
);
export const ThumbUpFilledSize24 = /* #__PURE__*/ hoc<'ThumbUpFilledSize24'>(
    ThumbUpFilledSize24Glyph,
    'ThumbUpFilledSize24'
);
export const PenFilledSize24 = /* #__PURE__*/ hoc<'PenFilledSize24'>(PenFilledSize24Glyph, 'PenFilledSize24');
export const CheckOutlinedSize16 = /* #__PURE__*/ hoc<'CheckOutlinedSize16'>(
    CheckOutlinedSize16Glyph,
    'CheckOutlinedSize16'
);
export const SuperstarFilledSize16 = /* #__PURE__*/ hoc<'SuperstarFilledSize16'>(
    SuperstarFilledSize16Glyph,
    'SuperstarFilledSize16'
);
export const IngotsOutlinedSize16 = /* #__PURE__*/ hoc<'IngotsOutlinedSize16'>(
    IngotsOutlinedSize16Glyph,
    'IngotsOutlinedSize16'
);
export const TrolleybusOutlinedSize24 = /* #__PURE__*/ hoc<'TrolleybusOutlinedSize24'>(
    TrolleybusOutlinedSize24Glyph,
    'TrolleybusOutlinedSize24'
);
export const ConstructionHatOutlinedSize16 = /* #__PURE__*/ hoc<'ConstructionHatOutlinedSize16'>(
    ConstructionHatOutlinedSize16Glyph,
    'ConstructionHatOutlinedSize16'
);
export const BusFilledSize24 = /* #__PURE__*/ hoc<'BusFilledSize24'>(BusFilledSize24Glyph, 'BusFilledSize24');
export const HumanCircleFilledSize16 = /* #__PURE__*/ hoc<'HumanCircleFilledSize16'>(
    HumanCircleFilledSize16Glyph,
    'HumanCircleFilledSize16'
);
export const CheckOutlinedSize12 = /* #__PURE__*/ hoc<'CheckOutlinedSize12'>(
    CheckOutlinedSize12Glyph,
    'CheckOutlinedSize12'
);
export const ComputerOutlinedSize16 = /* #__PURE__*/ hoc<'ComputerOutlinedSize16'>(
    ComputerOutlinedSize16Glyph,
    'ComputerOutlinedSize16'
);
export const SmartphoneFilledSize24 = /* #__PURE__*/ hoc<'SmartphoneFilledSize24'>(
    SmartphoneFilledSize24Glyph,
    'SmartphoneFilledSize24'
);
export const UserOutlinedSize24 = /* #__PURE__*/ hoc<'UserOutlinedSize24'>(
    UserOutlinedSize24Glyph,
    'UserOutlinedSize24'
);
export const PhoneArrowOutFilledSize16 = /* #__PURE__*/ hoc<'PhoneArrowOutFilledSize16'>(
    PhoneArrowOutFilledSize16Glyph,
    'PhoneArrowOutFilledSize16'
);
export const CarOutlinedSize16 = /* #__PURE__*/ hoc<'CarOutlinedSize16'>(CarOutlinedSize16Glyph, 'CarOutlinedSize16');
export const BusFilledSize16 = /* #__PURE__*/ hoc<'BusFilledSize16'>(BusFilledSize16Glyph, 'BusFilledSize16');
export const LiferingFilledSize16 = /* #__PURE__*/ hoc<'LiferingFilledSize16'>(
    LiferingFilledSize16Glyph,
    'LiferingFilledSize16'
);
export const GlobeOutlinedSize16 = /* #__PURE__*/ hoc<'GlobeOutlinedSize16'>(
    GlobeOutlinedSize16Glyph,
    'GlobeOutlinedSize16'
);
export const BagFilledSize16 = /* #__PURE__*/ hoc<'BagFilledSize16'>(BagFilledSize16Glyph, 'BagFilledSize16');
export const BusOutlinedSize16 = /* #__PURE__*/ hoc<'BusOutlinedSize16'>(BusOutlinedSize16Glyph, 'BusOutlinedSize16');
export const DocumentFilledSize32 = /* #__PURE__*/ hoc<'DocumentFilledSize32'>(
    DocumentFilledSize32Glyph,
    'DocumentFilledSize32'
);
export const PenFilledSize12 = /* #__PURE__*/ hoc<'PenFilledSize12'>(PenFilledSize12Glyph, 'PenFilledSize12');
export const EmojiNeutralFilledSize32 = /* #__PURE__*/ hoc<'EmojiNeutralFilledSize32'>(
    EmojiNeutralFilledSize32Glyph,
    'EmojiNeutralFilledSize32'
);
export const PhoneWaveFilledSize16 = /* #__PURE__*/ hoc<'PhoneWaveFilledSize16'>(
    PhoneWaveFilledSize16Glyph,
    'PhoneWaveFilledSize16'
);
export const LineArrowRightEnterOutlinedSize16 = /* #__PURE__*/ hoc<'LineArrowRightEnterOutlinedSize16'>(
    LineArrowRightEnterOutlinedSize16Glyph,
    'LineArrowRightEnterOutlinedSize16'
);
export const CheckOutlinedSize24 = /* #__PURE__*/ hoc<'CheckOutlinedSize24'>(
    CheckOutlinedSize24Glyph,
    'CheckOutlinedSize24'
);
export const PhoneDownOutlinedSize16 = /* #__PURE__*/ hoc<'PhoneDownOutlinedSize16'>(
    PhoneDownOutlinedSize16Glyph,
    'PhoneDownOutlinedSize16'
);
export const HeadsetFilledSize24 = /* #__PURE__*/ hoc<'HeadsetFilledSize24'>(
    HeadsetFilledSize24Glyph,
    'HeadsetFilledSize24'
);
export const TramOutlinedSize16 = /* #__PURE__*/ hoc<'TramOutlinedSize16'>(
    TramOutlinedSize16Glyph,
    'TramOutlinedSize16'
);
export const PhoneArrowInFilledSize24 = /* #__PURE__*/ hoc<'PhoneArrowInFilledSize24'>(
    PhoneArrowInFilledSize24Glyph,
    'PhoneArrowInFilledSize24'
);
export const DocumentFilledSize16 = /* #__PURE__*/ hoc<'DocumentFilledSize16'>(
    DocumentFilledSize16Glyph,
    'DocumentFilledSize16'
);
export const UserDoubleOutlinedSize24 = /* #__PURE__*/ hoc<'UserDoubleOutlinedSize24'>(
    UserDoubleOutlinedSize24Glyph,
    'UserDoubleOutlinedSize24'
);
export const ChevronRightSquareOutlinedSize16 = /* #__PURE__*/ hoc<'ChevronRightSquareOutlinedSize16'>(
    ChevronRightSquareOutlinedSize16Glyph,
    'ChevronRightSquareOutlinedSize16'
);
export const GlobeFilledSize24 = /* #__PURE__*/ hoc<'GlobeFilledSize24'>(GlobeFilledSize24Glyph, 'GlobeFilledSize24');
export const TrolleybusOutlinedSize16 = /* #__PURE__*/ hoc<'TrolleybusOutlinedSize16'>(
    TrolleybusOutlinedSize16Glyph,
    'TrolleybusOutlinedSize16'
);
export const UserDoubleOutlinedSize16 = /* #__PURE__*/ hoc<'UserDoubleOutlinedSize16'>(
    UserDoubleOutlinedSize16Glyph,
    'UserDoubleOutlinedSize16'
);
export const EmojiNeutralFilledSize24 = /* #__PURE__*/ hoc<'EmojiNeutralFilledSize24'>(
    EmojiNeutralFilledSize24Glyph,
    'EmojiNeutralFilledSize24'
);
export const PrinterOutlinedSize16 = /* #__PURE__*/ hoc<'PrinterOutlinedSize16'>(
    PrinterOutlinedSize16Glyph,
    'PrinterOutlinedSize16'
);
export const PrinterOutlinedSize24 = /* #__PURE__*/ hoc<'PrinterOutlinedSize24'>(
    PrinterOutlinedSize24Glyph,
    'PrinterOutlinedSize24'
);
export const BubbleRoundDoubleFilledSize24 = /* #__PURE__*/ hoc<'BubbleRoundDoubleFilledSize24'>(
    BubbleRoundDoubleFilledSize24Glyph,
    'BubbleRoundDoubleFilledSize24'
);
export const CardLinesStackedCrossFilledSize16 = /* #__PURE__*/ hoc<'CardLinesStackedCrossFilledSize16'>(
    CardLinesStackedCrossFilledSize16Glyph,
    'CardLinesStackedCrossFilledSize16'
);
export const BubbleDotRoundOutlinedSize24 = /* #__PURE__*/ hoc<'BubbleDotRoundOutlinedSize24'>(
    BubbleDotRoundOutlinedSize24Glyph,
    'BubbleDotRoundOutlinedSize24'
);
export const BricksOutlinedSize16 = /* #__PURE__*/ hoc<'BricksOutlinedSize16'>(
    BricksOutlinedSize16Glyph,
    'BricksOutlinedSize16'
);
export const BriefcaseOutlinedSize16 = /* #__PURE__*/ hoc<'BriefcaseOutlinedSize16'>(
    BriefcaseOutlinedSize16Glyph,
    'BriefcaseOutlinedSize16'
);
export const GraduationHatOutlinedSize32 = /* #__PURE__*/ hoc<'GraduationHatOutlinedSize32'>(
    GraduationHatOutlinedSize32Glyph,
    'GraduationHatOutlinedSize32'
);
export const PinCrossedOutlinedSize24 = /* #__PURE__*/ hoc<'PinCrossedOutlinedSize24'>(
    PinCrossedOutlinedSize24Glyph,
    'PinCrossedOutlinedSize24'
);
export const EnvelopeFilledSize24 = /* #__PURE__*/ hoc<'EnvelopeFilledSize24'>(
    EnvelopeFilledSize24Glyph,
    'EnvelopeFilledSize24'
);
export const BagPlusOutlinedSize16 = /* #__PURE__*/ hoc<'BagPlusOutlinedSize16'>(
    BagPlusOutlinedSize16Glyph,
    'BagPlusOutlinedSize16'
);
export const WheatFilledSize16 = /* #__PURE__*/ hoc<'WheatFilledSize16'>(WheatFilledSize16Glyph, 'WheatFilledSize16');
export const PenSquareOutlinedSize16 = /* #__PURE__*/ hoc<'PenSquareOutlinedSize16'>(
    PenSquareOutlinedSize16Glyph,
    'PenSquareOutlinedSize16'
);
export const ScooterOutlinedSize16 = /* #__PURE__*/ hoc<'ScooterOutlinedSize16'>(
    ScooterOutlinedSize16Glyph,
    'ScooterOutlinedSize16'
);
export const BubbleRoundHyperstarFilledSize16 = /* #__PURE__*/ hoc<'BubbleRoundHyperstarFilledSize16'>(
    BubbleRoundHyperstarFilledSize16Glyph,
    'BubbleRoundHyperstarFilledSize16'
);
export const PenLineOutlinedSize24 = /* #__PURE__*/ hoc<'PenLineOutlinedSize24'>(
    PenLineOutlinedSize24Glyph,
    'PenLineOutlinedSize24'
);
export const BricksOutlinedSize24 = /* #__PURE__*/ hoc<'BricksOutlinedSize24'>(
    BricksOutlinedSize24Glyph,
    'BricksOutlinedSize24'
);
export const GraduationHatOutlinedSize16 = /* #__PURE__*/ hoc<'GraduationHatOutlinedSize16'>(
    GraduationHatOutlinedSize16Glyph,
    'GraduationHatOutlinedSize16'
);
export const BubbleDotRoundFilledSize16 = /* #__PURE__*/ hoc<'BubbleDotRoundFilledSize16'>(
    BubbleDotRoundFilledSize16Glyph,
    'BubbleDotRoundFilledSize16'
);
export const BubbleRoundHyperstarFilledSize24 = /* #__PURE__*/ hoc<'BubbleRoundHyperstarFilledSize24'>(
    BubbleRoundHyperstarFilledSize24Glyph,
    'BubbleRoundHyperstarFilledSize24'
);
export const BracketsOutlinedSize16 = /* #__PURE__*/ hoc<'BracketsOutlinedSize16'>(
    BracketsOutlinedSize16Glyph,
    'BracketsOutlinedSize16'
);
export const BubbleSquareFilledSize16 = /* #__PURE__*/ hoc<'BubbleSquareFilledSize16'>(
    BubbleSquareFilledSize16Glyph,
    'BubbleSquareFilledSize16'
);
export const CardLinesFilledSize16 = /* #__PURE__*/ hoc<'CardLinesFilledSize16'>(
    CardLinesFilledSize16Glyph,
    'CardLinesFilledSize16'
);
export const BubbleDotRoundOutlinedSize16 = /* #__PURE__*/ hoc<'BubbleDotRoundOutlinedSize16'>(
    BubbleDotRoundOutlinedSize16Glyph,
    'BubbleDotRoundOutlinedSize16'
);
export const ChartLineFilledSize16 = /* #__PURE__*/ hoc<'ChartLineFilledSize16'>(
    ChartLineFilledSize16Glyph,
    'ChartLineFilledSize16'
);
export const GearOutlinedSize24 = /* #__PURE__*/ hoc<'GearOutlinedSize24'>(
    GearOutlinedSize24Glyph,
    'GearOutlinedSize24'
);
export const EnvelopeOpenedFilledSize16 = /* #__PURE__*/ hoc<'EnvelopeOpenedFilledSize16'>(
    EnvelopeOpenedFilledSize16Glyph,
    'EnvelopeOpenedFilledSize16'
);
export const GraduationHatOutlinedSize24 = /* #__PURE__*/ hoc<'GraduationHatOutlinedSize24'>(
    GraduationHatOutlinedSize24Glyph,
    'GraduationHatOutlinedSize24'
);
export const ChevronRightOutlinedSize16 = /* #__PURE__*/ hoc<'ChevronRightOutlinedSize16'>(
    ChevronRightOutlinedSize16Glyph,
    'ChevronRightOutlinedSize16'
);
export const DropsFilledSize16 = /* #__PURE__*/ hoc<'DropsFilledSize16'>(DropsFilledSize16Glyph, 'DropsFilledSize16');
export const TrashOutlinedSize16 = /* #__PURE__*/ hoc<'TrashOutlinedSize16'>(
    TrashOutlinedSize16Glyph,
    'TrashOutlinedSize16'
);
export const EnvelopeOutlinedSize16 = /* #__PURE__*/ hoc<'EnvelopeOutlinedSize16'>(
    EnvelopeOutlinedSize16Glyph,
    'EnvelopeOutlinedSize16'
);
export const ThumbDownOutlinedSize16 = /* #__PURE__*/ hoc<'ThumbDownOutlinedSize16'>(
    ThumbDownOutlinedSize16Glyph,
    'ThumbDownOutlinedSize16'
);
export const BracketsOutlinedSize24 = /* #__PURE__*/ hoc<'BracketsOutlinedSize24'>(
    BracketsOutlinedSize24Glyph,
    'BracketsOutlinedSize24'
);
export const ChevronRightOutlinedSize12 = /* #__PURE__*/ hoc<'ChevronRightOutlinedSize12'>(
    ChevronRightOutlinedSize12Glyph,
    'ChevronRightOutlinedSize12'
);
export const MapFilledSize16 = /* #__PURE__*/ hoc<'MapFilledSize16'>(MapFilledSize16Glyph, 'MapFilledSize16');
export const BubbleSquareOutlinedSize16 = /* #__PURE__*/ hoc<'BubbleSquareOutlinedSize16'>(
    BubbleSquareOutlinedSize16Glyph,
    'BubbleSquareOutlinedSize16'
);
export const UserCircleFilledSize32 = /* #__PURE__*/ hoc<'UserCircleFilledSize32'>(
    UserCircleFilledSize32Glyph,
    'UserCircleFilledSize32'
);
export const CardLinesOutlinedSize16 = /* #__PURE__*/ hoc<'CardLinesOutlinedSize16'>(
    CardLinesOutlinedSize16Glyph,
    'CardLinesOutlinedSize16'
);
export const ScooterOutlinedSize24 = /* #__PURE__*/ hoc<'ScooterOutlinedSize24'>(
    ScooterOutlinedSize24Glyph,
    'ScooterOutlinedSize24'
);
export const CardLinesStackedCrossedFilledSize16 = /* #__PURE__*/ hoc<'CardLinesStackedCrossedFilledSize16'>(
    CardLinesStackedCrossedFilledSize16Glyph,
    'CardLinesStackedCrossedFilledSize16'
);
export const BubbleRoundDoubleFilledSize16 = /* #__PURE__*/ hoc<'BubbleRoundDoubleFilledSize16'>(
    BubbleRoundDoubleFilledSize16Glyph,
    'BubbleRoundDoubleFilledSize16'
);
export const BubbleSquareOutlinedSize24 = /* #__PURE__*/ hoc<'BubbleSquareOutlinedSize24'>(
    BubbleSquareOutlinedSize24Glyph,
    'BubbleSquareOutlinedSize24'
);
export const BubbleRoundOutlinedSize16 = /* #__PURE__*/ hoc<'BubbleRoundOutlinedSize16'>(
    BubbleRoundOutlinedSize16Glyph,
    'BubbleRoundOutlinedSize16'
);
export const CardLinesCrossedOutlinedSize24 = /* #__PURE__*/ hoc<'CardLinesCrossedOutlinedSize24'>(
    CardLinesCrossedOutlinedSize24Glyph,
    'CardLinesCrossedOutlinedSize24'
);
export const DataflowFilledSize24 = /* #__PURE__*/ hoc<'DataflowFilledSize24'>(
    DataflowFilledSize24Glyph,
    'DataflowFilledSize24'
);
export const CardLinesCrossFilledSize24 = /* #__PURE__*/ hoc<'CardLinesCrossFilledSize24'>(
    CardLinesCrossFilledSize24Glyph,
    'CardLinesCrossFilledSize24'
);
export const BubbleSquareFilledSize24 = /* #__PURE__*/ hoc<'BubbleSquareFilledSize24'>(
    BubbleSquareFilledSize24Glyph,
    'BubbleSquareFilledSize24'
);
export const MicOutlinedSize16 = /* #__PURE__*/ hoc<'MicOutlinedSize16'>(MicOutlinedSize16Glyph, 'MicOutlinedSize16');
export const UserCircleFilledSize16 = /* #__PURE__*/ hoc<'UserCircleFilledSize16'>(
    UserCircleFilledSize16Glyph,
    'UserCircleFilledSize16'
);
export const CardLinesCrossOutlinedSize16 = /* #__PURE__*/ hoc<'CardLinesCrossOutlinedSize16'>(
    CardLinesCrossOutlinedSize16Glyph,
    'CardLinesCrossOutlinedSize16'
);
export const DropsOutlinedSize24 = /* #__PURE__*/ hoc<'DropsOutlinedSize24'>(
    DropsOutlinedSize24Glyph,
    'DropsOutlinedSize24'
);
export const LiferingOutlinedSize24 = /* #__PURE__*/ hoc<'LiferingOutlinedSize24'>(
    LiferingOutlinedSize24Glyph,
    'LiferingOutlinedSize24'
);
export const CardLinesPlusOutlinedSize24 = /* #__PURE__*/ hoc<'CardLinesPlusOutlinedSize24'>(
    CardLinesPlusOutlinedSize24Glyph,
    'CardLinesPlusOutlinedSize24'
);
export const EnvelopeFilledSize16 = /* #__PURE__*/ hoc<'EnvelopeFilledSize16'>(
    EnvelopeFilledSize16Glyph,
    'EnvelopeFilledSize16'
);
export const BoltOutlinedSize16 = /* #__PURE__*/ hoc<'BoltOutlinedSize16'>(
    BoltOutlinedSize16Glyph,
    'BoltOutlinedSize16'
);
export const EnvelopeOpenedOutlinedSize16 = /* #__PURE__*/ hoc<'EnvelopeOpenedOutlinedSize16'>(
    EnvelopeOpenedOutlinedSize16Glyph,
    'EnvelopeOpenedOutlinedSize16'
);
export const BottleOutlinedSize24 = /* #__PURE__*/ hoc<'BottleOutlinedSize24'>(
    BottleOutlinedSize24Glyph,
    'BottleOutlinedSize24'
);
export const PenLineOutlinedSize16 = /* #__PURE__*/ hoc<'PenLineOutlinedSize16'>(
    PenLineOutlinedSize16Glyph,
    'PenLineOutlinedSize16'
);
export const ThumbDownOutlinedSize24 = /* #__PURE__*/ hoc<'ThumbDownOutlinedSize24'>(
    ThumbDownOutlinedSize24Glyph,
    'ThumbDownOutlinedSize24'
);
export const BagPlusOutlinedSize24 = /* #__PURE__*/ hoc<'BagPlusOutlinedSize24'>(
    BagPlusOutlinedSize24Glyph,
    'BagPlusOutlinedSize24'
);
export const BubbleRoundOutlinedSize24 = /* #__PURE__*/ hoc<'BubbleRoundOutlinedSize24'>(
    BubbleRoundOutlinedSize24Glyph,
    'BubbleRoundOutlinedSize24'
);
export const WheatOutlinedSize16 = /* #__PURE__*/ hoc<'WheatOutlinedSize16'>(
    WheatOutlinedSize16Glyph,
    'WheatOutlinedSize16'
);
export const MapFilledSize24 = /* #__PURE__*/ hoc<'MapFilledSize24'>(MapFilledSize24Glyph, 'MapFilledSize24');
export const UserCircleFilledSize24 = /* #__PURE__*/ hoc<'UserCircleFilledSize24'>(
    UserCircleFilledSize24Glyph,
    'UserCircleFilledSize24'
);
export const CardLinesCrossedOutlinedSize16 = /* #__PURE__*/ hoc<'CardLinesCrossedOutlinedSize16'>(
    CardLinesCrossedOutlinedSize16Glyph,
    'CardLinesCrossedOutlinedSize16'
);
export const CardLinesPlusFilledSize16 = /* #__PURE__*/ hoc<'CardLinesPlusFilledSize16'>(
    CardLinesPlusFilledSize16Glyph,
    'CardLinesPlusFilledSize16'
);
export const CardLinesStackedOutlinedSize16 = /* #__PURE__*/ hoc<'CardLinesStackedOutlinedSize16'>(
    CardLinesStackedOutlinedSize16Glyph,
    'CardLinesStackedOutlinedSize16'
);
export const ThumbUpOutlinedSize16 = /* #__PURE__*/ hoc<'ThumbUpOutlinedSize16'>(
    ThumbUpOutlinedSize16Glyph,
    'ThumbUpOutlinedSize16'
);
export const CardLinesCrossOutlinedSize24 = /* #__PURE__*/ hoc<'CardLinesCrossOutlinedSize24'>(
    CardLinesCrossOutlinedSize24Glyph,
    'CardLinesCrossOutlinedSize24'
);
export const CameraFilledSize16 = /* #__PURE__*/ hoc<'CameraFilledSize16'>(
    CameraFilledSize16Glyph,
    'CameraFilledSize16'
);
export const PinCrossedOutlinedSize16 = /* #__PURE__*/ hoc<'PinCrossedOutlinedSize16'>(
    PinCrossedOutlinedSize16Glyph,
    'PinCrossedOutlinedSize16'
);
export const DataflowFilledSize16 = /* #__PURE__*/ hoc<'DataflowFilledSize16'>(
    DataflowFilledSize16Glyph,
    'DataflowFilledSize16'
);
export const WheatOutlinedSize24 = /* #__PURE__*/ hoc<'WheatOutlinedSize24'>(
    WheatOutlinedSize24Glyph,
    'WheatOutlinedSize24'
);
export const BubbleDotRoundFilledSize24 = /* #__PURE__*/ hoc<'BubbleDotRoundFilledSize24'>(
    BubbleDotRoundFilledSize24Glyph,
    'BubbleDotRoundFilledSize24'
);
export const ThumbUpOutlinedSize24 = /* #__PURE__*/ hoc<'ThumbUpOutlinedSize24'>(
    ThumbUpOutlinedSize24Glyph,
    'ThumbUpOutlinedSize24'
);
export const MapFilledSize32 = /* #__PURE__*/ hoc<'MapFilledSize32'>(MapFilledSize32Glyph, 'MapFilledSize32');
export const DropsOutlinedSize16 = /* #__PURE__*/ hoc<'DropsOutlinedSize16'>(
    DropsOutlinedSize16Glyph,
    'DropsOutlinedSize16'
);
export const ArchiveboxFilledSize24 = /* #__PURE__*/ hoc<'ArchiveboxFilledSize24'>(
    ArchiveboxFilledSize24Glyph,
    'ArchiveboxFilledSize24'
);
export const BankOutlinedSize16 = /* #__PURE__*/ hoc<'BankOutlinedSize16'>(
    BankOutlinedSize16Glyph,
    'BankOutlinedSize16'
);
export const ThumbDownFilledSize16 = /* #__PURE__*/ hoc<'ThumbDownFilledSize16'>(
    ThumbDownFilledSize16Glyph,
    'ThumbDownFilledSize16'
);
export const PenSquareOutlinedSize24 = /* #__PURE__*/ hoc<'PenSquareOutlinedSize24'>(
    PenSquareOutlinedSize24Glyph,
    'PenSquareOutlinedSize24'
);
export const CardLinesStackedOutlinedSize24 = /* #__PURE__*/ hoc<'CardLinesStackedOutlinedSize24'>(
    CardLinesStackedOutlinedSize24Glyph,
    'CardLinesStackedOutlinedSize24'
);
export const PenLineFilledSize24 = /* #__PURE__*/ hoc<'PenLineFilledSize24'>(
    PenLineFilledSize24Glyph,
    'PenLineFilledSize24'
);
export const GhostOutlinedSize24 = /* #__PURE__*/ hoc<'GhostOutlinedSize24'>(
    GhostOutlinedSize24Glyph,
    'GhostOutlinedSize24'
);
export const CameraFilledSize24 = /* #__PURE__*/ hoc<'CameraFilledSize24'>(
    CameraFilledSize24Glyph,
    'CameraFilledSize24'
);
export const ArchiveboxFilledSize16 = /* #__PURE__*/ hoc<'ArchiveboxFilledSize16'>(
    ArchiveboxFilledSize16Glyph,
    'ArchiveboxFilledSize16'
);
export const BriefcaseOutlinedSize24 = /* #__PURE__*/ hoc<'BriefcaseOutlinedSize24'>(
    BriefcaseOutlinedSize24Glyph,
    'BriefcaseOutlinedSize24'
);
export const TrashOutlinedSize24 = /* #__PURE__*/ hoc<'TrashOutlinedSize24'>(
    TrashOutlinedSize24Glyph,
    'TrashOutlinedSize24'
);
export const CalendarFilledSize24 = /* #__PURE__*/ hoc<'CalendarFilledSize24'>(
    CalendarFilledSize24Glyph,
    'CalendarFilledSize24'
);
export const ChartLineFilledSize24 = /* #__PURE__*/ hoc<'ChartLineFilledSize24'>(
    ChartLineFilledSize24Glyph,
    'ChartLineFilledSize24'
);
export const CardLinesCrossFilledSize16 = /* #__PURE__*/ hoc<'CardLinesCrossFilledSize16'>(
    CardLinesCrossFilledSize16Glyph,
    'CardLinesCrossFilledSize16'
);
export const CardLinesStackedCrossFilledSize24 = /* #__PURE__*/ hoc<'CardLinesStackedCrossFilledSize24'>(
    CardLinesStackedCrossFilledSize24Glyph,
    'CardLinesStackedCrossFilledSize24'
);
export const TrashFilledSize24 = /* #__PURE__*/ hoc<'TrashFilledSize24'>(TrashFilledSize24Glyph, 'TrashFilledSize24');
export const BottleOutlinedSize16 = /* #__PURE__*/ hoc<'BottleOutlinedSize16'>(
    BottleOutlinedSize16Glyph,
    'BottleOutlinedSize16'
);
export const BankOutlinedSize24 = /* #__PURE__*/ hoc<'BankOutlinedSize24'>(
    BankOutlinedSize24Glyph,
    'BankOutlinedSize24'
);
export const WheatFilledSize24 = /* #__PURE__*/ hoc<'WheatFilledSize24'>(WheatFilledSize24Glyph, 'WheatFilledSize24');
export const BoltOutlinedSize24 = /* #__PURE__*/ hoc<'BoltOutlinedSize24'>(
    BoltOutlinedSize24Glyph,
    'BoltOutlinedSize24'
);
export const CardLinesStackedCrossedFilledSize24 = /* #__PURE__*/ hoc<'CardLinesStackedCrossedFilledSize24'>(
    CardLinesStackedCrossedFilledSize24Glyph,
    'CardLinesStackedCrossedFilledSize24'
);
export const CardLinesOutlinedSize24 = /* #__PURE__*/ hoc<'CardLinesOutlinedSize24'>(
    CardLinesOutlinedSize24Glyph,
    'CardLinesOutlinedSize24'
);
export const EnvelopeOutlinedSize24 = /* #__PURE__*/ hoc<'EnvelopeOutlinedSize24'>(
    EnvelopeOutlinedSize24Glyph,
    'EnvelopeOutlinedSize24'
);
export const CalendarFilledSize16 = /* #__PURE__*/ hoc<'CalendarFilledSize16'>(
    CalendarFilledSize16Glyph,
    'CalendarFilledSize16'
);
export const PinOutlinedSize16 = /* #__PURE__*/ hoc<'PinOutlinedSize16'>(PinOutlinedSize16Glyph, 'PinOutlinedSize16');
export const ExclamationTriangleFilledSize24 = /* #__PURE__*/ hoc<'ExclamationTriangleFilledSize24'>(
    ExclamationTriangleFilledSize24Glyph,
    'ExclamationTriangleFilledSize24'
);
export const VideocameraOutlinedSize32 = /* #__PURE__*/ hoc<'VideocameraOutlinedSize32'>(
    VideocameraOutlinedSize32Glyph,
    'VideocameraOutlinedSize32'
);
export const GiftFilledSize24 = /* #__PURE__*/ hoc<'GiftFilledSize24'>(GiftFilledSize24Glyph, 'GiftFilledSize24');
export const DocumentVerifiedFilledSize16 = /* #__PURE__*/ hoc<'DocumentVerifiedFilledSize16'>(
    DocumentVerifiedFilledSize16Glyph,
    'DocumentVerifiedFilledSize16'
);
export const BotOutlinedSize24 = /* #__PURE__*/ hoc<'BotOutlinedSize24'>(BotOutlinedSize24Glyph, 'BotOutlinedSize24');
export const DocumentArrowUpOutlinedSize32 = /* #__PURE__*/ hoc<'DocumentArrowUpOutlinedSize32'>(
    DocumentArrowUpOutlinedSize32Glyph,
    'DocumentArrowUpOutlinedSize32'
);
export const DocumentOutlinedSize16 = /* #__PURE__*/ hoc<'DocumentOutlinedSize16'>(
    DocumentOutlinedSize16Glyph,
    'DocumentOutlinedSize16'
);
export const FolderHeartOutlinedSize16 = /* #__PURE__*/ hoc<'FolderHeartOutlinedSize16'>(
    FolderHeartOutlinedSize16Glyph,
    'FolderHeartOutlinedSize16'
);
export const FlagFilledSize16 = /* #__PURE__*/ hoc<'FlagFilledSize16'>(FlagFilledSize16Glyph, 'FlagFilledSize16');
export const MinusCircleOutlinedSize24 = /* #__PURE__*/ hoc<'MinusCircleOutlinedSize24'>(
    MinusCircleOutlinedSize24Glyph,
    'MinusCircleOutlinedSize24'
);
export const RotateRightFilledSize24 = /* #__PURE__*/ hoc<'RotateRightFilledSize24'>(
    RotateRightFilledSize24Glyph,
    'RotateRightFilledSize24'
);
export const ChevronLeftOutlinedSize12 = /* #__PURE__*/ hoc<'ChevronLeftOutlinedSize12'>(
    ChevronLeftOutlinedSize12Glyph,
    'ChevronLeftOutlinedSize12'
);
export const DocumentArrowUpOutlinedSize16 = /* #__PURE__*/ hoc<'DocumentArrowUpOutlinedSize16'>(
    DocumentArrowUpOutlinedSize16Glyph,
    'DocumentArrowUpOutlinedSize16'
);
export const DocumentArrowUpFilledSize16 = /* #__PURE__*/ hoc<'DocumentArrowUpFilledSize16'>(
    DocumentArrowUpFilledSize16Glyph,
    'DocumentArrowUpFilledSize16'
);
export const UturnRightOutlinedSize24 = /* #__PURE__*/ hoc<'UturnRightOutlinedSize24'>(
    UturnRightOutlinedSize24Glyph,
    'UturnRightOutlinedSize24'
);
export const ArrowDownRightOutlinedSize24 = /* #__PURE__*/ hoc<'ArrowDownRightOutlinedSize24'>(
    ArrowDownRightOutlinedSize24Glyph,
    'ArrowDownRightOutlinedSize24'
);
export const PenHyperstarOutlinedSize16 = /* #__PURE__*/ hoc<'PenHyperstarOutlinedSize16'>(
    PenHyperstarOutlinedSize16Glyph,
    'PenHyperstarOutlinedSize16'
);
export const StarFilledSize16 = /* #__PURE__*/ hoc<'StarFilledSize16'>(StarFilledSize16Glyph, 'StarFilledSize16');
export const SendWebOutlinedSize24 = /* #__PURE__*/ hoc<'SendWebOutlinedSize24'>(
    SendWebOutlinedSize24Glyph,
    'SendWebOutlinedSize24'
);
export const BellCrossedFilledSize24 = /* #__PURE__*/ hoc<'BellCrossedFilledSize24'>(
    BellCrossedFilledSize24Glyph,
    'BellCrossedFilledSize24'
);
export const FrameStarOutlinedSize24 = /* #__PURE__*/ hoc<'FrameStarOutlinedSize24'>(
    FrameStarOutlinedSize24Glyph,
    'FrameStarOutlinedSize24'
);
export const PenHyperstarOutlinedSize24 = /* #__PURE__*/ hoc<'PenHyperstarOutlinedSize24'>(
    PenHyperstarOutlinedSize24Glyph,
    'PenHyperstarOutlinedSize24'
);
export const GiftFilledSize16 = /* #__PURE__*/ hoc<'GiftFilledSize16'>(GiftFilledSize16Glyph, 'GiftFilledSize16');
export const CopyOutlinedSize24 = /* #__PURE__*/ hoc<'CopyOutlinedSize24'>(
    CopyOutlinedSize24Glyph,
    'CopyOutlinedSize24'
);
export const RotateLeftFilledSize16 = /* #__PURE__*/ hoc<'RotateLeftFilledSize16'>(
    RotateLeftFilledSize16Glyph,
    'RotateLeftFilledSize16'
);
export const DocumentArrowUpFilledSize32 = /* #__PURE__*/ hoc<'DocumentArrowUpFilledSize32'>(
    DocumentArrowUpFilledSize32Glyph,
    'DocumentArrowUpFilledSize32'
);
export const HumanWalkFilledSize24 = /* #__PURE__*/ hoc<'HumanWalkFilledSize24'>(
    HumanWalkFilledSize24Glyph,
    'HumanWalkFilledSize24'
);
export const DocumentOutlinedSize32 = /* #__PURE__*/ hoc<'DocumentOutlinedSize32'>(
    DocumentOutlinedSize32Glyph,
    'DocumentOutlinedSize32'
);
export const CopyOutlinedSize16 = /* #__PURE__*/ hoc<'CopyOutlinedSize16'>(
    CopyOutlinedSize16Glyph,
    'CopyOutlinedSize16'
);
export const RotateRightFilledSize16 = /* #__PURE__*/ hoc<'RotateRightFilledSize16'>(
    RotateRightFilledSize16Glyph,
    'RotateRightFilledSize16'
);
export const PlayCircleFilledSize16 = /* #__PURE__*/ hoc<'PlayCircleFilledSize16'>(
    PlayCircleFilledSize16Glyph,
    'PlayCircleFilledSize16'
);
export const RotateLeftFilledSize24 = /* #__PURE__*/ hoc<'RotateLeftFilledSize24'>(
    RotateLeftFilledSize24Glyph,
    'RotateLeftFilledSize24'
);
export const WalletFilledSize24 = /* #__PURE__*/ hoc<'WalletFilledSize24'>(
    WalletFilledSize24Glyph,
    'WalletFilledSize24'
);
export const EllipsisHorizontalCircleFilledSize24 = /* #__PURE__*/ hoc<'EllipsisHorizontalCircleFilledSize24'>(
    EllipsisHorizontalCircleFilledSize24Glyph,
    'EllipsisHorizontalCircleFilledSize24'
);
export const RotateRightOutlinedSize16 = /* #__PURE__*/ hoc<'RotateRightOutlinedSize16'>(
    RotateRightOutlinedSize16Glyph,
    'RotateRightOutlinedSize16'
);
export const MicFilledSize16 = /* #__PURE__*/ hoc<'MicFilledSize16'>(MicFilledSize16Glyph, 'MicFilledSize16');
export const DocumentStarFilledSize24 = /* #__PURE__*/ hoc<'DocumentStarFilledSize24'>(
    DocumentStarFilledSize24Glyph,
    'DocumentStarFilledSize24'
);
export const BriefcaseFilledSize24 = /* #__PURE__*/ hoc<'BriefcaseFilledSize24'>(
    BriefcaseFilledSize24Glyph,
    'BriefcaseFilledSize24'
);
export const DocumentVerifiedFilledSize32 = /* #__PURE__*/ hoc<'DocumentVerifiedFilledSize32'>(
    DocumentVerifiedFilledSize32Glyph,
    'DocumentVerifiedFilledSize32'
);
export const PinOutlinedSize24 = /* #__PURE__*/ hoc<'PinOutlinedSize24'>(PinOutlinedSize24Glyph, 'PinOutlinedSize24');
export const UturnRightOutlinedSize16 = /* #__PURE__*/ hoc<'UturnRightOutlinedSize16'>(
    UturnRightOutlinedSize16Glyph,
    'UturnRightOutlinedSize16'
);
export const DocumentArrowUpFilledSize24 = /* #__PURE__*/ hoc<'DocumentArrowUpFilledSize24'>(
    DocumentArrowUpFilledSize24Glyph,
    'DocumentArrowUpFilledSize24'
);
export const ArrowSquareOutlinedSize24 = /* #__PURE__*/ hoc<'ArrowSquareOutlinedSize24'>(
    ArrowSquareOutlinedSize24Glyph,
    'ArrowSquareOutlinedSize24'
);
export const VideocameraOutlinedSize24 = /* #__PURE__*/ hoc<'VideocameraOutlinedSize24'>(
    VideocameraOutlinedSize24Glyph,
    'VideocameraOutlinedSize24'
);
export const GridFilledSize24 = /* #__PURE__*/ hoc<'GridFilledSize24'>(GridFilledSize24Glyph, 'GridFilledSize24');
export const BellCrossedOutlinedSize24 = /* #__PURE__*/ hoc<'BellCrossedOutlinedSize24'>(
    BellCrossedOutlinedSize24Glyph,
    'BellCrossedOutlinedSize24'
);
export const TreeFilledSize16 = /* #__PURE__*/ hoc<'TreeFilledSize16'>(TreeFilledSize16Glyph, 'TreeFilledSize16');
export const SquaresIntersectedOutlinedSize16 = /* #__PURE__*/ hoc<'SquaresIntersectedOutlinedSize16'>(
    SquaresIntersectedOutlinedSize16Glyph,
    'SquaresIntersectedOutlinedSize16'
);
export const DocumentVerifiedOutlinedSize24 = /* #__PURE__*/ hoc<'DocumentVerifiedOutlinedSize24'>(
    DocumentVerifiedOutlinedSize24Glyph,
    'DocumentVerifiedOutlinedSize24'
);
export const SpeakerCrossFilledSize16 = /* #__PURE__*/ hoc<'SpeakerCrossFilledSize16'>(
    SpeakerCrossFilledSize16Glyph,
    'SpeakerCrossFilledSize16'
);
export const ArrowSquareOutlinedSize16 = /* #__PURE__*/ hoc<'ArrowSquareOutlinedSize16'>(
    ArrowSquareOutlinedSize16Glyph,
    'ArrowSquareOutlinedSize16'
);
export const BuildingFilledSize16 = /* #__PURE__*/ hoc<'BuildingFilledSize16'>(
    BuildingFilledSize16Glyph,
    'BuildingFilledSize16'
);
export const BriefcaseFilledSize16 = /* #__PURE__*/ hoc<'BriefcaseFilledSize16'>(
    BriefcaseFilledSize16Glyph,
    'BriefcaseFilledSize16'
);
export const LockOpenedFilledSize12 = /* #__PURE__*/ hoc<'LockOpenedFilledSize12'>(
    LockOpenedFilledSize12Glyph,
    'LockOpenedFilledSize12'
);
export const SendWebOutlinedSize32 = /* #__PURE__*/ hoc<'SendWebOutlinedSize32'>(
    SendWebOutlinedSize32Glyph,
    'SendWebOutlinedSize32'
);
export const CopyFilledSize24 = /* #__PURE__*/ hoc<'CopyFilledSize24'>(CopyFilledSize24Glyph, 'CopyFilledSize24');
export const BuildingFilledSize24 = /* #__PURE__*/ hoc<'BuildingFilledSize24'>(
    BuildingFilledSize24Glyph,
    'BuildingFilledSize24'
);
export const ChevronUpOutlinedSize12 = /* #__PURE__*/ hoc<'ChevronUpOutlinedSize12'>(
    ChevronUpOutlinedSize12Glyph,
    'ChevronUpOutlinedSize12'
);
export const GridFilledSize16 = /* #__PURE__*/ hoc<'GridFilledSize16'>(GridFilledSize16Glyph, 'GridFilledSize16');
export const TreeFilledSize24 = /* #__PURE__*/ hoc<'TreeFilledSize24'>(TreeFilledSize24Glyph, 'TreeFilledSize24');
export const EyeCrossedFilledSize16 = /* #__PURE__*/ hoc<'EyeCrossedFilledSize16'>(
    EyeCrossedFilledSize16Glyph,
    'EyeCrossedFilledSize16'
);
export const LockOpenedFilledSize16 = /* #__PURE__*/ hoc<'LockOpenedFilledSize16'>(
    LockOpenedFilledSize16Glyph,
    'LockOpenedFilledSize16'
);
export const LockOpenedFilledSize24 = /* #__PURE__*/ hoc<'LockOpenedFilledSize24'>(
    LockOpenedFilledSize24Glyph,
    'LockOpenedFilledSize24'
);
export const DocumentVerifiedOutlinedSize32 = /* #__PURE__*/ hoc<'DocumentVerifiedOutlinedSize32'>(
    DocumentVerifiedOutlinedSize32Glyph,
    'DocumentVerifiedOutlinedSize32'
);
export const ChevronLeftOutlinedSize24 = /* #__PURE__*/ hoc<'ChevronLeftOutlinedSize24'>(
    ChevronLeftOutlinedSize24Glyph,
    'ChevronLeftOutlinedSize24'
);
export const CircleFilledSize24 = /* #__PURE__*/ hoc<'CircleFilledSize24'>(
    CircleFilledSize24Glyph,
    'CircleFilledSize24'
);
export const DocumentArrowUpOutlinedSize24 = /* #__PURE__*/ hoc<'DocumentArrowUpOutlinedSize24'>(
    DocumentArrowUpOutlinedSize24Glyph,
    'DocumentArrowUpOutlinedSize24'
);
export const CircleFilledSize16 = /* #__PURE__*/ hoc<'CircleFilledSize16'>(
    CircleFilledSize16Glyph,
    'CircleFilledSize16'
);
export const MinusCircleOutlinedSize16 = /* #__PURE__*/ hoc<'MinusCircleOutlinedSize16'>(
    MinusCircleOutlinedSize16Glyph,
    'MinusCircleOutlinedSize16'
);
export const SpeakerCrossFilledSize24 = /* #__PURE__*/ hoc<'SpeakerCrossFilledSize24'>(
    SpeakerCrossFilledSize24Glyph,
    'SpeakerCrossFilledSize24'
);
export const BookFilledSize16 = /* #__PURE__*/ hoc<'BookFilledSize16'>(BookFilledSize16Glyph, 'BookFilledSize16');
export const BellFilledSize16 = /* #__PURE__*/ hoc<'BellFilledSize16'>(BellFilledSize16Glyph, 'BellFilledSize16');
export const CardLinesCrossedFilledSize16 = /* #__PURE__*/ hoc<'CardLinesCrossedFilledSize16'>(
    CardLinesCrossedFilledSize16Glyph,
    'CardLinesCrossedFilledSize16'
);
export const BellOutlinedSize16 = /* #__PURE__*/ hoc<'BellOutlinedSize16'>(
    BellOutlinedSize16Glyph,
    'BellOutlinedSize16'
);
export const CardLinesCrossedFilledSize24 = /* #__PURE__*/ hoc<'CardLinesCrossedFilledSize24'>(
    CardLinesCrossedFilledSize24Glyph,
    'CardLinesCrossedFilledSize24'
);
export const FolderHeartOutlinedSize24 = /* #__PURE__*/ hoc<'FolderHeartOutlinedSize24'>(
    FolderHeartOutlinedSize24Glyph,
    'FolderHeartOutlinedSize24'
);
export const ChevronUpOutlinedSize24 = /* #__PURE__*/ hoc<'ChevronUpOutlinedSize24'>(
    ChevronUpOutlinedSize24Glyph,
    'ChevronUpOutlinedSize24'
);
export const DocumentStarFilledSize32 = /* #__PURE__*/ hoc<'DocumentStarFilledSize32'>(
    DocumentStarFilledSize32Glyph,
    'DocumentStarFilledSize32'
);
export const SendAndroidFilledSize32 = /* #__PURE__*/ hoc<'SendAndroidFilledSize32'>(
    SendAndroidFilledSize32Glyph,
    'SendAndroidFilledSize32'
);
export const DocumentVerifiedFilledSize24 = /* #__PURE__*/ hoc<'DocumentVerifiedFilledSize24'>(
    DocumentVerifiedFilledSize24Glyph,
    'DocumentVerifiedFilledSize24'
);
export const EyeCrossedFilledSize24 = /* #__PURE__*/ hoc<'EyeCrossedFilledSize24'>(
    EyeCrossedFilledSize24Glyph,
    'EyeCrossedFilledSize24'
);
export const BookFilledSize24 = /* #__PURE__*/ hoc<'BookFilledSize24'>(BookFilledSize24Glyph, 'BookFilledSize24');
export const CopyFilledSize16 = /* #__PURE__*/ hoc<'CopyFilledSize16'>(CopyFilledSize16Glyph, 'CopyFilledSize16');
export const WalletFilledSize16 = /* #__PURE__*/ hoc<'WalletFilledSize16'>(
    WalletFilledSize16Glyph,
    'WalletFilledSize16'
);
export const DocumentStarFilledSize16 = /* #__PURE__*/ hoc<'DocumentStarFilledSize16'>(
    DocumentStarFilledSize16Glyph,
    'DocumentStarFilledSize16'
);
export const PinCrossedFilledSize24 = /* #__PURE__*/ hoc<'PinCrossedFilledSize24'>(
    PinCrossedFilledSize24Glyph,
    'PinCrossedFilledSize24'
);
export const ChevronLeftOutlinedSize16 = /* #__PURE__*/ hoc<'ChevronLeftOutlinedSize16'>(
    ChevronLeftOutlinedSize16Glyph,
    'ChevronLeftOutlinedSize16'
);
export const MicFilledSize24 = /* #__PURE__*/ hoc<'MicFilledSize24'>(MicFilledSize24Glyph, 'MicFilledSize24');
export const ArrowDownRightOutlinedSize16 = /* #__PURE__*/ hoc<'ArrowDownRightOutlinedSize16'>(
    ArrowDownRightOutlinedSize16Glyph,
    'ArrowDownRightOutlinedSize16'
);
export const RotateRightOutlinedSize24 = /* #__PURE__*/ hoc<'RotateRightOutlinedSize24'>(
    RotateRightOutlinedSize24Glyph,
    'RotateRightOutlinedSize24'
);
export const PinCrossedFilledSize16 = /* #__PURE__*/ hoc<'PinCrossedFilledSize16'>(
    PinCrossedFilledSize16Glyph,
    'PinCrossedFilledSize16'
);
export const HumanWalkFilledSize16 = /* #__PURE__*/ hoc<'HumanWalkFilledSize16'>(
    HumanWalkFilledSize16Glyph,
    'HumanWalkFilledSize16'
);
export const DocumentOutlinedSize24 = /* #__PURE__*/ hoc<'DocumentOutlinedSize24'>(
    DocumentOutlinedSize24Glyph,
    'DocumentOutlinedSize24'
);
export const PlayCircleFilledSize24 = /* #__PURE__*/ hoc<'PlayCircleFilledSize24'>(
    PlayCircleFilledSize24Glyph,
    'PlayCircleFilledSize24'
);
export const StarFilledSize32 = /* #__PURE__*/ hoc<'StarFilledSize32'>(StarFilledSize32Glyph, 'StarFilledSize32');
export const EllipsisHorizontalCircleFilledSize16 = /* #__PURE__*/ hoc<'EllipsisHorizontalCircleFilledSize16'>(
    EllipsisHorizontalCircleFilledSize16Glyph,
    'EllipsisHorizontalCircleFilledSize16'
);
export const VideocameraOutlinedSize16 = /* #__PURE__*/ hoc<'VideocameraOutlinedSize16'>(
    VideocameraOutlinedSize16Glyph,
    'VideocameraOutlinedSize16'
);
export const BellOutlinedSize24 = /* #__PURE__*/ hoc<'BellOutlinedSize24'>(
    BellOutlinedSize24Glyph,
    'BellOutlinedSize24'
);
export const BellCrossedOutlinedSize16 = /* #__PURE__*/ hoc<'BellCrossedOutlinedSize16'>(
    BellCrossedOutlinedSize16Glyph,
    'BellCrossedOutlinedSize16'
);
export const SendAndroidFilledSize16 = /* #__PURE__*/ hoc<'SendAndroidFilledSize16'>(
    SendAndroidFilledSize16Glyph,
    'SendAndroidFilledSize16'
);
export const SendAndroidFilledSize24 = /* #__PURE__*/ hoc<'SendAndroidFilledSize24'>(
    SendAndroidFilledSize24Glyph,
    'SendAndroidFilledSize24'
);
export const SendWebOutlinedSize16 = /* #__PURE__*/ hoc<'SendWebOutlinedSize16'>(
    SendWebOutlinedSize16Glyph,
    'SendWebOutlinedSize16'
);
export const BotOutlinedSize16 = /* #__PURE__*/ hoc<'BotOutlinedSize16'>(BotOutlinedSize16Glyph, 'BotOutlinedSize16');
export const ExclamationTriangleFilledSize32 = /* #__PURE__*/ hoc<'ExclamationTriangleFilledSize32'>(
    ExclamationTriangleFilledSize32Glyph,
    'ExclamationTriangleFilledSize32'
);
export const PlusBoldOutlinedSize16 = /* #__PURE__*/ hoc<'PlusBoldOutlinedSize16'>(
    PlusBoldOutlinedSize16Glyph,
    'PlusBoldOutlinedSize16'
);
export const HyperstarFilledSize16 = /* #__PURE__*/ hoc<'HyperstarFilledSize16'>(
    HyperstarFilledSize16Glyph,
    'HyperstarFilledSize16'
);
export const AntennaFilledSize24 = /* #__PURE__*/ hoc<'AntennaFilledSize24'>(
    AntennaFilledSize24Glyph,
    'AntennaFilledSize24'
);
export const GhostFilledSize24 = /* #__PURE__*/ hoc<'GhostFilledSize24'>(GhostFilledSize24Glyph, 'GhostFilledSize24');
export const MagnifierFilledSize16 = /* #__PURE__*/ hoc<'MagnifierFilledSize16'>(
    MagnifierFilledSize16Glyph,
    'MagnifierFilledSize16'
);
export const MagnifierMinusFilledSize16 = /* #__PURE__*/ hoc<'MagnifierMinusFilledSize16'>(
    MagnifierMinusFilledSize16Glyph,
    'MagnifierMinusFilledSize16'
);
export const BoltFilledSize16 = /* #__PURE__*/ hoc<'BoltFilledSize16'>(BoltFilledSize16Glyph, 'BoltFilledSize16');
export const HomeOutlinedSize16 = /* #__PURE__*/ hoc<'HomeOutlinedSize16'>(
    HomeOutlinedSize16Glyph,
    'HomeOutlinedSize16'
);
export const GhostFilledSize16 = /* #__PURE__*/ hoc<'GhostFilledSize16'>(GhostFilledSize16Glyph, 'GhostFilledSize16');
export const FlameFilledSize24 = /* #__PURE__*/ hoc<'FlameFilledSize24'>(FlameFilledSize24Glyph, 'FlameFilledSize24');
export const TreeOutlinedSize24 = /* #__PURE__*/ hoc<'TreeOutlinedSize24'>(
    TreeOutlinedSize24Glyph,
    'TreeOutlinedSize24'
);
export const ClockOutlinedSize12 = /* #__PURE__*/ hoc<'ClockOutlinedSize12'>(
    ClockOutlinedSize12Glyph,
    'ClockOutlinedSize12'
);
export const MoonStarFilledSize24 = /* #__PURE__*/ hoc<'MoonStarFilledSize24'>(
    MoonStarFilledSize24Glyph,
    'MoonStarFilledSize24'
);
export const ClockOutlinedSize24 = /* #__PURE__*/ hoc<'ClockOutlinedSize24'>(
    ClockOutlinedSize24Glyph,
    'ClockOutlinedSize24'
);
export const BackwardFilledSize24 = /* #__PURE__*/ hoc<'BackwardFilledSize24'>(
    BackwardFilledSize24Glyph,
    'BackwardFilledSize24'
);
export const AstrostarOutlinedSize16 = /* #__PURE__*/ hoc<'AstrostarOutlinedSize16'>(
    AstrostarOutlinedSize16Glyph,
    'AstrostarOutlinedSize16'
);
export const BagOutlinedSize16 = /* #__PURE__*/ hoc<'BagOutlinedSize16'>(BagOutlinedSize16Glyph, 'BagOutlinedSize16');
export const MagnifierFilledSize24 = /* #__PURE__*/ hoc<'MagnifierFilledSize24'>(
    MagnifierFilledSize24Glyph,
    'MagnifierFilledSize24'
);
export const HeadsetOutlinedSize24 = /* #__PURE__*/ hoc<'HeadsetOutlinedSize24'>(
    HeadsetOutlinedSize24Glyph,
    'HeadsetOutlinedSize24'
);
export const HeartOutlinedSize24 = /* #__PURE__*/ hoc<'HeartOutlinedSize24'>(
    HeartOutlinedSize24Glyph,
    'HeartOutlinedSize24'
);
export const BubbleRoundDoubleOutlinedSize16 = /* #__PURE__*/ hoc<'BubbleRoundDoubleOutlinedSize16'>(
    BubbleRoundDoubleOutlinedSize16Glyph,
    'BubbleRoundDoubleOutlinedSize16'
);
export const PhoneDownFilledSize24 = /* #__PURE__*/ hoc<'PhoneDownFilledSize24'>(
    PhoneDownFilledSize24Glyph,
    'PhoneDownFilledSize24'
);
export const HeartFilledSize16 = /* #__PURE__*/ hoc<'HeartFilledSize16'>(HeartFilledSize16Glyph, 'HeartFilledSize16');
export const TrainOutlinedSize16 = /* #__PURE__*/ hoc<'TrainOutlinedSize16'>(
    TrainOutlinedSize16Glyph,
    'TrainOutlinedSize16'
);
export const SmartphoneOutlinedSize16 = /* #__PURE__*/ hoc<'SmartphoneOutlinedSize16'>(
    SmartphoneOutlinedSize16Glyph,
    'SmartphoneOutlinedSize16'
);
export const BackwardFilledSize16 = /* #__PURE__*/ hoc<'BackwardFilledSize16'>(
    BackwardFilledSize16Glyph,
    'BackwardFilledSize16'
);
export const FlameFilledSize32 = /* #__PURE__*/ hoc<'FlameFilledSize32'>(FlameFilledSize32Glyph, 'FlameFilledSize32');
export const ArrowLeftRightOutlinedSize16 = /* #__PURE__*/ hoc<'ArrowLeftRightOutlinedSize16'>(
    ArrowLeftRightOutlinedSize16Glyph,
    'ArrowLeftRightOutlinedSize16'
);
export const HeartOutlinedSize32 = /* #__PURE__*/ hoc<'HeartOutlinedSize32'>(
    HeartOutlinedSize32Glyph,
    'HeartOutlinedSize32'
);
export const LightbulbOnFilledSize16 = /* #__PURE__*/ hoc<'LightbulbOnFilledSize16'>(
    LightbulbOnFilledSize16Glyph,
    'LightbulbOnFilledSize16'
);
export const BagOutlinedSize24 = /* #__PURE__*/ hoc<'BagOutlinedSize24'>(BagOutlinedSize24Glyph, 'BagOutlinedSize24');
export const StarHalfFilledSize32 = /* #__PURE__*/ hoc<'StarHalfFilledSize32'>(
    StarHalfFilledSize32Glyph,
    'StarHalfFilledSize32'
);
export const HyperstarFilledSize32 = /* #__PURE__*/ hoc<'HyperstarFilledSize32'>(
    HyperstarFilledSize32Glyph,
    'HyperstarFilledSize32'
);
export const BoltFilledSize24 = /* #__PURE__*/ hoc<'BoltFilledSize24'>(BoltFilledSize24Glyph, 'BoltFilledSize24');
export const TrolleyOutlinedSize24 = /* #__PURE__*/ hoc<'TrolleyOutlinedSize24'>(
    TrolleyOutlinedSize24Glyph,
    'TrolleyOutlinedSize24'
);
export const FlameOutlinedSize24 = /* #__PURE__*/ hoc<'FlameOutlinedSize24'>(
    FlameOutlinedSize24Glyph,
    'FlameOutlinedSize24'
);
export const MagnifierFilledHeartFilledSize24 = /* #__PURE__*/ hoc<'MagnifierFilledHeartFilledSize24'>(
    MagnifierFilledHeartFilledSize24Glyph,
    'MagnifierFilledHeartFilledSize24'
);
export const HyperstarFilledSize48 = /* #__PURE__*/ hoc<'HyperstarFilledSize48'>(
    HyperstarFilledSize48Glyph,
    'HyperstarFilledSize48'
);
export const HeartFilledSize24 = /* #__PURE__*/ hoc<'HeartFilledSize24'>(HeartFilledSize24Glyph, 'HeartFilledSize24');
export const MagnifierMinusFilledSize24 = /* #__PURE__*/ hoc<'MagnifierMinusFilledSize24'>(
    MagnifierMinusFilledSize24Glyph,
    'MagnifierMinusFilledSize24'
);
export const RotateLeftOultinedSize16 = /* #__PURE__*/ hoc<'RotateLeftOultinedSize16'>(
    RotateLeftOultinedSize16Glyph,
    'RotateLeftOultinedSize16'
);
export const StarCircleFilledSize32 = /* #__PURE__*/ hoc<'StarCircleFilledSize32'>(
    StarCircleFilledSize32Glyph,
    'StarCircleFilledSize32'
);
export const SmartphoneOutlinedSize24 = /* #__PURE__*/ hoc<'SmartphoneOutlinedSize24'>(
    SmartphoneOutlinedSize24Glyph,
    'SmartphoneOutlinedSize24'
);
export const BubbleRoundDoubleOutlinedSize24 = /* #__PURE__*/ hoc<'BubbleRoundDoubleOutlinedSize24'>(
    BubbleRoundDoubleOutlinedSize24Glyph,
    'BubbleRoundDoubleOutlinedSize24'
);
export const HeartFilledSize32 = /* #__PURE__*/ hoc<'HeartFilledSize32'>(HeartFilledSize32Glyph, 'HeartFilledSize32');
export const StarCircleFilledSize24 = /* #__PURE__*/ hoc<'StarCircleFilledSize24'>(
    StarCircleFilledSize24Glyph,
    'StarCircleFilledSize24'
);
export const EyeCrossedOutlinedSize24 = /* #__PURE__*/ hoc<'EyeCrossedOutlinedSize24'>(
    EyeCrossedOutlinedSize24Glyph,
    'EyeCrossedOutlinedSize24'
);
export const ArrowLeftRightOutlinedSize24 = /* #__PURE__*/ hoc<'ArrowLeftRightOutlinedSize24'>(
    ArrowLeftRightOutlinedSize24Glyph,
    'ArrowLeftRightOutlinedSize24'
);
export const SendIosFilledSize32 = /* #__PURE__*/ hoc<'SendIosFilledSize32'>(
    SendIosFilledSize32Glyph,
    'SendIosFilledSize32'
);
export const ArchiveboxArrowOutlinedSize24 = /* #__PURE__*/ hoc<'ArchiveboxArrowOutlinedSize24'>(
    ArchiveboxArrowOutlinedSize24Glyph,
    'ArchiveboxArrowOutlinedSize24'
);
export const BricksFilledSize16 = /* #__PURE__*/ hoc<'BricksFilledSize16'>(
    BricksFilledSize16Glyph,
    'BricksFilledSize16'
);
export const MagnifierFilledHeartFilledSize16 = /* #__PURE__*/ hoc<'MagnifierFilledHeartFilledSize16'>(
    MagnifierFilledHeartFilledSize16Glyph,
    'MagnifierFilledHeartFilledSize16'
);
export const StarCircleFilledSize16 = /* #__PURE__*/ hoc<'StarCircleFilledSize16'>(
    StarCircleFilledSize16Glyph,
    'StarCircleFilledSize16'
);
export const PhoneDownFilledSize16 = /* #__PURE__*/ hoc<'PhoneDownFilledSize16'>(
    PhoneDownFilledSize16Glyph,
    'PhoneDownFilledSize16'
);
export const HyperstarFilledSize24 = /* #__PURE__*/ hoc<'HyperstarFilledSize24'>(
    HyperstarFilledSize24Glyph,
    'HyperstarFilledSize24'
);
export const FlameFilledSize16 = /* #__PURE__*/ hoc<'FlameFilledSize16'>(FlameFilledSize16Glyph, 'FlameFilledSize16');
export const FlameOutlinedSize16 = /* #__PURE__*/ hoc<'FlameOutlinedSize16'>(
    FlameOutlinedSize16Glyph,
    'FlameOutlinedSize16'
);
export const FunnelOutlinedSize16 = /* #__PURE__*/ hoc<'FunnelOutlinedSize16'>(
    FunnelOutlinedSize16Glyph,
    'FunnelOutlinedSize16'
);
export const AntennaFilledSize16 = /* #__PURE__*/ hoc<'AntennaFilledSize16'>(
    AntennaFilledSize16Glyph,
    'AntennaFilledSize16'
);
export const FunnelOutlinedSize24 = /* #__PURE__*/ hoc<'FunnelOutlinedSize24'>(
    FunnelOutlinedSize24Glyph,
    'FunnelOutlinedSize24'
);
export const FolderArrowRightFilledSize24 = /* #__PURE__*/ hoc<'FolderArrowRightFilledSize24'>(
    FolderArrowRightFilledSize24Glyph,
    'FolderArrowRightFilledSize24'
);
export const PlusCircleOutlinedSize16 = /* #__PURE__*/ hoc<'PlusCircleOutlinedSize16'>(
    PlusCircleOutlinedSize16Glyph,
    'PlusCircleOutlinedSize16'
);
export const ShareWebOutlinedSize16 = /* #__PURE__*/ hoc<'ShareWebOutlinedSize16'>(
    ShareWebOutlinedSize16Glyph,
    'ShareWebOutlinedSize16'
);
export const FlagOutlinedSize16 = /* #__PURE__*/ hoc<'FlagOutlinedSize16'>(
    FlagOutlinedSize16Glyph,
    'FlagOutlinedSize16'
);
export const SendIosFilledSize16 = /* #__PURE__*/ hoc<'SendIosFilledSize16'>(
    SendIosFilledSize16Glyph,
    'SendIosFilledSize16'
);
export const ChevronLeftSquareOutlinedSize24 = /* #__PURE__*/ hoc<'ChevronLeftSquareOutlinedSize24'>(
    ChevronLeftSquareOutlinedSize24Glyph,
    'ChevronLeftSquareOutlinedSize24'
);
export const BoxOutlinedSize24 = /* #__PURE__*/ hoc<'BoxOutlinedSize24'>(BoxOutlinedSize24Glyph, 'BoxOutlinedSize24');
export const RotateLeftOultinedSize24 = /* #__PURE__*/ hoc<'RotateLeftOultinedSize24'>(
    RotateLeftOultinedSize24Glyph,
    'RotateLeftOultinedSize24'
);
export const PlusCircleOutlinedSize24 = /* #__PURE__*/ hoc<'PlusCircleOutlinedSize24'>(
    PlusCircleOutlinedSize24Glyph,
    'PlusCircleOutlinedSize24'
);
export const BricksFilledSize24 = /* #__PURE__*/ hoc<'BricksFilledSize24'>(
    BricksFilledSize24Glyph,
    'BricksFilledSize24'
);
export const HomeOutlinedSize24 = /* #__PURE__*/ hoc<'HomeOutlinedSize24'>(
    HomeOutlinedSize24Glyph,
    'HomeOutlinedSize24'
);
export const BoxOutlinedSize16 = /* #__PURE__*/ hoc<'BoxOutlinedSize16'>(BoxOutlinedSize16Glyph, 'BoxOutlinedSize16');
export const BusTaxiOutlinedSize16 = /* #__PURE__*/ hoc<'BusTaxiOutlinedSize16'>(
    BusTaxiOutlinedSize16Glyph,
    'BusTaxiOutlinedSize16'
);
export const LightbulbOnFilledSize24 = /* #__PURE__*/ hoc<'LightbulbOnFilledSize24'>(
    LightbulbOnFilledSize24Glyph,
    'LightbulbOnFilledSize24'
);
export const HeartOutlinedSize16 = /* #__PURE__*/ hoc<'HeartOutlinedSize16'>(
    HeartOutlinedSize16Glyph,
    'HeartOutlinedSize16'
);
export const EyeCrossedOutlinedSize16 = /* #__PURE__*/ hoc<'EyeCrossedOutlinedSize16'>(
    EyeCrossedOutlinedSize16Glyph,
    'EyeCrossedOutlinedSize16'
);
export const BulletOutlinedSize16 = /* #__PURE__*/ hoc<'BulletOutlinedSize16'>(
    BulletOutlinedSize16Glyph,
    'BulletOutlinedSize16'
);
export const AstrostarOutlinedSize24 = /* #__PURE__*/ hoc<'AstrostarOutlinedSize24'>(
    AstrostarOutlinedSize24Glyph,
    'AstrostarOutlinedSize24'
);
export const StarHalfFilledSize16 = /* #__PURE__*/ hoc<'StarHalfFilledSize16'>(
    StarHalfFilledSize16Glyph,
    'StarHalfFilledSize16'
);
export const TreeOutlinedSize16 = /* #__PURE__*/ hoc<'TreeOutlinedSize16'>(
    TreeOutlinedSize16Glyph,
    'TreeOutlinedSize16'
);
export const PlusBoldOutlinedSize24 = /* #__PURE__*/ hoc<'PlusBoldOutlinedSize24'>(
    PlusBoldOutlinedSize24Glyph,
    'PlusBoldOutlinedSize24'
);
export const BulletOutlinedSize24 = /* #__PURE__*/ hoc<'BulletOutlinedSize24'>(
    BulletOutlinedSize24Glyph,
    'BulletOutlinedSize24'
);
export const FolderArrowRightFilledSize16 = /* #__PURE__*/ hoc<'FolderArrowRightFilledSize16'>(
    FolderArrowRightFilledSize16Glyph,
    'FolderArrowRightFilledSize16'
);
export const ChevronLeftSquareOutlinedSize16 = /* #__PURE__*/ hoc<'ChevronLeftSquareOutlinedSize16'>(
    ChevronLeftSquareOutlinedSize16Glyph,
    'ChevronLeftSquareOutlinedSize16'
);
export const TrolleyOutlinedSize16 = /* #__PURE__*/ hoc<'TrolleyOutlinedSize16'>(
    TrolleyOutlinedSize16Glyph,
    'TrolleyOutlinedSize16'
);
export const DotFilledSize16 = /* #__PURE__*/ hoc<'DotFilledSize16'>(DotFilledSize16Glyph, 'DotFilledSize16');
export const PlusBoldFilledSize24 = /* #__PURE__*/ hoc<'PlusBoldFilledSize24'>(
    PlusBoldFilledSize24Glyph,
    'PlusBoldFilledSize24'
);
export const CheckCircleOutlinedSize12 = /* #__PURE__*/ hoc<'CheckCircleOutlinedSize12'>(
    CheckCircleOutlinedSize12Glyph,
    'CheckCircleOutlinedSize12'
);
export const LineArrowRightOutlinedSize24 = /* #__PURE__*/ hoc<'LineArrowRightOutlinedSize24'>(
    LineArrowRightOutlinedSize24Glyph,
    'LineArrowRightOutlinedSize24'
);
export const VerifiedBadgeOutlinedSize24 = /* #__PURE__*/ hoc<'VerifiedBadgeOutlinedSize24'>(
    VerifiedBadgeOutlinedSize24Glyph,
    'VerifiedBadgeOutlinedSize24'
);
export const DashedSquareInOutlinedSize24 = /* #__PURE__*/ hoc<'DashedSquareInOutlinedSize24'>(
    DashedSquareInOutlinedSize24Glyph,
    'DashedSquareInOutlinedSize24'
);
export const ImageHyperstarOutlinedSize16 = /* #__PURE__*/ hoc<'ImageHyperstarOutlinedSize16'>(
    ImageHyperstarOutlinedSize16Glyph,
    'ImageHyperstarOutlinedSize16'
);
export const CheckCircleOutlinedSize16 = /* #__PURE__*/ hoc<'CheckCircleOutlinedSize16'>(
    CheckCircleOutlinedSize16Glyph,
    'CheckCircleOutlinedSize16'
);
export const BarsOutlinedSize16 = /* #__PURE__*/ hoc<'BarsOutlinedSize16'>(
    BarsOutlinedSize16Glyph,
    'BarsOutlinedSize16'
);
export const ArrowDiagonalLeftDownOutlinedSize16 = /* #__PURE__*/ hoc<'ArrowDiagonalLeftDownOutlinedSize16'>(
    ArrowDiagonalLeftDownOutlinedSize16Glyph,
    'ArrowDiagonalLeftDownOutlinedSize16'
);
export const PlusBoldFilledSize16 = /* #__PURE__*/ hoc<'PlusBoldFilledSize16'>(
    PlusBoldFilledSize16Glyph,
    'PlusBoldFilledSize16'
);
export const ImageHyperstarOutlinedSize24 = /* #__PURE__*/ hoc<'ImageHyperstarOutlinedSize24'>(
    ImageHyperstarOutlinedSize24Glyph,
    'ImageHyperstarOutlinedSize24'
);
export const EllipsisHorizontalOutlinedSize24 = /* #__PURE__*/ hoc<'EllipsisHorizontalOutlinedSize24'>(
    EllipsisHorizontalOutlinedSize24Glyph,
    'EllipsisHorizontalOutlinedSize24'
);
export const SendIosOutlinedSize32 = /* #__PURE__*/ hoc<'SendIosOutlinedSize32'>(
    SendIosOutlinedSize32Glyph,
    'SendIosOutlinedSize32'
);
export const SendIosOutlinedSize16 = /* #__PURE__*/ hoc<'SendIosOutlinedSize16'>(
    SendIosOutlinedSize16Glyph,
    'SendIosOutlinedSize16'
);
export const ArrowPathOutlinedSize16 = /* #__PURE__*/ hoc<'ArrowPathOutlinedSize16'>(
    ArrowPathOutlinedSize16Glyph,
    'ArrowPathOutlinedSize16'
);
export const FolderFilledSize16 = /* #__PURE__*/ hoc<'FolderFilledSize16'>(
    FolderFilledSize16Glyph,
    'FolderFilledSize16'
);
export const MagnifierOutlinedSize24 = /* #__PURE__*/ hoc<'MagnifierOutlinedSize24'>(
    MagnifierOutlinedSize24Glyph,
    'MagnifierOutlinedSize24'
);
export const LocationOutlinedSize24 = /* #__PURE__*/ hoc<'LocationOutlinedSize24'>(
    LocationOutlinedSize24Glyph,
    'LocationOutlinedSize24'
);
export const BackwardOutlinedSize16 = /* #__PURE__*/ hoc<'BackwardOutlinedSize16'>(
    BackwardOutlinedSize16Glyph,
    'BackwardOutlinedSize16'
);
export const BanFilledSize24 = /* #__PURE__*/ hoc<'BanFilledSize24'>(BanFilledSize24Glyph, 'BanFilledSize24');
export const LocationOutlinedSize32 = /* #__PURE__*/ hoc<'LocationOutlinedSize32'>(
    LocationOutlinedSize32Glyph,
    'LocationOutlinedSize32'
);
export const CardLinesEyeFilledSize24 = /* #__PURE__*/ hoc<'CardLinesEyeFilledSize24'>(
    CardLinesEyeFilledSize24Glyph,
    'CardLinesEyeFilledSize24'
);
export const ChevronRightSquareFilledSize24 = /* #__PURE__*/ hoc<'ChevronRightSquareFilledSize24'>(
    ChevronRightSquareFilledSize24Glyph,
    'ChevronRightSquareFilledSize24'
);
export const DotFilledSize24 = /* #__PURE__*/ hoc<'DotFilledSize24'>(DotFilledSize24Glyph, 'DotFilledSize24');
export const ArrowsDiagonalInOutlinedSize16 = /* #__PURE__*/ hoc<'ArrowsDiagonalInOutlinedSize16'>(
    ArrowsDiagonalInOutlinedSize16Glyph,
    'ArrowsDiagonalInOutlinedSize16'
);
export const CheckCircleFilledSize24 = /* #__PURE__*/ hoc<'CheckCircleFilledSize24'>(
    CheckCircleFilledSize24Glyph,
    'CheckCircleFilledSize24'
);
export const ChartBarOutlinedSize24 = /* #__PURE__*/ hoc<'ChartBarOutlinedSize24'>(
    ChartBarOutlinedSize24Glyph,
    'ChartBarOutlinedSize24'
);
export const BicycleOutlinedSize16 = /* #__PURE__*/ hoc<'BicycleOutlinedSize16'>(
    BicycleOutlinedSize16Glyph,
    'BicycleOutlinedSize16'
);
export const ChevronUpDownOutlinedSize12 = /* #__PURE__*/ hoc<'ChevronUpDownOutlinedSize12'>(
    ChevronUpDownOutlinedSize12Glyph,
    'ChevronUpDownOutlinedSize12'
);
export const CheckCircleFilledSize12 = /* #__PURE__*/ hoc<'CheckCircleFilledSize12'>(
    CheckCircleFilledSize12Glyph,
    'CheckCircleFilledSize12'
);
export const LocationFilledSize24 = /* #__PURE__*/ hoc<'LocationFilledSize24'>(
    LocationFilledSize24Glyph,
    'LocationFilledSize24'
);
export const InfoCircleOutlinedSize24 = /* #__PURE__*/ hoc<'InfoCircleOutlinedSize24'>(
    InfoCircleOutlinedSize24Glyph,
    'InfoCircleOutlinedSize24'
);
export const UserSinglePlusFilledSize16 = /* #__PURE__*/ hoc<'UserSinglePlusFilledSize16'>(
    UserSinglePlusFilledSize16Glyph,
    'UserSinglePlusFilledSize16'
);
export const UserCircleOutlinedSize24 = /* #__PURE__*/ hoc<'UserCircleOutlinedSize24'>(
    UserCircleOutlinedSize24Glyph,
    'UserCircleOutlinedSize24'
);
export const CheckCircleOutlinedSize24 = /* #__PURE__*/ hoc<'CheckCircleOutlinedSize24'>(
    CheckCircleOutlinedSize24Glyph,
    'CheckCircleOutlinedSize24'
);
export const EllipsisHorizontalOutlinedSize16 = /* #__PURE__*/ hoc<'EllipsisHorizontalOutlinedSize16'>(
    EllipsisHorizontalOutlinedSize16Glyph,
    'EllipsisHorizontalOutlinedSize16'
);
export const EllipsisVerticalOutlinedSize16 = /* #__PURE__*/ hoc<'EllipsisVerticalOutlinedSize16'>(
    EllipsisVerticalOutlinedSize16Glyph,
    'EllipsisVerticalOutlinedSize16'
);
export const CardLinesEyeFilledSize16 = /* #__PURE__*/ hoc<'CardLinesEyeFilledSize16'>(
    CardLinesEyeFilledSize16Glyph,
    'CardLinesEyeFilledSize16'
);
export const PrinterFilledSize16 = /* #__PURE__*/ hoc<'PrinterFilledSize16'>(
    PrinterFilledSize16Glyph,
    'PrinterFilledSize16'
);
export const ShareIosOutlinedSize24 = /* #__PURE__*/ hoc<'ShareIosOutlinedSize24'>(
    ShareIosOutlinedSize24Glyph,
    'ShareIosOutlinedSize24'
);
export const FolderHyperstarOutlinedSize24 = /* #__PURE__*/ hoc<'FolderHyperstarOutlinedSize24'>(
    FolderHyperstarOutlinedSize24Glyph,
    'FolderHyperstarOutlinedSize24'
);
export const BanOutlinedSize24 = /* #__PURE__*/ hoc<'BanOutlinedSize24'>(BanOutlinedSize24Glyph, 'BanOutlinedSize24');
export const ArrowsDiagonalInOutlinedSize24 = /* #__PURE__*/ hoc<'ArrowsDiagonalInOutlinedSize24'>(
    ArrowsDiagonalInOutlinedSize24Glyph,
    'ArrowsDiagonalInOutlinedSize24'
);
export const ArrowDiagonalLeftDownOutlinedSize24 = /* #__PURE__*/ hoc<'ArrowDiagonalLeftDownOutlinedSize24'>(
    ArrowDiagonalLeftDownOutlinedSize24Glyph,
    'ArrowDiagonalLeftDownOutlinedSize24'
);
export const MagnifierOutlinedSize16 = /* #__PURE__*/ hoc<'MagnifierOutlinedSize16'>(
    MagnifierOutlinedSize16Glyph,
    'MagnifierOutlinedSize16'
);
export const EllipsisVerticalOutlinedSize24 = /* #__PURE__*/ hoc<'EllipsisVerticalOutlinedSize24'>(
    EllipsisVerticalOutlinedSize24Glyph,
    'EllipsisVerticalOutlinedSize24'
);
export const MapPinOutlinedSize24 = /* #__PURE__*/ hoc<'MapPinOutlinedSize24'>(
    MapPinOutlinedSize24Glyph,
    'MapPinOutlinedSize24'
);
export const InfoCircleOutlinedSize16 = /* #__PURE__*/ hoc<'InfoCircleOutlinedSize16'>(
    InfoCircleOutlinedSize16Glyph,
    'InfoCircleOutlinedSize16'
);
export const SendIosOutlinedSize24 = /* #__PURE__*/ hoc<'SendIosOutlinedSize24'>(
    SendIosOutlinedSize24Glyph,
    'SendIosOutlinedSize24'
);
export const MapPinFilledSize32 = /* #__PURE__*/ hoc<'MapPinFilledSize32'>(
    MapPinFilledSize32Glyph,
    'MapPinFilledSize32'
);
export const BankFilledSize16 = /* #__PURE__*/ hoc<'BankFilledSize16'>(BankFilledSize16Glyph, 'BankFilledSize16');
export const ChevronUpDownOutlinedSize16 = /* #__PURE__*/ hoc<'ChevronUpDownOutlinedSize16'>(
    ChevronUpDownOutlinedSize16Glyph,
    'ChevronUpDownOutlinedSize16'
);
export const FolderFilledSize24 = /* #__PURE__*/ hoc<'FolderFilledSize24'>(
    FolderFilledSize24Glyph,
    'FolderFilledSize24'
);
export const MinusCircleFilledSize24 = /* #__PURE__*/ hoc<'MinusCircleFilledSize24'>(
    MinusCircleFilledSize24Glyph,
    'MinusCircleFilledSize24'
);
export const MapPinOutlinedSize16 = /* #__PURE__*/ hoc<'MapPinOutlinedSize16'>(
    MapPinOutlinedSize16Glyph,
    'MapPinOutlinedSize16'
);
export const RadiusOutlinedSize16 = /* #__PURE__*/ hoc<'RadiusOutlinedSize16'>(
    RadiusOutlinedSize16Glyph,
    'RadiusOutlinedSize16'
);
export const MapPinFilledSize16 = /* #__PURE__*/ hoc<'MapPinFilledSize16'>(
    MapPinFilledSize16Glyph,
    'MapPinFilledSize16'
);
export const QuestionCircleFilledSize24 = /* #__PURE__*/ hoc<'QuestionCircleFilledSize24'>(
    QuestionCircleFilledSize24Glyph,
    'QuestionCircleFilledSize24'
);
export const DashedSquareInOutlinedSize16 = /* #__PURE__*/ hoc<'DashedSquareInOutlinedSize16'>(
    DashedSquareInOutlinedSize16Glyph,
    'DashedSquareInOutlinedSize16'
);
export const CircleOutlinedSize24 = /* #__PURE__*/ hoc<'CircleOutlinedSize24'>(
    CircleOutlinedSize24Glyph,
    'CircleOutlinedSize24'
);
export const BanOutlinedSize16 = /* #__PURE__*/ hoc<'BanOutlinedSize16'>(BanOutlinedSize16Glyph, 'BanOutlinedSize16');
export const VerifiedBadgeOutlinedSize16 = /* #__PURE__*/ hoc<'VerifiedBadgeOutlinedSize16'>(
    VerifiedBadgeOutlinedSize16Glyph,
    'VerifiedBadgeOutlinedSize16'
);
export const AdjustmentsFilledSize16 = /* #__PURE__*/ hoc<'AdjustmentsFilledSize16'>(
    AdjustmentsFilledSize16Glyph,
    'AdjustmentsFilledSize16'
);
export const CheckCircleFilledSize16 = /* #__PURE__*/ hoc<'CheckCircleFilledSize16'>(
    CheckCircleFilledSize16Glyph,
    'CheckCircleFilledSize16'
);
export const ChevronRightSquareFilledSize16 = /* #__PURE__*/ hoc<'ChevronRightSquareFilledSize16'>(
    ChevronRightSquareFilledSize16Glyph,
    'ChevronRightSquareFilledSize16'
);
export const BanFilledSize16 = /* #__PURE__*/ hoc<'BanFilledSize16'>(BanFilledSize16Glyph, 'BanFilledSize16');
export const CrossOutlinedSize16 = /* #__PURE__*/ hoc<'CrossOutlinedSize16'>(
    CrossOutlinedSize16Glyph,
    'CrossOutlinedSize16'
);
export const CardLinesStackedCrossedOutlinedSize24 = /* #__PURE__*/ hoc<'CardLinesStackedCrossedOutlinedSize24'>(
    CardLinesStackedCrossedOutlinedSize24Glyph,
    'CardLinesStackedCrossedOutlinedSize24'
);
export const ArrowPathOutlinedSize24 = /* #__PURE__*/ hoc<'ArrowPathOutlinedSize24'>(
    ArrowPathOutlinedSize24Glyph,
    'ArrowPathOutlinedSize24'
);
export const RadiusFilledSize16 = /* #__PURE__*/ hoc<'RadiusFilledSize16'>(
    RadiusFilledSize16Glyph,
    'RadiusFilledSize16'
);
export const QuestionCircleOutlinedSize24 = /* #__PURE__*/ hoc<'QuestionCircleOutlinedSize24'>(
    QuestionCircleOutlinedSize24Glyph,
    'QuestionCircleOutlinedSize24'
);
export const MapPinOutlinedSize32 = /* #__PURE__*/ hoc<'MapPinOutlinedSize32'>(
    MapPinOutlinedSize32Glyph,
    'MapPinOutlinedSize32'
);
export const VideocameraHyperstarOutlinedSize24 = /* #__PURE__*/ hoc<'VideocameraHyperstarOutlinedSize24'>(
    VideocameraHyperstarOutlinedSize24Glyph,
    'VideocameraHyperstarOutlinedSize24'
);
export const MagnifierFilledHeartOutlinedSize24 = /* #__PURE__*/ hoc<'MagnifierFilledHeartOutlinedSize24'>(
    MagnifierFilledHeartOutlinedSize24Glyph,
    'MagnifierFilledHeartOutlinedSize24'
);
export const QuestionCircleFilledSize16 = /* #__PURE__*/ hoc<'QuestionCircleFilledSize16'>(
    QuestionCircleFilledSize16Glyph,
    'QuestionCircleFilledSize16'
);
export const MagnifierFilledHyperstarFilledSize24 = /* #__PURE__*/ hoc<'MagnifierFilledHyperstarFilledSize24'>(
    MagnifierFilledHyperstarFilledSize24Glyph,
    'MagnifierFilledHyperstarFilledSize24'
);
export const MagnifierFilledHeartOutlinedSize16 = /* #__PURE__*/ hoc<'MagnifierFilledHeartOutlinedSize16'>(
    MagnifierFilledHeartOutlinedSize16Glyph,
    'MagnifierFilledHeartOutlinedSize16'
);
export const ChevronUpDownOutlinedSize24 = /* #__PURE__*/ hoc<'ChevronUpDownOutlinedSize24'>(
    ChevronUpDownOutlinedSize24Glyph,
    'ChevronUpDownOutlinedSize24'
);
export const LineArrowRightOutlinedSize16 = /* #__PURE__*/ hoc<'LineArrowRightOutlinedSize16'>(
    LineArrowRightOutlinedSize16Glyph,
    'LineArrowRightOutlinedSize16'
);
export const ShareIosOutlinedSize16 = /* #__PURE__*/ hoc<'ShareIosOutlinedSize16'>(
    ShareIosOutlinedSize16Glyph,
    'ShareIosOutlinedSize16'
);
export const BankFilledSize24 = /* #__PURE__*/ hoc<'BankFilledSize24'>(BankFilledSize24Glyph, 'BankFilledSize24');
export const MinusCircleFilledSize16 = /* #__PURE__*/ hoc<'MinusCircleFilledSize16'>(
    MinusCircleFilledSize16Glyph,
    'MinusCircleFilledSize16'
);
export const VideocameraHyperstarOutlinedSize16 = /* #__PURE__*/ hoc<'VideocameraHyperstarOutlinedSize16'>(
    VideocameraHyperstarOutlinedSize16Glyph,
    'VideocameraHyperstarOutlinedSize16'
);
export const UserCircleOutlinedSize32 = /* #__PURE__*/ hoc<'UserCircleOutlinedSize32'>(
    UserCircleOutlinedSize32Glyph,
    'UserCircleOutlinedSize32'
);
export const ExclamationCircleOutlinedSize16 = /* #__PURE__*/ hoc<'ExclamationCircleOutlinedSize16'>(
    ExclamationCircleOutlinedSize16Glyph,
    'ExclamationCircleOutlinedSize16'
);
export const ChevronDownOutlinedSize24 = /* #__PURE__*/ hoc<'ChevronDownOutlinedSize24'>(
    ChevronDownOutlinedSize24Glyph,
    'ChevronDownOutlinedSize24'
);
export const ArchiveboxOutlinedSize16 = /* #__PURE__*/ hoc<'ArchiveboxOutlinedSize16'>(
    ArchiveboxOutlinedSize16Glyph,
    'ArchiveboxOutlinedSize16'
);
export const StarOutlinedSize16 = /* #__PURE__*/ hoc<'StarOutlinedSize16'>(
    StarOutlinedSize16Glyph,
    'StarOutlinedSize16'
);
export const BubbleRoundHyperstarOutlinedSize16 = /* #__PURE__*/ hoc<'BubbleRoundHyperstarOutlinedSize16'>(
    BubbleRoundHyperstarOutlinedSize16Glyph,
    'BubbleRoundHyperstarOutlinedSize16'
);
export const ChevronWide3OutlinedSize24 = /* #__PURE__*/ hoc<'ChevronWide3OutlinedSize24'>(
    ChevronWide3OutlinedSize24Glyph,
    'ChevronWide3OutlinedSize24'
);
export const SendAndroidOutlinedSize24 = /* #__PURE__*/ hoc<'SendAndroidOutlinedSize24'>(
    SendAndroidOutlinedSize24Glyph,
    'SendAndroidOutlinedSize24'
);
export const PlusCircleFilledSize24 = /* #__PURE__*/ hoc<'PlusCircleFilledSize24'>(
    PlusCircleFilledSize24Glyph,
    'PlusCircleFilledSize24'
);
export const CrossCircleFilledSize24 = /* #__PURE__*/ hoc<'CrossCircleFilledSize24'>(
    CrossCircleFilledSize24Glyph,
    'CrossCircleFilledSize24'
);
export const StarOutlinedSize32 = /* #__PURE__*/ hoc<'StarOutlinedSize32'>(
    StarOutlinedSize32Glyph,
    'StarOutlinedSize32'
);
export const CardLinesStackedFilledSize16 = /* #__PURE__*/ hoc<'CardLinesStackedFilledSize16'>(
    CardLinesStackedFilledSize16Glyph,
    'CardLinesStackedFilledSize16'
);
export const MapOutlinedSize24 = /* #__PURE__*/ hoc<'MapOutlinedSize24'>(MapOutlinedSize24Glyph, 'MapOutlinedSize24');
export const UserFilledSize16 = /* #__PURE__*/ hoc<'UserFilledSize16'>(UserFilledSize16Glyph, 'UserFilledSize16');
export const CardLinesStackedPlusOutlinedSize16 = /* #__PURE__*/ hoc<'CardLinesStackedPlusOutlinedSize16'>(
    CardLinesStackedPlusOutlinedSize16Glyph,
    'CardLinesStackedPlusOutlinedSize16'
);
export const MagnifierOutlinedHyperstarFilledSize16 = /* #__PURE__*/ hoc<'MagnifierOutlinedHyperstarFilledSize16'>(
    MagnifierOutlinedHyperstarFilledSize16Glyph,
    'MagnifierOutlinedHyperstarFilledSize16'
);
export const VideocameraHyperstarFilledSize16 = /* #__PURE__*/ hoc<'VideocameraHyperstarFilledSize16'>(
    VideocameraHyperstarFilledSize16Glyph,
    'VideocameraHyperstarFilledSize16'
);
export const ArrowDownLineOutlinedSize16 = /* #__PURE__*/ hoc<'ArrowDownLineOutlinedSize16'>(
    ArrowDownLineOutlinedSize16Glyph,
    'ArrowDownLineOutlinedSize16'
);
export const MinusOutlinedSize24 = /* #__PURE__*/ hoc<'MinusOutlinedSize24'>(
    MinusOutlinedSize24Glyph,
    'MinusOutlinedSize24'
);
export const GamepadOutlinedSize24 = /* #__PURE__*/ hoc<'GamepadOutlinedSize24'>(
    GamepadOutlinedSize24Glyph,
    'GamepadOutlinedSize24'
);
export const CardLinesStackedCrossOutlinedSize24 = /* #__PURE__*/ hoc<'CardLinesStackedCrossOutlinedSize24'>(
    CardLinesStackedCrossOutlinedSize24Glyph,
    'CardLinesStackedCrossOutlinedSize24'
);
export const ImageStackOutlinedSize16 = /* #__PURE__*/ hoc<'ImageStackOutlinedSize16'>(
    ImageStackOutlinedSize16Glyph,
    'ImageStackOutlinedSize16'
);
export const ChevronWide3OutlinedSize16 = /* #__PURE__*/ hoc<'ChevronWide3OutlinedSize16'>(
    ChevronWide3OutlinedSize16Glyph,
    'ChevronWide3OutlinedSize16'
);
export const MagnifierOutlinedHeartFilledSize24 = /* #__PURE__*/ hoc<'MagnifierOutlinedHeartFilledSize24'>(
    MagnifierOutlinedHeartFilledSize24Glyph,
    'MagnifierOutlinedHeartFilledSize24'
);
export const DrawerFilledSize16 = /* #__PURE__*/ hoc<'DrawerFilledSize16'>(
    DrawerFilledSize16Glyph,
    'DrawerFilledSize16'
);
export const MagnifierMinusOutlinedSize24 = /* #__PURE__*/ hoc<'MagnifierMinusOutlinedSize24'>(
    MagnifierMinusOutlinedSize24Glyph,
    'MagnifierMinusOutlinedSize24'
);
export const MagnifierMinusOutlinedSize16 = /* #__PURE__*/ hoc<'MagnifierMinusOutlinedSize16'>(
    MagnifierMinusOutlinedSize16Glyph,
    'MagnifierMinusOutlinedSize16'
);
export const ArrowPathClockwiseOutlinedSize24 = /* #__PURE__*/ hoc<'ArrowPathClockwiseOutlinedSize24'>(
    ArrowPathClockwiseOutlinedSize24Glyph,
    'ArrowPathClockwiseOutlinedSize24'
);
export const InfoCircleFilledSize16 = /* #__PURE__*/ hoc<'InfoCircleFilledSize16'>(
    InfoCircleFilledSize16Glyph,
    'InfoCircleFilledSize16'
);
export const ChevronWideOutlinedSize24 = /* #__PURE__*/ hoc<'ChevronWideOutlinedSize24'>(
    ChevronWideOutlinedSize24Glyph,
    'ChevronWideOutlinedSize24'
);
export const ShareWebFilledSize24 = /* #__PURE__*/ hoc<'ShareWebFilledSize24'>(
    ShareWebFilledSize24Glyph,
    'ShareWebFilledSize24'
);
export const UserFilledSize24 = /* #__PURE__*/ hoc<'UserFilledSize24'>(UserFilledSize24Glyph, 'UserFilledSize24');
export const EyeFilledSize16 = /* #__PURE__*/ hoc<'EyeFilledSize16'>(EyeFilledSize16Glyph, 'EyeFilledSize16');
export const MinusOutlinedSize16 = /* #__PURE__*/ hoc<'MinusOutlinedSize16'>(
    MinusOutlinedSize16Glyph,
    'MinusOutlinedSize16'
);
export const GamepadOutlinedSize16 = /* #__PURE__*/ hoc<'GamepadOutlinedSize16'>(
    GamepadOutlinedSize16Glyph,
    'GamepadOutlinedSize16'
);
export const SendWebFilledSize32 = /* #__PURE__*/ hoc<'SendWebFilledSize32'>(
    SendWebFilledSize32Glyph,
    'SendWebFilledSize32'
);
export const InfoCircleFilledSize24 = /* #__PURE__*/ hoc<'InfoCircleFilledSize24'>(
    InfoCircleFilledSize24Glyph,
    'InfoCircleFilledSize24'
);
export const ChartLineOutlinedSize16 = /* #__PURE__*/ hoc<'ChartLineOutlinedSize16'>(
    ChartLineOutlinedSize16Glyph,
    'ChartLineOutlinedSize16'
);
export const ArrowPathClockwiseOutlinedSize16 = /* #__PURE__*/ hoc<'ArrowPathClockwiseOutlinedSize16'>(
    ArrowPathClockwiseOutlinedSize16Glyph,
    'ArrowPathClockwiseOutlinedSize16'
);
export const ForwardOutlinedSize24 = /* #__PURE__*/ hoc<'ForwardOutlinedSize24'>(
    ForwardOutlinedSize24Glyph,
    'ForwardOutlinedSize24'
);
export const ImageStackOutlinedSize32 = /* #__PURE__*/ hoc<'ImageStackOutlinedSize32'>(
    ImageStackOutlinedSize32Glyph,
    'ImageStackOutlinedSize32'
);
export const FolderArrowRightOutlinedSize24 = /* #__PURE__*/ hoc<'FolderArrowRightOutlinedSize24'>(
    FolderArrowRightOutlinedSize24Glyph,
    'FolderArrowRightOutlinedSize24'
);
export const SendAndroidOutlinedSize16 = /* #__PURE__*/ hoc<'SendAndroidOutlinedSize16'>(
    SendAndroidOutlinedSize16Glyph,
    'SendAndroidOutlinedSize16'
);
export const ExclamationCircleFilledSize16 = /* #__PURE__*/ hoc<'ExclamationCircleFilledSize16'>(
    ExclamationCircleFilledSize16Glyph,
    'ExclamationCircleFilledSize16'
);
export const ShareWebFilledSize16 = /* #__PURE__*/ hoc<'ShareWebFilledSize16'>(
    ShareWebFilledSize16Glyph,
    'ShareWebFilledSize16'
);
export const DrawerOutlinedSize16 = /* #__PURE__*/ hoc<'DrawerOutlinedSize16'>(
    DrawerOutlinedSize16Glyph,
    'DrawerOutlinedSize16'
);
export const MagnifierPlusOutlinedSize16 = /* #__PURE__*/ hoc<'MagnifierPlusOutlinedSize16'>(
    MagnifierPlusOutlinedSize16Glyph,
    'MagnifierPlusOutlinedSize16'
);
export const BulletFilledSize16 = /* #__PURE__*/ hoc<'BulletFilledSize16'>(
    BulletFilledSize16Glyph,
    'BulletFilledSize16'
);
export const StarOutlinedSize24 = /* #__PURE__*/ hoc<'StarOutlinedSize24'>(
    StarOutlinedSize24Glyph,
    'StarOutlinedSize24'
);
export const ChartLineOutlinedSize24 = /* #__PURE__*/ hoc<'ChartLineOutlinedSize24'>(
    ChartLineOutlinedSize24Glyph,
    'ChartLineOutlinedSize24'
);
export const ArrowDownOutlinedSize16 = /* #__PURE__*/ hoc<'ArrowDownOutlinedSize16'>(
    ArrowDownOutlinedSize16Glyph,
    'ArrowDownOutlinedSize16'
);
export const ShareAndroidOutlinedSize24 = /* #__PURE__*/ hoc<'ShareAndroidOutlinedSize24'>(
    ShareAndroidOutlinedSize24Glyph,
    'ShareAndroidOutlinedSize24'
);
export const MagnifierOutlinedHeartFilledSize16 = /* #__PURE__*/ hoc<'MagnifierOutlinedHeartFilledSize16'>(
    MagnifierOutlinedHeartFilledSize16Glyph,
    'MagnifierOutlinedHeartFilledSize16'
);
export const BubbleRoundHyperstarOutlinedSize24 = /* #__PURE__*/ hoc<'BubbleRoundHyperstarOutlinedSize24'>(
    BubbleRoundHyperstarOutlinedSize24Glyph,
    'BubbleRoundHyperstarOutlinedSize24'
);
export const SuperstarOutlinedSize16 = /* #__PURE__*/ hoc<'SuperstarOutlinedSize16'>(
    SuperstarOutlinedSize16Glyph,
    'SuperstarOutlinedSize16'
);
export const MagnifierOutlinedHyperstarFilledSize24 = /* #__PURE__*/ hoc<'MagnifierOutlinedHyperstarFilledSize24'>(
    MagnifierOutlinedHyperstarFilledSize24Glyph,
    'MagnifierOutlinedHyperstarFilledSize24'
);
export const StarCircleOutlinedSize16 = /* #__PURE__*/ hoc<'StarCircleOutlinedSize16'>(
    StarCircleOutlinedSize16Glyph,
    'StarCircleOutlinedSize16'
);
export const PenOutlinedSize12 = /* #__PURE__*/ hoc<'PenOutlinedSize12'>(PenOutlinedSize12Glyph, 'PenOutlinedSize12');
export const DrawerOutlinedSize24 = /* #__PURE__*/ hoc<'DrawerOutlinedSize24'>(
    DrawerOutlinedSize24Glyph,
    'DrawerOutlinedSize24'
);
export const DrawerFilledSize24 = /* #__PURE__*/ hoc<'DrawerFilledSize24'>(
    DrawerFilledSize24Glyph,
    'DrawerFilledSize24'
);
export const SuperstarOutlinedSize24 = /* #__PURE__*/ hoc<'SuperstarOutlinedSize24'>(
    SuperstarOutlinedSize24Glyph,
    'SuperstarOutlinedSize24'
);
export const ForwardOutlinedSize16 = /* #__PURE__*/ hoc<'ForwardOutlinedSize16'>(
    ForwardOutlinedSize16Glyph,
    'ForwardOutlinedSize16'
);
export const SendAndroidOutlinedSize32 = /* #__PURE__*/ hoc<'SendAndroidOutlinedSize32'>(
    SendAndroidOutlinedSize32Glyph,
    'SendAndroidOutlinedSize32'
);
export const MapOutlinedSize32 = /* #__PURE__*/ hoc<'MapOutlinedSize32'>(MapOutlinedSize32Glyph, 'MapOutlinedSize32');
export const PenOutlinedSize24 = /* #__PURE__*/ hoc<'PenOutlinedSize24'>(PenOutlinedSize24Glyph, 'PenOutlinedSize24');
export const ArrowUpDownOutlinedSize24 = /* #__PURE__*/ hoc<'ArrowUpDownOutlinedSize24'>(
    ArrowUpDownOutlinedSize24Glyph,
    'ArrowUpDownOutlinedSize24'
);
export const FolderArrowRightOutlinedSize16 = /* #__PURE__*/ hoc<'FolderArrowRightOutlinedSize16'>(
    FolderArrowRightOutlinedSize16Glyph,
    'FolderArrowRightOutlinedSize16'
);
export const ChartLineOutlinedSize32 = /* #__PURE__*/ hoc<'ChartLineOutlinedSize32'>(
    ChartLineOutlinedSize32Glyph,
    'ChartLineOutlinedSize32'
);
export const StarCircleOutlinedSize32 = /* #__PURE__*/ hoc<'StarCircleOutlinedSize32'>(
    StarCircleOutlinedSize32Glyph,
    'StarCircleOutlinedSize32'
);
export const ArrowUpDownOutlinedSize16 = /* #__PURE__*/ hoc<'ArrowUpDownOutlinedSize16'>(
    ArrowUpDownOutlinedSize16Glyph,
    'ArrowUpDownOutlinedSize16'
);
export const FolderHyperstarFilledSize16 = /* #__PURE__*/ hoc<'FolderHyperstarFilledSize16'>(
    FolderHyperstarFilledSize16Glyph,
    'FolderHyperstarFilledSize16'
);
export const ArrowRightOutlinedSize16 = /* #__PURE__*/ hoc<'ArrowRightOutlinedSize16'>(
    ArrowRightOutlinedSize16Glyph,
    'ArrowRightOutlinedSize16'
);
export const EyeFilledSize24 = /* #__PURE__*/ hoc<'EyeFilledSize24'>(EyeFilledSize24Glyph, 'EyeFilledSize24');
export const ArchiveboxOutlinedSize24 = /* #__PURE__*/ hoc<'ArchiveboxOutlinedSize24'>(
    ArchiveboxOutlinedSize24Glyph,
    'ArchiveboxOutlinedSize24'
);
export const StarCircleOutlinedSize24 = /* #__PURE__*/ hoc<'StarCircleOutlinedSize24'>(
    StarCircleOutlinedSize24Glyph,
    'StarCircleOutlinedSize24'
);
export const ArrowDownOutlinedSize24 = /* #__PURE__*/ hoc<'ArrowDownOutlinedSize24'>(
    ArrowDownOutlinedSize24Glyph,
    'ArrowDownOutlinedSize24'
);
export const LockClosedFilledSize24 = /* #__PURE__*/ hoc<'LockClosedFilledSize24'>(
    LockClosedFilledSize24Glyph,
    'LockClosedFilledSize24'
);
export const PlusCircleFilledSize16 = /* #__PURE__*/ hoc<'PlusCircleFilledSize16'>(
    PlusCircleFilledSize16Glyph,
    'PlusCircleFilledSize16'
);
export const CardLinesStackedFilledSize24 = /* #__PURE__*/ hoc<'CardLinesStackedFilledSize24'>(
    CardLinesStackedFilledSize24Glyph,
    'CardLinesStackedFilledSize24'
);
export const SendWebFilledSize24 = /* #__PURE__*/ hoc<'SendWebFilledSize24'>(
    SendWebFilledSize24Glyph,
    'SendWebFilledSize24'
);
export const UserDoubleFilledSize16 = /* #__PURE__*/ hoc<'UserDoubleFilledSize16'>(
    UserDoubleFilledSize16Glyph,
    'UserDoubleFilledSize16'
);
export const UserDoubleFilledSize24 = /* #__PURE__*/ hoc<'UserDoubleFilledSize24'>(
    UserDoubleFilledSize24Glyph,
    'UserDoubleFilledSize24'
);
export const VideocameraHyperstarFilledSize24 = /* #__PURE__*/ hoc<'VideocameraHyperstarFilledSize24'>(
    VideocameraHyperstarFilledSize24Glyph,
    'VideocameraHyperstarFilledSize24'
);
export const ArrowDownLineOutlinedSize24 = /* #__PURE__*/ hoc<'ArrowDownLineOutlinedSize24'>(
    ArrowDownLineOutlinedSize24Glyph,
    'ArrowDownLineOutlinedSize24'
);
export const AdjustmentsOutlinedSize16 = /* #__PURE__*/ hoc<'AdjustmentsOutlinedSize16'>(
    AdjustmentsOutlinedSize16Glyph,
    'AdjustmentsOutlinedSize16'
);
export const AdjustmentsOutlinedSize24 = /* #__PURE__*/ hoc<'AdjustmentsOutlinedSize24'>(
    AdjustmentsOutlinedSize24Glyph,
    'AdjustmentsOutlinedSize24'
);
export const ExclamationCircleFilledSize24 = /* #__PURE__*/ hoc<'ExclamationCircleFilledSize24'>(
    ExclamationCircleFilledSize24Glyph,
    'ExclamationCircleFilledSize24'
);
export const CheckDoubleOutlinedSize16 = /* #__PURE__*/ hoc<'CheckDoubleOutlinedSize16'>(
    CheckDoubleOutlinedSize16Glyph,
    'CheckDoubleOutlinedSize16'
);
export const EmojiSmileOutlinedSize24 = /* #__PURE__*/ hoc<'EmojiSmileOutlinedSize24'>(
    EmojiSmileOutlinedSize24Glyph,
    'EmojiSmileOutlinedSize24'
);
export const ShareAndroidOutlinedSize16 = /* #__PURE__*/ hoc<'ShareAndroidOutlinedSize16'>(
    ShareAndroidOutlinedSize16Glyph,
    'ShareAndroidOutlinedSize16'
);
export const AstrostarFilledSize24 = /* #__PURE__*/ hoc<'AstrostarFilledSize24'>(
    AstrostarFilledSize24Glyph,
    'AstrostarFilledSize24'
);
export const ListOutlinedSize24 = /* #__PURE__*/ hoc<'ListOutlinedSize24'>(
    ListOutlinedSize24Glyph,
    'ListOutlinedSize24'
);
export const LockClosedFilledSize12 = /* #__PURE__*/ hoc<'LockClosedFilledSize12'>(
    LockClosedFilledSize12Glyph,
    'LockClosedFilledSize12'
);
export const CrossCircleFilledSize16 = /* #__PURE__*/ hoc<'CrossCircleFilledSize16'>(
    CrossCircleFilledSize16Glyph,
    'CrossCircleFilledSize16'
);
export const ChevronDownOutlinedSize12 = /* #__PURE__*/ hoc<'ChevronDownOutlinedSize12'>(
    ChevronDownOutlinedSize12Glyph,
    'ChevronDownOutlinedSize12'
);
export const DotsOutlinedSize24 = /* #__PURE__*/ hoc<'DotsOutlinedSize24'>(
    DotsOutlinedSize24Glyph,
    'DotsOutlinedSize24'
);
export const EllipsisHorizontalCircleOutlinedSize16 = /* #__PURE__*/ hoc<'EllipsisHorizontalCircleOutlinedSize16'>(
    EllipsisHorizontalCircleOutlinedSize16Glyph,
    'EllipsisHorizontalCircleOutlinedSize16'
);
export const UturnLeftOutlinedSize24 = /* #__PURE__*/ hoc<'UturnLeftOutlinedSize24'>(
    UturnLeftOutlinedSize24Glyph,
    'UturnLeftOutlinedSize24'
);
export const ArrowLeftOutlinedSize24 = /* #__PURE__*/ hoc<'ArrowLeftOutlinedSize24'>(
    ArrowLeftOutlinedSize24Glyph,
    'ArrowLeftOutlinedSize24'
);
export const RocketOutlinedSize16 = /* #__PURE__*/ hoc<'RocketOutlinedSize16'>(
    RocketOutlinedSize16Glyph,
    'RocketOutlinedSize16'
);
export const MegaphoneOutlinedSize24 = /* #__PURE__*/ hoc<'MegaphoneOutlinedSize24'>(
    MegaphoneOutlinedSize24Glyph,
    'MegaphoneOutlinedSize24'
);
export const GearFilledSize16 = /* #__PURE__*/ hoc<'GearFilledSize16'>(GearFilledSize16Glyph, 'GearFilledSize16');
export const RocketOutlinedSize24 = /* #__PURE__*/ hoc<'RocketOutlinedSize24'>(
    RocketOutlinedSize24Glyph,
    'RocketOutlinedSize24'
);
export const ArrowLeftOutlinedSize16 = /* #__PURE__*/ hoc<'ArrowLeftOutlinedSize16'>(
    ArrowLeftOutlinedSize16Glyph,
    'ArrowLeftOutlinedSize16'
);
export const ExclamationTriangleOutlinedSize24 = /* #__PURE__*/ hoc<'ExclamationTriangleOutlinedSize24'>(
    ExclamationTriangleOutlinedSize24Glyph,
    'ExclamationTriangleOutlinedSize24'
);
export const GearFilledSize24 = /* #__PURE__*/ hoc<'GearFilledSize24'>(GearFilledSize24Glyph, 'GearFilledSize24');
export const QrCodeOutlinedSize16 = /* #__PURE__*/ hoc<'QrCodeOutlinedSize16'>(
    QrCodeOutlinedSize16Glyph,
    'QrCodeOutlinedSize16'
);
export const ExclamationCircleOutlinedSize24 = /* #__PURE__*/ hoc<'ExclamationCircleOutlinedSize24'>(
    ExclamationCircleOutlinedSize24Glyph,
    'ExclamationCircleOutlinedSize24'
);
export const UturnLeftOutlinedSize16 = /* #__PURE__*/ hoc<'UturnLeftOutlinedSize16'>(
    UturnLeftOutlinedSize16Glyph,
    'UturnLeftOutlinedSize16'
);
export const DotsOutlinedSize16 = /* #__PURE__*/ hoc<'DotsOutlinedSize16'>(
    DotsOutlinedSize16Glyph,
    'DotsOutlinedSize16'
);
export const MegaphoneOutlinedSize16 = /* #__PURE__*/ hoc<'MegaphoneOutlinedSize16'>(
    MegaphoneOutlinedSize16Glyph,
    'MegaphoneOutlinedSize16'
);
export const EllipsisHorizontalCircleOutlinedSize24 = /* #__PURE__*/ hoc<'EllipsisHorizontalCircleOutlinedSize24'>(
    EllipsisHorizontalCircleOutlinedSize24Glyph,
    'EllipsisHorizontalCircleOutlinedSize24'
);
export const ExclamationTriangleOutlinedSize32 = /* #__PURE__*/ hoc<'ExclamationTriangleOutlinedSize32'>(
    ExclamationTriangleOutlinedSize32Glyph,
    'ExclamationTriangleOutlinedSize32'
);
export const QrCodeOutlinedSize24 = /* #__PURE__*/ hoc<'QrCodeOutlinedSize24'>(
    QrCodeOutlinedSize24Glyph,
    'QrCodeOutlinedSize24'
);
export const ExclamationTriangleOutlinedSize16 = /* #__PURE__*/ hoc<'ExclamationTriangleOutlinedSize16'>(
    ExclamationTriangleOutlinedSize16Glyph,
    'ExclamationTriangleOutlinedSize16'
);
